import countriesImport from './assets/countries.json';
import zipImportNO from './assets/postnummer_no.json';


const locale = {

    getDateString(locale, input) {
        let date = new Date(input);
        let day = date.getDate().toString();
        let mon = this.getMonthName(locale, date.getMonth());
        let year = date.getFullYear();
        let h = date.getHours();
        if (date.getHours() < 10) h = '0' + h;
        let m = date.getMinutes();
        if (date.getMinutes() < 10) m = '0' + m;
        if (locale.key == 'nb_NO') {
            return `${day}. ${mon} ${year} ${h}:${m}`;
        }else {
            return `${mon} ${day} ${year} ${h}:${m}`;
        }
    },

    getMonthName(locale, month) {
        switch (locale.key) {
            case 'nb_NO': return this.getMonthNameNO(month);
            case 'en_EN': return this.getMonthNameEN(month);
        }
        return 'month';
    },

    getMonthNameEN(month) {
        switch (month) {
            case 0: return 'January';
            case 1: return 'February';
            case 2: return 'March';
            case 3: return 'April';
            case 4: return 'May';
            case 5: return 'June';
            case 6: return 'July';
            case 7: return 'August';
            case 8: return 'September';
            case 9: return 'October';
            case 10: return 'November';
            case 11: return 'December';
        }
        return 'month';
    },
    getMonthNameNO(month) {
        switch (month) {
            case 0: return 'januar';
            case 1: return 'februar';
            case 2: return 'mars';
            case 3: return 'april';
            case 4: return 'mai';
            case 5: return 'juni';
            case 6: return 'juli';
            case 7: return 'august';
            case 8: return 'september';
            case 9: return 'oktober';
            case 10: return 'november';
            case 11: return 'desember';
        }
        return 'month';
    },

    getLocale(locales, key) {
        for (let i in locales) {
            if (locales[i].key == key && locales[i].enabled) {
                return locales[i];
            }
        }
        // the specified key was not found or not enabled, use first enabled language we find instead
        return locales.find(x => x.enabled) || locales[0];
    },

    loadCountries(root) {

        root.zipNumbersNO = zipImportNO;

        root.countriesJson = [];
        root.countriesCommon = [];
        for (let key in countriesImport) {
            if (key == 'NO' || key == 'SE' || key == 'FI' || key == 'DK') {
                root.countriesCommon.push({
                    key: key,
                    prefix: countriesImport[key].prefix,
                    nb_NO: countriesImport[key].nb_NO,
                    en_EN: countriesImport[key].en_EN,
                    sv_SE: countriesImport[key].sv_SE,
                    de_DE: countriesImport[key].de_DE
                });
            }
            root.countriesJson.push({
                key: key,
                prefix: countriesImport[key].prefix.replace(' ', ''),
                nb_NO: countriesImport[key].nb_NO,
                en_EN: countriesImport[key].en_EN,
                sv_SE: countriesImport[key].sv_SE,
                de_DE: countriesImport[key].de_DE
            });
            root.countries.push({
                alpha2: key,
                alpha3: countriesImport[key].alpha3,
                prefix: countriesImport[key].prefix,
                region: countriesImport[key].region,
                subregion: countriesImport[key].sub,
                unDate: countriesImport[key].unDate,
                sanction: countriesImport[key].sanction,
                name: {
                    nb_NO: countriesImport[key].nb_NO,
                    en_EN: countriesImport[key].en_EN,
                    sv_SE: countriesImport[key].sv_SE,
                    de_DE: countriesImport[key].de_DE
                }
            });
        }
        root.countriesJson.sort((a, b) => (a.nb_NO > b.nb_NO) ? 1 : -1);
        root.countriesCommon.sort((a, b) => (a.nb_NO > b.nb_NO) ? 1 : -1);
    },

    getBasicTranslations() {
        const translations = {
            "pep_explanation": {
                "en_EN": "<h3>Politically exposed person</h3><p>A «politically exposed person» is defined as a person who:</p><p></p><ul><li><p>(a) holds or has held a «<strong>senior public position or office</strong>» as mentioned below;</p></li><li><p>(b) is a «<strong>close relative</strong>» of a politically exposed person; or</p></li><li><p>(c) is a «<strong>known employee/business partner</strong>» of a political person.</p></li></ul><p>«<strong>Senior public office or office</strong>» is defined as:</p><p></p><ul><li><p>(a) head of state, head of government, minister or deputy minister</p></li><li><p>(b) member of the National Assembly</p></li><li><p>(c) member of governing body of political party</p></li><li><p>(d) a member of a higher court who makes a decision which cannot or only exceptionally be appealed</p></li><li><p>(e) member of the board of the National Audit Office, the Court of Auditors or the Central Bank</p></li><li><p>(f) ambassador, chargé d'affaires or military officer of higher rank</p></li><li><p>(g) medlem av administrativt, ledende eller kontrollerende organ i statlig foretak</p></li><li><p>(h) member of administrative, governing or controlling body of a state-owned enterprise</p></li></ul><p>«<strong>close relative</strong>» is defined as parents, spouse, registered partner, cohabitant and children, as well as the child's spouse, registered partner or cohabitant.</p><p></p><p>A «<strong>known employee/business partner</strong>» is defined as:</p><p></p><ul><li><p>(a) a beneficial owner of a judicial person, association or foreign legal arrangement in association with a politically exposed person;</p></li><li><p>(b) have a close business relationship with a politically exposed person; or</p></li><li><p>(c) be the sole real right holder in a judicial person, association or foreign legal arrangement that is in fact established to favor a politically exposed person.</p></li></ul>",
                "nb_NO": "<h3>Politisk eksponert person</h3><p>Med «politisk eksponert person» menes person som:</p><p></p><ul><li><p>(a) innehar eller har innehatt «<strong>høytstående offentlig stilling eller verv</strong>» som&nbsp; nevnt nedenfor;</p></li><li><p>(b) er «<strong>nært familiemedlem</strong>» av en politisk eksponert person; eller</p></li><li><p>(c) er «<strong>kjent medarbeider</strong>» av en politisk person.</p></li></ul><p>Med «<strong>høytstående offentlig stilling eller verv</strong>» menes:</p><p></p><ul><li><p>(a) statsoverhode, regjeringssjef, minister eller assisterende minister</p></li><li><p>(b) medlem av nasjonalforsamling</p></li><li><p>(c) medlem av styrende organ i politisk parti</p></li><li><p>(d) medlem av høyere rettsinstans som treffer beslutning som ikke eller bare&nbsp; unntaksvis kan ankes</p></li><li><p>(e) medlem av styre i riksrevisjon, revisjonsdomstol eller sentralbank</p></li><li><p>(f) ambassadør, chargé d'affaires eller militær offiser av høyere rang</p></li><li><p>(g) medlem av administrativt, ledende eller kontrollerende organ i statlig foretak</p></li><li><p>(h) direktør, styremedlem eller annen person i øverste ledelse i internasjonal&nbsp; organisasjon</p></li></ul><p>Med «<strong>nært familiemedlem</strong>» menes foreldre, ektefelle, registrert partner, samboer og&nbsp; barn, samt barns ektefelle, registrert partner eller samboer.</p><p></p><p>Med «<strong>kjent medarbeider</strong>» menes fysisk person som er kjent for å:</p><p></p><ul><li><p>(a) være reell rettighetshaver i juridisk person, sammenslutning eller utenlandsk&nbsp; juridisk arrangement i felleskap med politisk eksponert person;</p></li><li><p>(b) ha nær forretningsforbindelse til politisk eksponert person; eller</p></li><li><p>(c) være eneste reelle rettighetshaver i juridisk person, sammenslutning eller&nbsp; utenlandsk juridisk arrangement som i realiteten er etablert for å begunstige&nbsp; politisk eksponert person.</p></li></ul><p></p>",
                "sv_SE": "<h3> Politiskt utsatt person </h3> <p> Med «politiskt utsatt person» avses en person som:</p><p></p><ul><li><p>(a) innehar eller har hållit «<strong>ledande offentliga befattning eller kontor</strong>» som&nbsp;nämnt nedan;</p></li><li><p>(b) er «<strong>nära familjemedlem</strong>»av en politiskt utsatt person; eller</p></li><li><p>(c) er «<strong>känd medarbetare</strong>» av en politisk person.</p></li></ul><p>Med «<strong>högre offentliga befattningar eller befattningar</strong>» menar:</p><p></p><ul><li><p>(a) statschef, regeringschef, minister eller biträdande minister</p></li><li><p>(b) medlem av nationalförsamlingen</p></li><li><p>(c) ledamot av styrande organ i politiskt parti</p></li><li><p>(d) medlem av en högre domstol som fattar ett beslut som inte eller bara&nbsp; kan i undantagsfall överklagas</p></li><li><p>(e) styrelseledamot i revisionsverket, revisionsrätten eller centralbanken </p></li><li><p>(f) Ambassadör, Chargé d 'affaires eller militär officer med högre rang</p></li><li><p>(g) medlem av ett statligt företags administrativa, styrande eller kontrollerande organ</p></li><li><p>(h) en styrelseledamot, styrelseledamot eller annan person i ledningen för en internationell&nbsp; organisation</p></li></ul><p>Med «<strong>Närstående familjemedlem </strong>» betyder föräldrar, make, registrerad partner, samboare och &nbsp; barn, liksom barnets make, registrerade partner eller samboare.</p><p></p><p>Med «<strong>känd medarbeare</strong>» avses en fysisk person som är känd för att</p><p></p><ul><li><p>(a) vara en verklig ägare till en juridisk enhet, förening eller utländsk &nbsp; lagligt arrangemang gemensamt med en politiskt utsatt person;</p></li><li><p>(b) har en nära affärsrelation med en politiskt utsatt person; eller</p></li><li><p>(c) vara den enda verkliga ägaren till en juridisk enhet, förening eller&nbsp; utländskt lagligt arrangemang som faktiskt är etablerat för att gynna&nbsp; politiskt utsatt person.</p></li></ul><p></p>"
            },
            "loading": {
                "en_EN": "Loading",
                "nb_NO": "Laster",
                "sv_SE": "Laddar"
            },
            "loading_portal": {
                "en_EN": "Loading portal",
                "nb_NO": "Laster inn portal",
                "sv_SE": "Laddar in portalen"
            },
            "loading_form": {
                "en_EN": "Loading form",
                "nb_NO": "Laster inn skjema",
                "sv_SE": "Laddar in formuläret"
            },
            "loading_customer": {
                "en_EN": "Loading customer",
                "nb_NO": "Laster inn kunde",
                "sv_SE": "Laddar kunder"
            },
            "loading_aml_fetch": {
                "en_EN": "Fetching data from BankID AML",
                "nb_NO": "Henter data fra BankID AML",
                "sv_SE": "Hämtar data från BankID"
            },
            "loading_aml_report": {
                "en_EN": "Fetching company report from BankID AML",
                "nb_NO": "Henter firmarapport fra BankID AML",
                "sv_SE": "Hämtar företagsrapport från Trapets"
            },
            "loading_aml": {
                "en_EN": "Loading AML data",
                "nb_NO": "Laster AML data",
                "sv_SE": "Laddar AML data"
            },
            "loading_creating_form": {
                "en_EN": "Creating form",
                "nb_NO": "Oppretter skjema",
                "sv_SE": "Skapar formulär"
            },
            "loading_forwarding_form": {
                "en_EN": "Forwarding form",
                "nb_NO": "Videresender skjema",
                "sv_SE": "Skickar vidare formuläret"
            },
            "loading_creating_receipt": {
                "en_EN": "Creating receipt",
                "nb_NO": "Oppretter kvittering",
                "sv_SE": "Skapar kvitto"
            },
            "loading_saving_customer": {
                "en_EN": "Saving customer data",
                "nb_NO": "Lagrer kundedata",
                "sv_SE": "Sparar kunddata"
            },
            "loading_deleting_customer": {
                "en_EN": "Deleting customer",
                "nb_NO": "Sletter kunde",
                "sv_SE": "Raderar kund"
            },
            "loading_id": {
                "en_EN": "Loading ID-control",
                "nb_NO": "Laster ID-kontroll",
                "sv_SE": "Laddar ID-kontroll"
            },
            "loading_id_verify": {
                "en_EN": "Verifying your ID",
                "nb_NO": "Verifiserer din ID",
                "sv_SE": "Verifierar ditt ID"
            },
            "loading_redirect": {
                "en_EN": "You will be redirected in ",
                "nb_NO": "Du vil bli sendt videre om ",
                "sv_SE": "Du blir omdirigerad om "
            },
            "loading_redirect_seconds": {
                "en_EN": " seconds",
                "nb_NO": " sekunder",
                "sv_SE": "sekunder"
            },
            "loading_document": {
                "en_EN": "Loading document",
                "nb_NO": "Laster dokument",
                "sv_SE": "Laddar dokument"
            },
            "loading_archiving": {
                "en_EN": "Archiving current report",
                "nb_NO": "Arkiverer gjeldende kundekontroll",
                "sv_SE": "Arkiverar nuvarande kundkontroll"
            },
            "loading_submitting_form": {
                "en_EN": "Submitting form",
                "nb_NO": "Sender inn skjema",
                "sv_SE": "Skickar in formuläret"
            },
            "loading_sign_link": {
                "en_EN": "Preparing document for signing with Verified",
                "nb_NO": "Gjør klart for signering med Verified",
                "sv_SE": "Förbereder dokumentet för signering med Verified"
            },
            "verified_archive": {
                "en_EN": "Verified-archive",
                "nb_NO": "Verified-arkiv",
                "sv_SE": "Verified-arkiv"
            },
            "log_out": {
                "en_EN": "Log out",
                "nb_NO": "Logg ut",
                "sv_SE": "Logga ut"
            },
            "error_header": {
                "en_EN": "Ooops, there was an error",
                "nb_NO": "Ooops, det skjedde en feil",
                "sv_SE": "Ooops, något gick fel"
            },
            "error_message": {
                "en_EN": "Error message",
                "nb_NO": "Feilmelding",
                "sv_SE": "Felmeddelande"
            },
            "error_reload": {
                "en_EN": "Try reloading the page",
                "nb_NO": "Prøv å last inn på nytt",
                "sv_SE": "Testa att ladda om sidan"
            },
            "error_submit": {
                "en_EN": "Submit error report",
                "nb_NO": "Send inn feilrapport",
                "sv_SE": "Skicka in felrapport"
            },
            "error_thanks": {
                "en_EN": "Thank you for reporting this error.",
                "nb_NO": "Takk for at du rapporterte feilen.",
                "sv_SE": "Tack för att du rapporterade detta fel."
            },
            "error_close": {
                "en_EN": "You can now close this tab, we will investigate the problem.",
                "nb_NO": "Du kan nå lukke fanen, vi skal undersøke problemet.",
                "sv_SE": "Du kan nu stänga denna flik, vi kommer undersäka problemet."
            },
            "preview_main_document": {
                "en_EN": "Main document",
                "nb_NO": "Hoveddokument",
                "sv_SE": "Huvuddokument"
            },
            "preview_attachments": {
                "en_EN": "Attachments",
                "nb_NO": "Vedlegg",
                "sv_SE": "Bilagor"
            },
            "validation_required": {
                "en_EN": "Required",
                "nb_NO": "Påkrevd",
                "sv_SE": "Krävs"
            },
            "validation_number": {
                "en_EN": "Please enter a valid number",
                "nb_NO": "Tast inn et gyldig nummer"
            },
            "validation_minimum": {
                "en_EN": "Please enter at least",
                "nb_NO": "Tast inn minst"
            },
            "validation_digits": {
                "en_EN": "digits",
                "nb_NO": "siffer"
            },
            "validation_percentage": {
                "en_EN": "Please enter a valid percentage",
                "nb_NO": "Tast inn en gyldig prosentandel",
                "sv_SE": "Vänligen ange en gilyig procentandel"
            },
            "validation_email": {
                "en_EN": "Please enter a valid Email-address",
                "nb_NO": "Tast inn en gyldig Epost-adresse",
                "sv_SE": "Vänligen ange en giltig epostadress"
            },
            "validation_account_no": {
                "en_EN": "Please enter a valid account number",
                "nb_NO": "Tast inn et gyldig kontonummer",
                "sv_SE": "Ange ett giltigt kontonummer"
            },
            "dashboard": {
                "en_EN": "Overview",
                "nb_NO": "Oversikt",
                "sv_SE": "Översikt"
            },
            "customers": {
                "en_EN": "Customers",
                "nb_NO": "Kunder",
                "sv_SE": "Kunder"
            },
            "reports": {
                "en_EN": "Reports",
                "nb_NO": "Rapporter",
                "sv_SE": "Rapporter"
            },
            "main_search": {
                "en_EN": "Search",
                "nb_NO": "Personsøk",
                "sv_SE": "Personsökning"
            },
            "archive": {
                "en_EN": "E-signing/archive",
                "nb_NO": "E-signering/arkiv",
                "sv_SE": "E-signering/arkiv"
            },
            "settings": {
                "en_EN": "Settings",
                "nb_NO": "Innstillinger",
                "sv_SE": "Inställningar"
            },
            "customer_new": {
                "en_EN": "New customer",
                "nb_NO": "Ny kunde",
                "sv_SE": "Ny kund"
            },
            "customer_new_org": {
                "en_EN": "Company (Judicial person)",
                "nb_NO": "Foretak (Juridisk person)",
                "sv_SE": "Företag (Juridisk person)"
            },
            "customer_new_other_title": {
                "en_EN": "Foreign company",
                "nb_NO": "Utenlandsk foretak",
                "sv_SE": "Utländskt företag"
            },
            "customer_new_person": {
                "en_EN": "Physical person",
                "nb_NO": "Fysisk person",
                "sv_SE": "Fysisk person"
            },
            "customer_new_no": {
                "en_EN": "Norwegian company registered in the Brønnøysund registries",
                "nb_NO": "Norsk foretak registrert i Brønnøysundregistrene",
                "sv_SE": "Norsk företag registrerat i Brønnøysundregistrene"
            },
            "customer_new_se": {
                "en_EN": "Swedish company registered in Bolagsverket",
                "nb_NO": "Svenskt foretak registrert i Bolagsverket",
                "sv_SE": "Svenskt företag registrerat i Bolagsverket"
            },
            "customer_new_uk": {
                "en_EN": "British company registered in Companies House",
                "nb_NO": "Britisk selskap registrert i Companies House",
                "sv_SE": "Brittiskt företag registrerat i Companies House"
            },
            "customer_new_other": {
                "en_EN": "Forreign company or company under creation (Public company info will need to be entered manually and BankID company search will not be available).",
                "nb_NO": "Utenlandsk foretak eller foretak under stiftelse (Foretaksinformasjon må tastes inn manuelt og BankID AML organsisasjonsøk vil ikke være tilgjengelig).",
                "sv_SE": "Utländskt företag eller företag under skapande (Offentlig företagsinformation måste anges manuellt och BankID-företagsökning kommer inte att vara tillgänglig)."
            },
            "customer_new_exists": {
                "en_EN": "Customer already exists",
                "nb_NO": "Kunden eksisterer allerede",
                "sv_SE": "Kunden finns redan"
            },
            "customer_brreg_hint": {
                "en_EN": "Find the customer in the Brønnøysind registries",
                "nb_NO": "Finn kunden i Brønnøysundregistret",
                "sv_SE": "Hitta kunden i Brønnøysindregistret"
            },
            "customer_bolag_hint": {
                "en_EN": "Provide the organization number to find the customer in Bolagsverket",
                "nb_NO": "Tast inn organisasjonsnummeret for å søke opp kunden i Bolagsverket",
                "sv_SE": "Ange organisationsnummer för att hitta kunden i Bolagsverket"
            },
            "customer_chouse_hint": {
                "en_EN": "Enter company name or number and press enter to search",
                "nb_NO": "Tast inn foretaksnavn eller nummer og trykk enter for å søke",
                "sv_SE": "Ange företagsnamn eller nummer och tryck Enter för att söka"
            },
            "customer_brreg_placeholder": {
                "en_EN": "Start typing to search",
                "nb_NO": "Begynn å skrive for å søke",
                "sv_SE": "Börja skirv för att söka"
            },
            "customer_reference": {
                "en_EN": "Reference number/Customer number",
                "nb_NO": "Referansenummer/Kundenummer",
                "sv_SE": "Referensnummer/Kundnummer"
            },
            "customer_reference_short": {
                "en_EN": "Reference number",
                "nb_NO": "Referansenummer",
                "sv_SE": "Referensnummer"
            },
            "customer_reference_message": {
                "en_EN": "Your reference number",
                "nb_NO": "Ditt referansenummer",
                "sv_SE": "Ditt referensnummer"
            },
            "customer_last": {
                "en_EN": "Last customers",
                "nb_NO": "Siste kunder",
                "sv_SE": "Sista kunderna"
            },
            "customer_delete": {
                "en_EN": "Delete customer",
                "nb_NO": "Slett kunde",
                "sv_SE": "Radera kund"
            },
            "customer_archive": {
                "en_EN": "New report",
                "nb_NO": "Ny kundekontroll",
                "sv_SE": "Ny kundkontroll"
            },
            "customer_archive_prompt": {
                "en_EN": "Are you sure you want to start a new report?",
                "nb_NO": "Er du sikker på at du vil starte en ny kundekontroll?",
                "sv_SE": "Är du säkert på att du vill starta en ny kundkontroll"
            },
            "customer_archive_hint": {
                "en_EN": "The current report will be archived and you can perform a new company search and send out a new self-declaration form.",
                "nb_NO": "Den gjeldende kundekontrollen vil bli arkivert og du kan gjøre et nytt selskapssøk og sende ut nytt egenerklæringsskjema.",
                "sv_SE": "Den aktuella rapporten kommer arkiveras och du kan utföra en ny företagssökning och skicka ut ett nytt kundkännedom."
            },
            "customer_no_hits": {
                "en_EN": "No customers matching this filter",
                "nb_NO": "Ingen kunder matcher dette filteret",
                "sv_SE": "Inga kunder som matchar det här filtret"
            },
            "filters": {
                "en_EN": "Filters",
                "nb_NO": "Filtre",
                "sv_SE": "Filter"
            },
            "filters_tags": {
                "en_EN": "Tags",
                "nb_NO": "Tagger",
                "sv_SE": "Taggar"
            },
            "filters_remove": {
                "en_EN": "Remove all filters",
                "nb_NO": "Fjern alle filtre",
                "sv_SE": "Ta bort alla filter"
            },
            "filters_status": {
                "en_EN": "Status",
                "nb_NO": "Status",
                "sv_SE": "Status"
            },
            "filters_expires": {
                "en_EN": "Self-declaration form",
                "nb_NO": "Egenerklæringsskjema",
                "sv_SE": "Kundkännedom"
            },
            "filters_flow": {
                "en_EN": "Customer type",
                "nb_NO": "Kundetype",
                "sv_SE": "Kundtyp"
            },
            "filters_team_members": {
                "en_EN": "Team members",
                "nb_NO": "Kollegaer",
                "sv_SE": "Kollegor"
            },
            "filters_risk": {
                "en_EN": "Risk",
                "nb_NO": "Risiko",
                "sv_SE": "Risk"
            },
            "filters_department": {
                "en_EN": "Department",
                "nb_NO": "Avdeling",
                "sv_SE": "Avdelning"
            },
            "filters_partner": {
                "en_EN": "Partner",
                "nb_NO": "Partner",
                "sv_SE": "Partner"
            },
            "filters_partner_lcsp": {
                "en_EN": "LCSP",
                "nb_NO": "LCSP",
                "sv_SE": "LCSP"
            },
            "filters_custom_status": {
                "en_EN": "Custom status",
                "nb_NO": "Egendefinert status",
                "sv_SE": "Status"
            },
            "filters_custom_services": {
                "en_EN": "Services",
                "nb_NO": "Tjenester",
                "sv_SE": "Tjänster"
            },
            "filters_custom_reclassed": {
                "en_EN": "Reclassified",
                "nb_NO": "Omklassifisert",
                "sv_SE": "Omklassificerad"
            },
            "filters_custom_reference": {
                "en_EN": "Reference number",
                "nb_NO": "Referansenummer",
                "sv_SE": "Referensnummer"
            },
            "filters_custom_reference_a": {
                "en_EN": "Awaiting number",
                "nb_NO": "Avventer referansenummer",
                "sv_SE": "Inväntar referensnummer"
            },
            "events_last": {
                "en_EN": "Last events",
                "nb_NO": "Siste hendelser",
                "sv_SE": "Senste händelserna"
            },
            "previous_reports": {
                "en_EN": "Previous assessments",
                "nb_NO": "Tidligere kundekontroller",
                "sv_SE": "Tidigare händelser"
            },
            "common_password": {
                "en_EN": "Password",
                "nb_NO": "Passord",
                "sv_SE": "Lösenord"
            },
            "common_log_in": {
                "en_EN": "Log in",
                "nb_NO": "Logg inn",
                "sv_SE": "Logga in"
            },
            "common_wrong_pass": {
                "en_EN": "Wrong email/password",
                "nb_NO": "Feil brukernavn/passord",
                "sv_SE": "Fel lösenord"
            },
            "common_name": {
                "en_EN": "Name",
                "nb_NO": "Navn",
                "sv_SE": "Namn",
                "de_DE": "Name"
            },
            "common_first_name": {
                "en_EN": "First name",
                "nb_NO": "Fornavn",
                "sv_SE": "Förnamn",
                "de_DE": "Vorname"
            },
            "common_last_name": {
                "en_EN": "Last name",
                "nb_NO": "Etternavn",
                "sv_SE": "Efternamn",
                "de_DE": "Nachname"
            },
            "common_dob": {
                "en_EN": "Date of birth",
                "nb_NO": "Fødselsdato",
                "sv_SE": "Födelsedatum",
                "de_DE": "Geburtsdatum"
            },
            "common_ssn": {
                "en_EN": "SSN",
                "nb_NO": "Fødselsnummer",
                "sv_SE": "Personnummer"
            },
            "common_ssn_country": {
                "en_EN": "Country of SSN",
                "nb_NO": "Fødselsnummer fra land",
                "sv_SE": "Personnummer från land"
            },
            "common_share": {
                "en_EN": "Owner share",
                "nb_NO": "Eierandel",
                "de_DE": "Inhaberanteil",
                "sv_SE": "Ägarandel"
            },
            "common_role": {
                "en_EN": "Role",
                "nb_NO": "Rolle",
                "de_DE": "Rolle",
                "sv_SE": "Roll"
            },
            "common_address": {
                "en_EN": "Address",
                "nb_NO": "Adresse",
                "sv_SE": "Adress",
                "de_DE": "Strasse und Hausnummer"
            },
            "common_zip": {
                "en_EN": "Zip-code",
                "nb_NO": "Postnummer",
                "sv_SE": "Postnummer",
                "de_DE": "PLZ"
            },
            "common_city": {
                "en_EN": "City",
                "nb_NO": "Sted",
                "sv_SE": "Ort",
                "de_DE": "Ort"
            },
            "common_commune": {
                "en_EN": "Municipality",
                "nb_NO": "Kommune",
                "sv_SE": "Kommun"
            },
            "common_country": {
                "en_EN": "Country",
                "nb_NO": "Land",
                "sv_SE": "Land",
                "de_DE": "Land"
            },
            "common_citizenship": {
                "en_EN": "Country",
                "nb_NO": "Statsborgerskap",
                "sv_SE": "Medborgarskap",
                "de_DE": "Staatsbürgerschaft"
            },
            "common_email": {
                "en_EN": "Email",
                "nb_NO": "Epost",
                "sv_SE": "Epost",
                "de_DE": "email"
            },
            "common_phone": {
                "en_EN": "Phone",
                "nb_NO": "Telefon",
                "de_DE": "Telefonnummer",
                "sv_SE": "Telefon"
            },
            "common_required": {
                "en_EN": "Required",
                "nb_NO": "Påkrevd",
                "sv_SE": "Krävs",
                "de_DE": "Erforderlich"
            },
            "common_optional": {
                "en_EN": "Optional",
                "nb_NO": "Valgfritt",
                "sv_SE": "Valfritt",
                "de_DE": "Optional"
            },
            "common_other": {
                "en_EN": "Other",
                "nb_NO": "Annet",
                "de_DE": "Sonstiges",
                "sv_SE": "Annat"
            },
            "common_yes": {
                "en_EN": "Yes",
                "nb_NO": "Ja",
                "de_DE": "Ja",
                "sv_SE": "Ja"
            },
            "common_no": {
                "en_EN": "No",
                "nb_NO": "Nei",
                "de_DE": "Nein",
                "sv_SE": "Nej"
            },
            "common_prev": {
                "en_EN": "Previous",
                "nb_NO": "Tilbake",
                "sv_SE": "Tillbaka",
                "de_DE": "Zurück"
            },
            "common_next": {
                "en_EN": "Next",
                "nb_NO": "Neste",
                "sv_SE": "Nästa",
                "de_DE": "Weiter"
            },
            "common_add": {
                "en_EN": "Add",
                "nb_NO": "Legg til",
                "de_DE": "Hinzufügen",
                "sv_SE": "Lägg till"
            },
            "common_remove": {
                "en_EN": "Remove",
                "nb_NO": "Ta bort",
                "de_DE": "Entfernen",
                "sv_SE": "Ta bort"
            },
            "common_save": {
                "en_EN": "Save",
                "nb_NO": "Lagre",
                "de_DE": "Speichern",
                "sv_SE": "Spara"
            },
            "common_cancel": {
                "en_EN": "Cancel",
                "nb_NO": "Avbryt",
                "de_DE": "Abbrechen",
                "sv_SE": "Avbryt"
            },
            "common_open": {
                "en_EN": "Open",
                "nb_NO": "Åpne",
                "de_DE": "Öffnen",
                "sv_SE": "Öppna"
            },
            "common_close": {
                "en_EN": "Close",
                "nb_NO": "Lukk",
                "de_DE": "Schliessen",
                "sv_SE": "Stäng"
            },
            "common_overview": {
                "en_EN": "Overview",
                "nb_NO": "Oversikt",
                "de_DE": "Übersicht",
                "sv_SE": "Översikt"
            },
            "common_person": {
                "en_EN": "Person",
                "nb_NO": "Person",
                "de_DE": "Person",
                "sv_SE": "Person"
            },
            "common_persons": {
                "en_EN": "Persons",
                "nb_NO": "Personer",
                "de_DE": "Personen",
                "sv_SE": "Personer"
            },
            "common_language": {
                "en_EN": "Language",
                "nb_NO": "Språk",
                "de_DE": "Sprache",
                "sv_SE": "Språk"
            },
            "common_result": {
                "en_EN": "Result",
                "nb_NO": "Resultat",
                "de_DE": "Ergebnis",
                "sv_SE": "Resultat"
            },
            "common_firm": {
                "en_EN": "Firm",
                "nb_NO": "Foretak",
                "de_DE": "Gesellschaft",
                "sv_SE": "Företag"
            },
            "common_title": {
                "en_EN": "Title/Position",
                "nb_NO": "Stilling/Tittel",
                "de_DE": "Stellung/Titel",
                "sv_SE": "Titel/Position"
            },
            "common_type": {
                "en_EN": "Type",
                "nb_NO": "Type",
                "de_DE": "Art",
                "sv_SE": "Typ"
            },
            "common_size": {
                "en_EN": "Size",
                "nb_NO": "Størrelse",
                "de_DE": "Grösse",
                "sv_SE": "Storlek"
            },
            "common_date": {
                "en_EN": "Date",
                "nb_NO": "Dato",
                "de_DE": "Datum",
                "sv_SE": "Datum"
            },
            "common_unknown": {
                "en_EN": "Unknown",
                "nb_NO": "Ukjent",
                "de_DE": "Unbekannt",
                "sv_SE": "Okänt"
            },
            "common_unidentified": {
                "en_EN": "Unidentified",
                "nb_NO": "Uidentifisert",
                "sv_SE": "Oidentifierad"
            },
            "common_of": {
                "en_EN": "out of",
                "nb_NO": "av",
                "de_DE": "von",
                "sv_SE": "av"
            },
            "common_select_role": {
                "en_EN": "Select role",
                "nb_NO": "Velg rolle",
                "de_DE": "wähle eine Rolle",
                "sv_SE": "Välj roll"
            },
            "common_description": {
                "en_EN": "Description",
                "nb_NO": "Beskrivelse",
                "de_DE": "Beschreibung",
                "sv_SE": "Beskrivning"
            },
            "common_performed": {
                "en_EN": "Performed",
                "nb_NO": "Utført",
                "de_DE": "erledigt",
                "sv_SE": "Utförd"
            },
            "common_options": {
                "en_EN": "Options",
                "nb_NO": "Valg",
                "de_DE": "Auswahl",
                "sv_SE": "Val"
            },
            "common_confirm": {
                "en_EN": "Confirm",
                "nb_NO": "Bekreft",
                "de_DE": "bestätigen",
                "sv_SE": "Bekräfta"
            },
            "common_confirmed": {
                "en_EN": "Confirmed",
                "nb_NO": "Bekreftet",
                "de_DE": "bestätigt",
                "sv_SE": "Bekräftat"
            },
            "common_complete": {
                "en_EN": "Complete",
                "nb_NO": "Fullfør",
                "de_DE": "abschliessen",
                "sv_SE": "Fullständig"
            },
            "common_reset": {
                "en_EN": "Reset",
                "nb_NO": "Tilbakestill",
                "de_DE": "zurücksetzen",
                "sv_SE": "Återställ"
            },
            "common_search": {
                "en_EN": "Search",
                "nb_NO": "Søk",
                "sv_SE": "Sök"
            },
            "common_search_results": {
                "en_EN": "Search results",
                "nb_NO": "Søkeresultater"
            },
            "common_new": {
                "en_EN": "New",
                "nb_NO": "Ny",
                "sv_SE": "Ny"
            },
            "fileupload_header": {
                "en_EN": "Upload file",
                "nb_NO": "Last opp fil",
                "sv_SE": "Ladda upp fil"
            },
            "fileupload_hint": {
                "en_EN": "Drag and drop a file here or",
                "nb_NO": "Dra og slipp en fil her eller",
                "sv_SE": "Dra och släpp en fil här eller"
            },
            "fileupload_browse": {
                "en_EN": "select file",
                "nb_NO": "velg fil",
                "sv_SE": "välj en fil"
            },
            "clients_search": {
                "en_EN": "Search customers",
                "nb_NO": "Søk etter kunder",
                "sv_SE": "Sök efter kunder"
            },
            "clients_expires": {
                "en_EN": "Expires",
                "nb_NO": "Utløper",
                "sv_SE": "Förfaller"
            },
            "clients_expires_in": {
                "en_EN": "in",
                "nb_NO": "om",
                "sv_SE": "om"
            },
            "clients_expires_days": {
                "en_EN": "days",
                "nb_NO": "dager",
                "sv_SE": "dagar"
            },
            "clients_expires_today": {
                "en_EN": "today",
                "nb_NO": "i dag",
                "sv_SE": "i dag"
            },
            "clients_expires_tomorrow": {
                "en_EN": "tomorrow",
                "nb_NO": "i morgen",
                "sv_SE": "i morgon"
            },
            "clients_expires_expired": {
                "en_EN": "Expired",
                "nb_NO": "Utløpt",
                "sv_SE": "Utgånget"
            },
            "clients_reminder": {
                "en_EN": "Last reminder:",
                "nb_NO": "Siste påminnelse:",
                "sv_SE": "Sista påminnelsen:"
            },
            "clients_reminder_never": {
                "en_EN": "Never",
                "nb_NO": "Aldri",
                "sv_SE": "Aldrig"
            },
            "clients_reminder_today": {
                "en_EN": "Today",
                "nb_NO": "I dag",
                "sv_SE": "I dag"
            },
            "clients_reminder_yesterday": {
                "en_EN": "Yesterday",
                "nb_NO": "I går",
                "sv_SE": "I går"
            },
            "clients_reminder_days_ago": {
                "en_EN": "days ago",
                "nb_NO": "dager siden",
                "sv_SE": "dagar sedan"
            },
            "show_help": {
                "en_EN": "Click to show help",
                "nb_NO": "Trykk for å vise hjelp",
                "sv_SE": "Klicka för att visa hjälp"
            },
            "home_event_aml": {
                "en_EN": "AML search performed on company",
                "nb_NO": "AML søk utført på foretaket",
                "sv_SE": "AML sök är utfört på företaget"
            },
            "home_event_kyc_sent": {
                "en_EN": "Self-declaration form sent out",
                "nb_NO": "Egenerklæringsskjema sendt ut",
                "sv_SE": "Kundkännedom är skickat"
            },
            "home_event_kyc_filled": {
                "en_EN": "Self-declaration form filled out by customer",
                "nb_NO": "Egenerklæringsskjema besvart av kunden",
                "sv_SE": "Kundkännedom har fyllts i av kunden"
            },
            "home_event_pep": {
                "en_EN": "PEP/Sanction search performed on person",
                "nb_NO": "PEP/Sanksjonssøk utført på person",
                "sv_SE": "PEP/Sanktionssökning har utförts på personen"
            },
            "home_event_idc_sent": {
                "en_EN": "ID-control sent out",
                "nb_NO": "ID-kontroll sendt ut",
                "sv_SE": "ID-kontroll skickad"
            },
            "home_event_idc_completed": {
                "en_EN": "ID-control completed",
                "nb_NO": "ID-kontroll fullført",
                "sv_SE": "ID-kontroll slutförd"
            },
            "home_event_report": {
                "en_EN": "Final report created",
                "nb_NO": "Sluttrapport laget",
                "sv_SE": "Slutrapport skapad"
            },
            "home_reminders": {
                "en_EN": "Reminders",
                "nb_NO": "Påminnelser",
                "sv_SE": "Påminnelser"
            },
            "home_batches": {
                "en_EN": "Batch sendouts",
                "nb_NO": "Messeutsendelser",
                "sv_SE": "Massutskick"
            },
            "home_batch_num_notified": {
                "en_EN": "customers notified",
                "nb_NO": "kunder varslet",
                "sv_SE": "kunden är meddelad"
            },
            "client_delete": {
                "en_EN": "Delete customer",
                "nb_NO": "Slette kunde",
                "sv_SE": "Radera kund"
            },
            "client_delete_prompt": {
                "en_EN": "Are you sure you want to delete this customer?",
                "nb_NO": "Er du sikker på at du vil slette denne kunden?",
                "sv_SE": "Är du säker på att du vill radera kunden?"
            },
            "client_delete_hint": {
                "en_EN": "The final report and receipts wil still be available from the Verified-archive.",
                "nb_NO": "Sluttrapport og kvitteringer vil fortsatt ligge i Verified-arkivet.",
                "sv_SE": "Slutrapporten och kvitton kommer fortfarande att finnas tillgängliga i Verified-arkivet"
            },
            "ov_steps": {
                "en_EN": "Steps",
                "nb_NO": "Steg i kundekontrollen",
                "sv_SE": "Steg i kundkontrollen"
            },
            "ov_archive_empty": {
                "en_EN": "No previous reports",
                "nb_NO": "Ingen tidligere kundekontroller",
                "sv_SE": "Inga tidigare kundkontroller"
            },
            "ov_archive_new": {
                "en_EN": "New report",
                "nb_NO": "Ny kundekontroll",
                "sv_SE": "Ny kundkontroll"
            },
            "ov_kyc_send_out": {
                "en_EN": "Send out",
                "nb_NO": "Send ut",
                "sv_SE": "Skicka"
            },
            "ov_kyc_goto": {
                "en_EN": "Go to form",
                "nb_NO": "Gå til skjema",
                "sv_SE": "Gå till formuläret"
            },
            "ov_search_first": {
                "en_EN": "You must perform a search on the company first",
                "nb_NO": "Du må gjøre et søk på foretaket først",
                "sv_SE": "Du måste gör en sökning på ett företag först"
            },
            "ov_send_reminder": {
                "en_EN": "Send reminder",
                "nb_NO": "Send påminnelse",
                "sv_SE": "Skicka en påminnelse"
            },
            "ov_kyc_awaiting_editor": {
                "en_EN": "AWAITING filling",
                "nb_NO": "AVVENTER utfylling",
                "sv_SE": "INVÄNTAR ifyllning"
            },
            "ov_kyc_awaiting_signing": {
                "en_EN": "AWAITING signing",
                "nb_NO": "AVVENTER signering",
                "sv_SE": "INVÄNTAR signering"
            },
            "ov_kyc_status_complete": {
                "en_EN": "SIGNED",
                "nb_NO": "SIGNERT",
                "sv_SE": "SIGNERAT"
            },
            "ov_kyc_status_by": {
                "en_EN": "by ",
                "nb_NO": "av ",
                "sv_SE": "av"
            },
            "ov_id_status_awaiting": {
                "en_EN": "AWAITING ",
                "nb_NO": "AVVENTER ",
                "sv_SE": "VÄNTAR"
            },
            "ov_id_status_complete": {
                "en_EN": "COMPLETED ",
                "nb_NO": "FULLFØRT ",
                "sv_SE": "KLART"
            },
            "ov_id_status_ids": {
                "en_EN": " ID-control(s)",
                "nb_NO": " ID-kontrolle(r) ",
                "sv_SE": "ID-kontroll(er)"
            },
            "ov_view_persons": {
                "en_EN": "Show roles",
                "nb_NO": "Vis personer",
                "sv_SE": "Visa personer"
            },
            "ov_all_roles_complete": {
                "en_EN": "All selected key roles controlled",
                "nb_NO": "Alle valgte personer kontrollert",
                "sv_SE": "Alla valda personer är kontrollerade"
            },
            "ov_book_control": {
                "en_EN": "confirmation of shareholder book",
                "nb_NO": "bekreftelse av aksjeeierbok",
                "sv_SE": "bekräftelse av aktieägarbok"
            },
            "ov_book_control_awaiting": {
                "en_EN": "You must confirm the shareholder book first",
                "nb_NO": "Du må bekrefte aksjeeierbok først",
                "sv_SE": "Du måste bekräfta aktieägarboken först"
            },
            "ov_book_attached": {
                "en_EN": "Attached",
                "nb_NO": "Vedlagt",
                "sv_SE": "Bifogad"
            },
            "ov_book_control_awaiting_status": {
                "en_EN": "awaiting confirmation",
                "nb_NO": "avventer bekreftelse",
                "sv_SE": "inväntar bekräftelse"
            },
            "ov_book_show": {
                "en_EN": "Show shareholder book",
                "nb_NO": "Vis aksjeeierbok",
                "sv_SE": "Visa aktiebok"
            },
            "ov_view_aml": {
                "en_EN": "Show company report",
                "nb_NO": "Vis firmarapport",
                "sv_SE": "Visa företagsrapport"
            },
            "ov_view_kyc": {
                "en_EN": "Show declaration",
                "nb_NO": "Vis egenerklæring",
                "sv_SE": "Visa deklaration"
            },
            "ov_hint_aml_no": {
                "en_EN": "BankID AML fetches data about the company, beneficial owners and search against the UN and EU's sanction registries.",
                "nb_NO": "BankID AML henter data om foretaket, reelle rettighetshavere og søker mot FN og EUs sanksjonsregistre.",
                "sv_SE": "BankID AML hämtar data om företaget, verkliga huvdumän och sök mot FN och EUs sanktionslistor."
            },
            "ov_tt_aml_no": {
                "en_EN": "<p>BankID AML fetches information from the following sources:</p><ul><li><p><strong>EU commission</strong> - The EU&nbsp;commission&nbsp;owns and updates the list <strong>EU_consolidated</strong>, which also covers sanctioned companies.</p></li><li><p><strong>UN Security council</strong> - The UN security council&nbsp;owns and updates the list <strong>UN_global</strong>, which also covers sanctioned companies.</p></li><li><p><strong>BRREG, Brønnøysundregisteret</strong></p></li><li><p>Data from <strong>Enhetsregisteret, Foretaksregisteret, Regnskapsregisteret</strong>, and other official registries for company information.</p></li><li><p><strong>The authorization registry</strong> - The official registry for registered authorizations or powers of attorney.</p></li></ul>",
                "nb_NO": "<p>BankID AML henter selskapsinformasjon fra følgende kilder:</p><ul><li><p><strong>EU commission</strong> - The EU&nbsp;commission&nbsp;owns and updates the list <strong>EU_consolidated</strong>, which also covers sanctioned companies.</p></li><li><p><strong>UN Security council</strong> - The UN security council&nbsp;owns and updates the list <strong>UN_global</strong>, which also covers sanctioned companies.</p></li><li><p><strong>BRREG, Brønnøysundregisteret</strong></p></li><li><p>Data from <strong>Enhetsregisteret, Foretaksregisteret, Regnskapsregisteret</strong>, and other official registries for company information.</p></li><li><p><strong>The authorization registry</strong> - The official registry for registered authorizations or powers of attorney.</p></li></ul>",
                "sv_SE": "<p>BankID AML hämtar företagsinformation från följande källor:</p><ul><li><p><strong>EU commission</strong> - The EU&nbsp;commission&nbsp;owns and updates the list <strong>EU_consolidated</strong>, which also covers sanctioned companies.</p></li><li><p><strong>UN Security council</strong> - The UN security council&nbsp;owns and updates the list <strong>UN_global</strong>, which also covers sanctioned companies.</p></li><li><p><strong>BRREG, Brønnøysundregisteret</strong></p></li><li><p>Data from <strong>Enhetsregisteret, Foretaksregisteret, Regnskapsregisteret</strong>, and other official registries for company information.</p></li><li><p><strong>The authorization registry</strong> - The official registry for registered authorizations or powers of attorney.</p></li></ul>"
            },
            "ov_hint_kyc": {
                "en_EN": "Filled out by the customer contact person and makes sure to collect updated information about the company and key roles.",
                "nb_NO": "Fylles ut av kundens kontaktperson og sørger for å hente inn oppdatert data om foretaket og nøkkelroller.",
                "sv_SE": "Fylls i av kundens kontaktperson och ser till att samla in uppdaterad information om företaget och nyckelroller"
            },
            "ov_tt_kyc": {
                "en_EN": "<p>The customer contact person goes through the form and fills in information about the company, key roles and beneficial owners.</p><p>The contact person selects who will sign on behalf of the company.</p><p></p><p>You can go through the form and fill in known information before it is sent to the contact person for further filling.</p>",
                "nb_NO": "<p>Kundens kontaktperson går gjennom skjemaet og fyller inn informasjon om foretaket, nøkkelroller og reelle rettighetshavere.</p><p>Kontaktpersonen velger hvem som skal signere på vegne av foretaket.</p><p></p><p>Du kan se gjennom skjemaet og eventuelt fylle i informasjon før det sendes til kontaktpersonen for videre utfylling.</p>",
                "sv_SE": "<p>Kundens kontaktperson går igenom formuläret och fller i information om företaget, nyckelroller och verkliga huvudmän.</p><p>Kontaktperson väljer vem som ska signera för företaget.</p><p></p><p>Du kan gå igenom formuläret och fylla i känd information innan den skickas till kontaktpersonen för vidare fyllning.</p>"
            },
            "ov_hint_roles": {
                "en_EN": "Define key roles in the company and perform PEP/Sanction-searches and ID-controls.",
                "nb_NO": "Angi nøkkelroller i foretaket og utfør PEP/Sanksjonssøk med BankID AML og ID-kontroller.",
                "sv_SE": "Definiera nyckelroller i företaget och utför PEP / Sanction-sökningar och ID-kontroller."
            },
            "ov_tt_roles": {
                "en_EN": "<p>Start with defining the key roles in the company that needs additional checks, this is usually the CEO, Chairman and beneficial owners.</p><p></p><p>Perform PEP/Sanction-searches and ID-controls if necessary.</p>",
                "nb_NO": "<p>Start med å definere nøkkelroller i foretaket som trenger videre undersøkelse, dette er typisk Daglig leder, Styreleder og Reelle rettighetshavere.</p><p></p><p>Utfør PEP/Sanksjonssøk og ID-kontroller hvis nødvendig.</p>",
                "sv_SE": "<p>Börja med att definiera nyckelrollerna i företaget som behöver ytterligare kontroller, detta är vanligtvis VD, styrelseordförande och verkliga ägare.</p><p></p><p>Utför PEP / Sanction-sökningar och ID-kontroller vid behov.</p>"
            },
            "ov_hint_report": {
                "en_EN": "Look through the collected information and set a risk assessment, then generate a final report for this customer.",
                "nb_NO": "Gå gjennom innsamlet informasjon og sett en risikovurdering, så genereres det en sluttrapport for kunden.",
                "sv_SE": "Gå igenom den insamlade informationen och sätt en riskbedömning och skapa sedan en slutrapport för denna kund."
            },
            "ov_tt_report": {
                "en_EN": "<p>Look through the collected information and set a risk assessment, then generate a final report for this customer.</p>",
                "nb_NO": "<p>Gå gjennom innsamlet informasjon og sett en risikovurdering, så genereres det en sluttrapport for kunden.</p>",
                "sv_SE": "<p>Gå igenom den insamlade informationen och sätt en riskbedömning och skapa sedan en slutrapport för denna kund.</p>"
            },
            "ov_create_report": {
                "en_EN": "Create report",
                "nb_NO": "Lag rapport",
                "sv_SE": "Skapa rapport"
            },
            "ov_show_report": {
                "en_EN": "Show report",
                "nb_NO": "Vis rapport",
                "sv_SE": "Visa rapport"
            },
            "ov_kyc_change_recipient": {
                "en_EN": "Change recipient/Send reminder",
                "nb_NO": "Endre mottaker/Send påminnelse",
                "sv_SE": "Ändra mottagare/Skicka påminnelse"
            },
            "ov_kyc_resend": {
                "en_EN": "Resend completed form",
                "nb_NO": "Send på nytt ferdig utfylt",
                "sv_SE": "Skicka formuläret igen"
            },
            "ov_kyc_reset": {
                "en_EN": "Reset/Awaiting recipient",
                "nb_NO": "Tilbakestill/Avventer mottaker",
                "sv_SE": "Återställ/Väntar mottagare"
            },
            "ov_kyc_reset_header": {
                "en_EN": "Reset form?",
                "nb_NO": "Tilbakestille skjema?",
                "sv_SE": "Återställ formulär?"
            },
            "ov_kyc_reset_prompt": {
                "en_EN": "Are you sure you want to reset the form?",
                "nb_NO": "Er du sikker på at du vil tilbakestille skjema?",
                "sv_SE": "Är du säker på att du vill återställ formuläret?"
            },
            "ov_kyc_reset_hint": {
                "en_EN": "Status/filters will be updated and you will be able to send a new form to a new recipient at a later time.",
                "nb_NO": "Status/filter vil bli oppdatert og du vil kunne sende ut et nytt skjema til en ny mottaker på et senere tidspunkt.",
                "sv_SE": "Status/filter uppdateras och du kan skicka ett nytt formulär till en ny mottagare vid ett senare tillfälle."
            },
            "events_created": {
                "en_EN": "Customer created by ",
                "nb_NO": "Kunde opprettet av ",
                "sv_SE": "Kund skapad av "
            },
            "events_aml": {
                "en_EN": "Sanction-search on the company performed by ",
                "nb_NO": "Sanksjonssøk utført på foretaket av ",
                "sv_SE": "Sanktionssökning på företaget utfört av "
            },
            "events_aml_chouse": {
                "en_EN": "Company data from Companies House downloaded by ",
                "nb_NO": "Selskapsdata fra Companies House hentet av "
            },
            "events_kyc_sent": {
                "en_EN": "Declaration form sent out by ",
                "nb_NO": "Egenerklæringsskjema sendt ut av ",
                "sv_SE": "Deklarationsformulär skickat ut av "
            },
            "events_kyc_completed": {
                "en_EN": "Declaration form filled out by ",
                "nb_NO": "Egenerklæringsskjema utfylt av ",
                "sv_SE": "Deklarationsformulär ifylld av "
            },
            "events_kyc_signed": {
                "en_EN": "Declaration form signed by ",
                "nb_NO": "Egenerklæringsskjema signert av ",
                "sv_SE": "Deklarationsformulär signerat av "
            },
            "events_pep": {
                "en_EN": "PEP/Sanction-search performed on ",
                "nb_NO": "PEP/Sanksjonssøk utført på ",
                "sv_SE": "PEP/Sanktionssökning utförd på "
            },
            "events_id_sent": {
                "en_EN": "ID-control sent to ",
                "nb_NO": "ID-kontroll sendt til ",
                "sv_SE": "ID-kontroll skickad till "
            },
            "events_id_reminder": {
                "en_EN": "ID-control (reminder) sent to ",
                "nb_NO": "ID-kontroll (påminnelse) sendt til ",
                "sv_SE": "ID-kontroll (påminnelse) skickad till "
            },
            "events_id_completed": {
                "en_EN": "ID-control completed by ",
                "nb_NO": "ID-kontroll fullført for ",
                "sv_SE": "ID-kontroll slutförd av "
            },
            "events_report_created": {
                "en_EN": "Final report created by ",
                "nb_NO": "Sluttrapport laget av ",
                "sv_SE": "Slutrapport skapad av "
            },
            "save_changes": {
                "en_EN": "Save changes",
                "nb_NO": "Lagre endringer",
                "sv_SE": "Spara ändringar"
            },
            "company_orgnr": {
                "en_EN": "Number",
                "nb_NO": "Org.nr",
                "sv_SE": "Företagsnr",
                "de_DE": "Organisationsnumemr"
            },
            "company_industry_code": {
                "en_EN": "Industry code",
                "nb_NO": "Industrikode",
                "sv_SE": "Branschkod"
            },
            "company_org_form": {
                "en_EN": "Entity type",
                "nb_NO": "Selskapstype",
                "sv_SE": "Företagstyp",
                "de_DE": "Gesellschaftsform"
            },
            "company_est_date": {
                "en_EN": "Date established",
                "nb_NO": "Stiftelsesdato",
                "de_DE": "Datum der Gründung",
                "sv_SE": "Datum för grundandet"
            },
            "company_reg_date": {
                "en_EN": "Date registered",
                "nb_NO": "Dato registrert",
                "sv_SE": "Datum registrerat",
                "de_DE": "Datum der Registrierung"
            },
            "company_employees": {
                "en_EN": "Employees",
                "nb_NO": "Ansatte",
                "sv_SE": "Anställda",
                "de_DE": "Angestellte"
            },
            "company_business": {
                "en_EN": "Business",
                "nb_NO": "Bransje",
                "de_DE": "Branche",
                "sv_SE": "Branch"
            },
            "company_business_code": {
                "en_EN": "Business code",
                "nb_NO": "Næringskode",
                "sv_SE": "Företagskod"
            },
            "company_brreg_header": {
                "en_EN": "Information from public registries",
                "nb_NO": "Informasjon fra Brønnøysundregistrene",
                "de_DE": "Informationen aus dem Brønnøysundregister",
                "sv_SE": "Information från offentliga register"
            },
            "company_bolag_header": {
                "en_EN": "Information from bolagsverket",
                "nb_NO": "Informasjon fra bolagsverket",
                "sv_SE": "Information från bolagsverket"
            },
            "company_manual_header": {
                "en_EN": "Information about the company",
                "nb_NO": "Informasjon om foretaket",
                "de_DE": "Information über die Gesellschaft",
                "sv_SE": "Information om företaget"
            },
            "company_registered": {
                "en_EN": "Registered",
                "nb_NO": "Registrert",
                "de_DE": "registriert",
                "sv_SE": "Registrerad"
            },
            "company_in_brreg": {
                "en_EN": "In Brønnøysund registries:",
                "nb_NO": "I enhetsregisteret:",
                "de_DE": "im Brønnøysundregister",
                "sv_SE": "I Brønnøysund-registret:"
            },
            "company_in_business_reg": {
                "en_EN": "In business registry:",
                "nb_NO": "I foretaksregisteret:",
                "de_DE": "im Gesellschaftsregister / Handelsregister",
                "sv_SE": "I företagsregistret:"
            },
            "company_in_mva_reg": {
                "en_EN": "In VAT registry:",
                "nb_NO": "I MVA-registeret:",
                "de_DE": "im MVA-register /Mehrwertsteuerregister",
                "sv_SE": "I momsregistret:"
            },
            "company_status": {
                "en_EN": "Status",
                "nb_NO": "Status",
                "de_DE": "Status",
                "sv_SE": "Status"
            },
            "company_stat_bankrupt": {
                "en_EN": "Bankrupt:",
                "nb_NO": "Konkurs:",
                "de_DE": "Konkurs:",
                "sv_SE": "konkurs:"
            },
            "company_stat_liquidation": {
                "en_EN": "Under liquidation:",
                "nb_NO": "Under avvikling:",
                "de_DE": "Unter Abwicklung:",
                "sv_SE": "Under avveckling:"
            },
            "company_stat_cliquidation": {
                "en_EN": "Under compulsory liquidation:",
                "nb_NO": "Under tvangsavvikling/oppløsning:",
                "de_DE": "Unter Zwangsabwicklung/Konkurs/Auflösung:",
                "sv_SE": "Under obligatorisk likvidation:"
            },
            "company_our_rep": {
                "en_EN": "Our associate",
                "nb_NO": "Opprettet av",
                "sv_SE": "Vår medarbetare"
            },
            "company_company": {
                "en_EN": "Company",
                "nb_NO": "Foretaket",
                "de_DE": "Gesellschaft",
                "sv_SE": "Företag"
            },
            "company_final_report": {
                "en_EN": "Final report",
                "nb_NO": "Sluttrapport",
                "sv_SE": "Slutrapport"
            },
            "company_business_codes": {
                "en_EN": "Business codes",
                "nb_NO": "Næringskoder",
                "sv_SE": "Företagskoder",
                "de_DE": "Gewerbekodes"
            },
            "company_shareholder_book": {
                "en_EN": "Shareholder book",
                "nb_NO": "Aksjeeierbok",
                "sv_SE": "Aktieägarbok"
            },
            "company_owner_structure": {
                "en_EN": "Owner structure",
                "nb_NO": "Eierstruktur",
                "de_DE": "Gesellschafterstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "kyc_form": {
                "en_EN": "Declaration form",
                "nb_NO": "Egenerklæringsskjema",
                "sv_SE": "Ägarstruktur"
            },
            "judicial_person": {
                "en_EN": "Judicial person",
                "nb_NO": "Juridisk person",
                "sv_SE": "Juridisk person"
            },
            "physical_person": {
                "en_EN": "Physical person",
                "nb_NO": "Fysisk person",
                "sv_SE": "Fysiks person"
            },
            "key_roles": {
                "en_EN": "Key roles",
                "nb_NO": "Nøkkelroller",
                "sv_SE": "Nyckelroller"
            },
            "all_roles": {
                "en_EN": "All roles",
                "nb_NO": "Alle roller",
                "sv_SE": "Alla roller"
            },
            "key_roles_description": {
                "en_EN": "Add key roles in the company that requires further controls. This is usually the CEO, chairman and beneficial owners.",
                "nb_NO": "Legg til nøkkelroller i selskapet som krever videre undersøkelse. Dette er typisk Daglig leder, Styreleder og Reelle rettighetshavere.",
                "sv_SE": "Lägg till nyckelroller i företaget som kräver ytterligare kontroller. Detta är vanligtvis VD, ordförande och verkliga huvudmän."
            },
            "key_roles_empty": {
                "en_EN": "No key roles has been selected for screening",
                "nb_NO": "Det er ikke valgt noen nøkkelroller til vurdering",
                "sv_SE": "Alla roller"
            },
            "pep_question": {
                "en_EN": "Is this person politically exposed?",
                "nb_NO": "Er denne personen politisk eksponert?",
                "sv_SE": "Är denna person politiskt utsatt?"
            },
            "pep_title": {
                "en_EN": "Title / function (Why is this person defined as a PEP?)",
                "nb_NO": "Tittel / funksjon (Hvorfor er denne personen definert som en PEP?)",
                "sv_SE": "Titel / funktion"
            },
            "pep_searches": {
                "en_EN": "PEP/Sanction-searches",
                "nb_NO": "PEP/Sanksjonssøk",
                "sv_SE": "PEP/Sanktionssök"
            },
            "id_controls": {
                "en_EN": "ID-controls",
                "nb_NO": "ID-kontroller",
                "sv_SE": "ID-kontroller"
            },
            "show_receipt": {
                "en_EN": "Show receipt",
                "nb_NO": "Vis kvittering",
                "sv_SE": "Visa kvitto"
            },
            "report_assessment": {
                "en_EN": "Assessment",
                "nb_NO": "Vurdering",
                "sv_SE": "Bedömning"
            },
            "report_ok": {
                "en_EN": "OK, No comment",
                "nb_NO": "OK, Ingen kommentar",
                "sv_SE": "OK, Ingen kommentar"
            },
            "report_comment": {
                "en_EN": "Comment",
                "nb_NO": "Kommentar",
                "sv_SE": "Kommentar"
            },
            "report_comment_findings": {
                "en_EN": "Comment/findings",
                "nb_NO": "Kommentar/eventuelle funn i søkeresultater",
                "sv_SE": "Kommentar/resultat"
            },
            "report_no_comment": {
                "en_EN": "No comment",
                "nb_NO": "Ingen kommentar",
                "sv_SE": "Ingen kommentar"
            },
            "report_no_findings": {
                "en_EN": "No findings/comment",
                "nb_NO": "Ingen funn/kommentar",
                "sv_SE": "Inget resultat/kommentar"
            },
            "report_assessments": {
                "en_EN": "Assessments",
                "nb_NO": "Vurderinger",
                "sv_SE": "Bedömningar"
            },
            "report_final_assessment": {
                "en_EN": "Final assessment",
                "nb_NO": "Totalvurdering",
                "sv_SE": "Slutlig bedömning"
            },
            "report_generate": {
                "en_EN": "Create final report",
                "nb_NO": "Lag sluttrapport",
                "sv_SE": "Skapa slutrapport"
            },
            "report_risk_assessment": {
                "en_EN": "Risk assessment",
                "nb_NO": "Risikovurdering",
                "sv_SE": "Riskbedömning"
            },
            "report_risk_low": {
                "en_EN": "Low",
                "nb_NO": "Lav",
                "sv_SE": "Låg"
            },
            "report_risk_med": {
                "en_EN": "Medium",
                "nb_NO": "Medium",
                "sv_SE": "Medium"
            },
            "report_risk_high": {
                "en_EN": "High",
                "nb_NO": "Høy",
                "sv_SE": "Hög"
            },
            "report_aml_result": {
                "en_EN": "Result from sanction-search with BankID AML",
                "nb_NO": "Resultat fra sanskjonssøk med BankID AML",
                "sv_SE": "Resultat från sanktionssökning med BankID AML"
            },
            "report_empty_kyc": {
                "en_EN": "Information from the KYC-form will be here when it is completed...",
                "nb_NO": "Informasjon fra kundekontrollen kommer her når den er fylt inn...",
                "sv_SE": "Information från KYC-formuläret kommer att finnas här när den är klar ..."
            },
            "report_empty_pep": {
                "en_EN": "No PEP/Sanction-searches have been performed...",
                "nb_NO": "Det er ikke gjort noen PEP/Sanksjonssøk...",
                "sv_SE": "Inga PEP / sanktionssökningar har utförts ..."
            },
            "report_empty_id": {
                "en_EN": "No ID-controls have been performed...",
                "nb_NO": "Det er ikke utført noen ID-kontroller...",
                "sv_SE": "Inga ID-kontroller har utförts ..."
            },
            "report_ready": {
                "en_EN": "Ready to create final report...",
                "nb_NO": "Klar for å opprette sluttrapport...",
                "sv_SE": "Redo att skapa slutrapport ..."
            },
            "report_not_ready": {
                "en_EN": "Not ready...",
                "nb_NO": "Ikke klar...",
                "sv_SE": "Inte redo..."
            },
            "report_completed": {
                "en_EN": "Final report already created",
                "nb_NO": "Sluttrapporten er allerede laget",
                "sv_SE": "Slutrapport redan skapad"
            },
            "report_check_aml": {
                "en_EN": "Company information not collected",
                "nb_NO": "Foretaksinformasjon ikke innhentet",
                "sv_SE": "Företagsinformation har inte samlats in"
            },
            "report_check_aml_c": {
                "en_EN": "Assessment of company information not completed",
                "nb_NO": "Vurdering av foretaket ikke fullført",
                "sv_SE": "Bedömning av företagsinformation inte slutförd"
            },
            "report_check_kyc": {
                "en_EN": "Declaration form not completed",
                "nb_NO": "Egenerklæringsskjema ikke fullført",
                "sv_SE": "Kundkännedomen inte slutförd"
            },
            "report_check_kyc_c": {
                "en_EN": "Assessment of declaration not completed",
                "nb_NO": "Vurdering av egenerklæring ikke fullført",
                "sv_SE": "Bedömningen av kundkännedom har inte slutförts"
            },
            "report_check_per_c": {
                "en_EN": "Assessment of key roles not completed",
                "nb_NO": "Vurdering av nøkkelroller ikke fullført",
                "sv_SE": "Bedömning av nyckelroller har inte slutförts"
            },
            "report_check_risk": {
                "en_EN": "Assessment of risk level not completed",
                "nb_NO": "Vurdering av risikonivå ikke fullført",
                "sv_SE": "Bedömning av risknivå inte slutförd"
            },
            "report_check_comment": {
                "en_EN": "Final assessment comment not added",
                "nb_NO": "Mangler kommentar på totalvurdering",
                "sv_SE": "Slutlig bedömningskommentar har inte lagts till"
            },
            "report_check_comp": {
                "en_EN": "Assessment of data changed in self-declaration not completed",
                "nb_NO": "Vurdering av data endret i egenerklæring ikke fullført",
                "sv_SE": "Bedömning av uppgifter som har ändrats i kundekännedomen har inte slutförts"
            },
            "report_check_chlist": {
                "en_EN": "Checklist not completed",
                "nb_NO": "Alle punkter i sjekklisten ikke fullført",
                "sv_SE": "Alla punkter i checklistan har inte slutförts"
            },
            "report_check_file": {
                "en_EN": "External risk assessment not uploaded",
                "nb_NO": "Ekstern risikovurdering ikke lastet opp",
                "sv_SE": "Extern riskbedömning har inte laddats upp"
            },
            "report_checklist": {
                "en_EN": "Checklist",
                "nb_NO": "Sjekkliste",
                "sv_SE": "Checklista"
            },
            "report_comparison": {
                "en_EN": "Data changed in self-declaration",
                "nb_NO": "Data endret i egenerklæring",
                "sv_SE": "Uppgifterna ändrades i kundkännedomen"
            },
            "report_external_header": {
                "en_EN": "Risk assessment",
                "nb_NO": "Risikovurdering",
                "sv_SE": "Riskbedömning"
            },
            "report_external_hint": {
                "en_EN": "Drag and drop the file here or",
                "nb_NO": "Dra og slipp filen her eller",
                "sv_SE": "Dra och släpp filen här eller"
            },
            "report_external_select": {
                "en_EN": "select file",
                "nb_NO": "velg fil",
                "sv_SE": "välj fil"
            },
            "report_external_help": {
                "en_EN": "The risk assessment must be in PDF-format. Select «File - Export» in Excel to create a PDF.",
                "nb_NO": "Risikovurderingen må være i PDF-format. Velg «Fil - Eksporter» i Excel for å lage PDF.",
                "sv_SE": "Riskbedömningen måste vara i PDF-format. Välj «Fil - Exportera» i Excel för att skapa en PDF."
            },
            "preview_download_merged": {
                "en_EN": "Download combined",
                "nb_NO": "Last ned samlet",
                "sv_SE": "Ladda ner tillsammans"
            },
            "persons_kyc_pep": {
                "en_EN": "Reported as PEP in the self declaration form",
                "nb_NO": "Rapportert som PEP i egenerklæringsskjema",
                "sv_SE": "Rapporteras som PEP i kundkännedom"
            },
            "persons_kyc_added": {
                "en_EN": "Added in the self declaration form",
                "nb_NO": "Lagt til av mottaker i kundekontrollen",
                "sv_SE": "Tillagt av mottagaren i kundkännedom"
            },
            "persons_manual_added": {
                "en_EN": "Added manually by ",
                "nb_NO": "Lagt til manuelt av ",
                "sv_SE": "Lades till manuellt av "
            },
            "persons_select_contact": {
                "en_EN": "Select contact person",
                "nb_NO": "Velg kontaktperson",
                "sv_SE": "Välj kontaktperson"
            },
            "persons_contact": {
                "en_EN": "Contact person",
                "nb_NO": "Kontaktperson",
                "sv_SE": "Kontaktperson"
            },
            "persons_contact_hint": {
                "en_EN": "The person that act on behalf of the company",
                "nb_NO": "Angi person som handler på vegne av selskapet",
                "sv_SE": "Ange den person som agerar åt företagets vägnar"
            },
            "persons_search_baml": {
                "en_EN": "Search with BankID AML",
                "nb_NO": "Søk med BankID AML",
                "sv_SE": "Sök med BankID AML"
            },
            "persons_id_manual": {
                "en_EN": "Completed manually",
                "nb_NO": "Fullført manuelt",
                "sv_SE": "Slutfört manuellt"
            },
            "persons_id_manual_hint": {
                "en_EN": "If the persons ID has already been confirmed outside the AML portal you can set it as completed here.",
                "nb_NO": "Hvis en ID-kontroll allerede er gjort utenfor AML-portalen kan du sette den som fullført her.",
                "sv_SE": "Om en ID-kontroll redan har gjorts utanför AML-portalen kan du ställa in den som avslutad här."
            },
            "persons_id_send": {
                "en_EN": "Send ID-control",
                "nb_NO": "Send ID-kontroll",
                "sv_SE": "Skicka ID-kontroll"
            },
            "sms_notification": {
                "en_EN": "SMS notification",
                "nb_NO": "SMS varsling",
                "sv_SE": "SMS avisering"
            },
            "sms_notification_use": {
                "en_EN": "Use SMS for notification",
                "nb_NO": "Varsle mottaker med SMS",
                "sv_SE": "Meddela mottagaren via SMS"
            },
            "sms_notification_info_sms": {
                "en_EN": "Recipient receives an SMS with the invitation",
                "nb_NO": "Mottaker får invitasjon på SMS",
                "sv_SE": "Mottagaren får inbjudan via SMS"
            },
            "sms_notification_info_email": {
                "en_EN": "Recipient receives an E-mail with the invitation",
                "nb_NO": "Mottaker får invitasjon på E-post",
                "sv_SE": "Mottagaren får inbjudan via e-post"
            },
            "persons_email_send": {
                "en_EN": "Send email",
                "nb_NO": "Send epost",
                "sv_SE": "Skicka epost"
            },
            "persons_role_add": {
                "en_EN": "Do you want to add this person to key roles?",
                "nb_NO": "Vil du legge til denne personen i nøkkelroller?",
                "sv_SE": "Vill du lägga till den här personen i nyckelroller?"
            },
            "persons_role_remove": {
                "en_EN": "Do you want to remove this person from key roles?",
                "nb_NO": "Vil du ta bort denne personen fra nøkkelroller?",
                "sv_SE": "Vill du ta bort den här personen från nyckelroller?"
            },
            "list_add_manually": {
                "en_EN": "Add manually",
                "nb_NO": "Legg til manuelt",
                "sv_SE": "Lägg till manuellt"
            },
            "persons_pep_tooltip": {
                "en_EN": "",
                "nb_NO": "<h3>PEP/Sanksjonssøket søker mot flere databaser:</h3><p><strong>Det søkes mot følgende sanksjonslister:</strong></p><ul><li><p>European Union Consolidated Financial Sanctions List</p></li><li><p>United Nations Security Council Consolidated List</p></li></ul><p><strong>Trapets PEP Edge</strong></p><p>Trapets provide the list “Pep Edge” that is an editorially made list of Politically Exposed Persons (PEP) and Relatives and Close Associates (RCA) for the Nordic. The list is updated daily and is considered to have close to 100% coverage in the Nordics. It also contains expired PEP`s for Norway with the date of when the person resigned from the role that made him/her a PEP.</p><p></p><p><strong>Adresseinformasjon</strong></p><p>Hvis det er aktivert tilgang Det Sentrale Folkeregister (DSF), hentes adressen herfra. Hvis ikke hentes adressen fra Posten.</p><p></p>",
                "sv_SE": "<h3>PEP/Sanktionssökning gäller flera databaser: </h3><p><strong>Följande sanktionslistor tillämpas:</strong></p><ul><li><p>Europeiska unionens konsoliderade finansiella sanktionslista</p></li><li><p>FN: s säkerhetsråds konsoliderade lista</p></li></ul><p><strong>Trapets PEP Edge</strong></p><p>Trapets provide the list “Pep Edge” that is an editorially made list of Politically Exposed Persons (PEP) and Relatives and Close Associates (RCA) for the Nordic. The list is updated daily and is considered to have close to 100% coverage in the Nordics. It also contains expired PEP`s for Norway with the date of when the person resigned from the role that made him/her a PEP.</p><p></p><p><strong>Adressinformation</strong></p><p>Om åtkomst till det centrala befolkningsregistret (DSF) är aktiverat hämtas adressen härifrån. Om inte, hämtas adressen från Posten.</p><p></p>"
            },
            "persons_idc_tooltip": {
                "en_EN": "",
                "nb_NO": "<h3>Sender en e-post med invitasjon til ID-kontrollen.</h3><p>Mottaker følger linken i e-posten og legitimerer seg med <strong>BankID</strong>.</p><p></p><p>Det er <strong>ikke </strong>nødvendig å legitimere alle personene i selskapet, vanligvis kun signaturberettigede og reelle rettighetshavere.</p><p></p>",
                "sv_SE": "<h3>Skickar ett mejl som bjuder in dig till ID-kontrollen.</h3><p>Mottagaren följer länken i e-postmeddelandet och identifierar sig <strong>BankID</strong>.</p><p></p><p>Det är <strong>inte </strong>nödvändigt att legitimera alla människor i företaget, vanligtvis bara undertecknare och verkliga huvudmän.</p><p></p>"
            },
            "hit_pep": {
                "en_EN": "Hit on PEP",
                "nb_NO": "Treff på PEP",
                "sv_SE": "Träff på PEP"
            },
            "hit_sanction": {
                "en_EN": "Hit on sanction",
                "nb_NO": "Treff på sanksjon",
                "sv_SE": "Träff på sanktion"
            },
            "hit_pep_and_sanction": {
                "en_EN": "Hit on PEP and sanction",
                "nb_NO": "Treff på PEP og sanksjon",
                "sv_SE": "Träff på PEP och sanktion"
            },
            "hit_none": {
                "en_EN": "No hits on PEP or sanction",
                "nb_NO": "Ingen treff på PEP eller sanksjon",
                "sv_SE": "Ingen träff på PEP eller sanktion"
            },
            "hit_empty_search": {
                "en_EN": "Not performed",
                "nb_NO": "Ikke utført",
                "sv_SE": "Inte utförd"
            },
            "search_perform": {
                "en_EN": "Search",
                "nb_NO": "Utfør søk",
                "sv_SE": "Utför sökning"
            },
            "search_performed": {
                "en_EN": "Search performed",
                "nb_NO": "Søk utført",
                "sv_SE": "Sökning utförd"
            },
            "person_pep": {
                "en_EN": "PEP/Sanction-search",
                "nb_NO": "PEP/Sanksjonssøk",
                "sv_SE": "PEP/Sanktionssök"
            },
            "person_id": {
                "en_EN": "ID-control",
                "nb_NO": "ID-kontroll",
                "sv_SE": "ID-kontroll"
            },
            "person_confirmed_id": {
                "en_EN": "Confirmed identity",
                "nb_NO": "Bekreftet identitet",
                "sv_SE": "Bekräftad identitet"
            },
            "person_confirmed_id_empty": {
                "en_EN": "ID-control not performed",
                "nb_NO": "ID-kontroll ikke utført",
                "sv_SE": "ID-kontroll har inte utförts"
            },
            "person_confirmed_id_pending": {
                "en_EN": "Awaiting completion of ID-control",
                "nb_NO": "Avventer fullførelse av ID-kontroll",
                "sv_SE": "Väntar på att ID-kontrollen är klar"
            },
            "person_confirmed_id_fileupload": {
                "en_EN": "ID confirmed by uploading passport",
                "nb_NO": "ID bekreftet med passopplasting",
                "sv_SE": "ID bekräftat med uppladdning av pass"
            },
            "person_confirmed_id_manual": {
                "en_EN": "ID confirmed outside portal",
                "nb_NO": "ID bekreftet utenfor portalen",
                "sv_SE": "ID bekräftat utanför portalen"
            },
            "person_id_awaiting": {
                "en_EN": "AWAITING completion",
                "nb_NO": "AVVENTER fullførelse",
                "sv_SE": "Inväntar färdigställning"
            },
            "person_id_confirmed": {
                "en_EN": "ID confirmed",
                "nb_NO": "ID bekreftet",
                "sv_SE": "ID bekräftat"
            },
            "person_not_selected": {
                "en_EN": "Not selected",
                "nb_NO": "Ikke valgt",
                "sv_SE": "Ej valt"
            },
            "person_add_manual": {
                "en_EN": "Add person manually",
                "nb_NO": "Legg til person manuelt",
                "sv_SE": "Lägg till person manuellt"
            },
            "person_add_list": {
                "en_EN": "Or select a person from the list to the right",
                "nb_NO": "Eller velg fra listen til høyre",
                "sv_SE": "Eller välj från listan till höger"
            },
            "recipient": {
                "en_EN": "Recipient",
                "nb_NO": "Mottaker",
                "de_DE": "Empfänger",
                "sv_SE": "Mottagare"
            },
            "recipient_select": {
                "en_EN": "Select recipient",
                "nb_NO": "Velg mottaker",
                "de_DE": "Wähle einen Empfänger",
                "sv_SE": "Välj mottagare"
            },
            "recipient_add": {
                "en_EN": "Add new recipient",
                "nb_NO": "Legg til ny mottaker",
                "de_DE": "Füge einen neuen Empfänger hinzu",
                "sv_SE": "Lägg till ny mottagare"
            },
            "recipient_action_question": {
                "en_EN": "What should this recipient do?",
                "nb_NO": "Hva skal denne personen gjøre?",
                "de_DE": "Was soll diese Person ausführen?",
                "sv_SE": "Vad ska den här personen göra?"
            },
            "recipient_action_sign": {
                "en_EN": "Sign with:",
                "nb_NO": "Signere med:",
                "de_DE": "Unterschreibe mit:",
                "sv_SE": "Signer med"
            },
            "recipient_action_approve": {
                "en_EN": "Approve",
                "nb_NO": "Godkjenne",
                "de_DE": "Bestätige",
                "sv_SE": "Godkänna"
            },
            "recipient_order": {
                "en_EN": "Recipient order",
                "nb_NO": "Valgt rekkefølge",
                "de_DE": "Ausgewählte Reihenfolge",
                "sv_SE": "Vald mottagarordning"
            },
            "recipient_list": {
                "en_EN": "Select person from list",
                "nb_NO": "Velg person fra rolle-liste",
                "de_DE": "Wähle eine Person aus der Liste",
                "sv_SE": "Välj person från listan"
            },
            "recipient_list_missing": {
                "en_EN": "The person is not in the list",
                "nb_NO": "Personen er ikke i listen",
                "de_DE": "Die Person ist nicht in der Liste aufgefüht.",
                "sv_SE": "Personen är inte med i listan "
            },
            "recipient_select_person": {
                "en_EN": "Select person",
                "nb_NO": "Velg person",
                "de_DE": "Wähle eine Person",
                "sv_SE": "Välj person"
            },
            "recipient_error_details": {
                "en_EN": "Enter all details for the recipient",
                "nb_NO": "Fyll inn alle detaljer om mottaker",
                "de_DE": "alle Emfängerdaten ausfüllen / eintragen",
                "sv_SE": "Fyll i all information om mottagaren"
            },
            "recipient_order_therafter": {
                "en_EN": "therafter",
                "nb_NO": "deretter",
                "de_DE": "danach",
                "sv_SE": "sedan"
            },
            "recipient_order_finally": {
                "en_EN": "finally when everyone has completed their actions",
                "nb_NO": "til slutt når alle har fullført",
                "de_DE": "nachdem alles ausgefüllt wurde,",
                "sv_SE": "till slut när alla är klara"
            },
            "recipient_order_invitation": {
                "en_EN": " receives an invitation to ",
                "nb_NO": " mottar invitasjon til å ",
                "de_DE": " bekomt der Empfänger eine Aufforderung ",
                "sv_SE": " får inbjudan till att "
            },
            "recipient_order_editor": {
                "en_EN": "Fill out form",
                "nb_NO": "Fylle i skjema",
                "de_DE": "das Formular zu vervollständigen.",
                "sv_SE": "Fylla i formuläret"
            },
            "recipient_order_signer": {
                "en_EN": "Sign",
                "nb_NO": "Signere",
                "de_DE": "unterschreibe hier",
                "sv_SE": "Signera"
            },
            "recipient_order_signs": {
                "en_EN": "Signs",
                "nb_NO": "Signerer",
                "de_DE": "Name des Unterzeichners",
                "sv_SE": "Signerar"
            },
            "recipient_order_selected": {
                "en_EN": "The chosen persons",
                "nb_NO": "Valgte personer",
                "de_DE": "Ausgewählte Personen",
                "sv_SE": "Valda personer"
            },
            "recipient_order_all": {
                "en_EN": "Everyone including you",
                "nb_NO": "Alle inkludert deg",
                "de_DE": "Alle inklusive dir",
                "sv_SE": "Alla inklusive dig"
            },
            "recipient_order_select_1": {
                "en_EN": " chooses one or more persons to ",
                "nb_NO": " velger en eller flere som skal ",
                "de_DE": " einen oder mehrere auswählen, die ",
                "sv_SE": " väljer en eller flera som ska "
            },
            "recipient_order_select_2": {
                "en_EN": " on behalf of the company ",
                "nb_NO": " på vegne av foretaket",
                "de_DE": " im Namen der Gesellschaft ",
                "sv_SE": " på företagets vägnar "
            },
            "recipient_order_email": {
                "en_EN": " receives an email with a link to the signed document(s)",
                "nb_NO": " får en e-post med link til signerte dokument(er)",
                "de_DE": " eine email mit einem Link zu den signierten Dokumenten erhalten sollen.",
                "sv_SE": " får ett e-postmeddelande med länk till de signerade dokumentet(en)"
            },
            "recipient_order_fills_and": {
                "en_EN": " fills in the form and ",
                "nb_NO": " fyller ut og ",
                "de_DE": " ausfüllen und ",
                "sv_SE": " fyller i formuläret och "
            },
            "recipient_order_completed_form": {
                "en_EN": " the completed form.",
                "nb_NO": " det ferdig utfylte skjemaet.",
                "de_DE": " das fertig ausgefüllte Formular",
                "sv_SE": " det ifyllda formuläret."
            },
            "ceo": {
                "en_EN": "CEO",
                "nb_NO": "Daglig leder",
                "sv_SE": "VD",
                "de_DE": "Geschäftsführer"
            },
            "chair": {
                "en_EN": "Chairman",
                "nb_NO": "Styreleder",
                "sv_SE": "Ordförande",
                "de_DE": "Vorstandsvorsitzender"
            },
            "proprietor": {
                "en_EN": "Proprietor",
                "nb_NO": "Innehaver",
                "sv_SE": "Ägare",
                "de_DE": "Eigner"
            },
            "role_customer_contact": {
                "en_EN": "Customer contact",
                "nb_NO": "Kontaktperson",
                "sv_SE": "Kontaktperson"
            },
            "screening_role_sign_right": {
                "en_EN": "Signatory",
                "nb_NO": "Signaturberettiget",
                "sv_SE": "Undertecknande",
                "de_DE": "Unterschriftsbevollmächtigter"
            },
            "screening_role_procura": {
                "en_EN": "Procura",
                "nb_NO": "Prokurist",
                "sv_SE": "Procura",
                "de_DE": "Prokurist"
            },
            "screening_role_deputy_chairman": {
                "en_EN": "Deputy chairman",
                "nb_NO": "Nestleder",
                "sv_SE": "Suppleant ordförande",
                "de_DE": "stellv. Geschäftsführer"
            },
            "screening_role_board_member": {
                "en_EN": "Board member",
                "nb_NO": "Styremedlem",
                "sv_SE": "Ledamot",
                "de_DE": "Vorstandsmitglied"
            },
            "screening_role_board_members": {
                "en_EN": "Board members",
                "nb_NO": "Styremedlemmer",
                "sv_SE": "Ledamöter",
                "de_DE": "Vorstandsmitglieder"
            },
            "screening_role_deputy_board_member": {
                "en_EN": "Deputy board member",
                "nb_NO": "Varamedlem",
                "sv_SE": "Suppleant",
                "de_DE": "Stellvertreter / stellvertretendes Mitglied"
            },
            "screening_role_deputy_board_members": {
                "en_EN": "Deputy board members",
                "nb_NO": "Varamedlemmer",
                "sv_SE": "Suppleanter",
                "de_DE": "Stellvertreter / stellvertretende Mitglieder"
            },
            "screening_role_rrh": {
                "en_EN": "Beneficial owner",
                "nb_NO": "Reell rettighetshaver",
                "sv_SE": "Verklig huvudman",
                "de_DE": "persönlicher Gesellschafter"
            },
            "screening_role_rrhs": {
                "en_EN": "Beneficial owners",
                "nb_NO": "Reelle rettighetshavere",
                "sv_SE": "Verkliga huvudmän",
                "de_DE": "persönliche Gesellschafter"
            },
            "screening_role_shareholder": {
                "en_EN": "Shareholder",
                "nb_NO": "Aksjonær",
                "sv_SE": "Aktieägare",
                "de_DE": "Aktionär"
            },
            "screening_role_shareholders": {
                "en_EN": "Shareholders",
                "nb_NO": "Aksjonærer",
                "sv_SE": "Aktieägare",
                "de_DE": "Aktionäre"
            },
            "screening_role_others": {
                "en_EN": "Other roles",
                "nb_NO": "Andre roller",
                "sv_SE": "Andra roller",
                "de_DE": "andere Rollen "
            },
            "screening_role_accountant": {
                "en_EN": "Accountant",
                "nb_NO": "Regnskapsfører",
                "sv_SE": "Revisor"
            },
            "scr_secretary": {
                "en_EN": "Secretary"
            },
            "scr_director": {
                "en_EN": "Director"
            },
            "scr_directors": {
                "en_EN": "Directors"
            },


            "role_secretary": {
                "en_EN": "Secretary"
            },
            "role_director": {
                "en_EN": "Director"
            },

            "role_individual": {
                "en_EN": "Individual",
                "nb_NO": "Privatperson",
                "sv_SE": "Privatperson"
            },
            "role_kyc_pep": {
                "en_EN": "Self-reported as PEP",
                "nb_NO": "Selvrapportert som PEP",
                "sv_SE": "Självrapporterad som PEP"
            },
            "role_ceo": {
                "en_EN": "CEO",
                "nb_NO": "Daglig leder",
                "sv_SE": "VD",
                "de_DE": "Geschäftsführer"
            },
            "role_chair": {
                "en_EN": "Chairman",
                "nb_NO": "Styreleder",
                "sv_SE": "Ordförande",
                "de_DE": "Vorstandsvorsitzender"
            },
            "role_proprietor": {
                "en_EN": "Proprietor",
                "nb_NO": "Innehaver",
                "sv_SE": "Ägare",
                "de_DE": "Eigner"
            },
            "role_customer_contact": {
                "en_EN": "Customer contact",
                "nb_NO": "Kontaktperson",
                "sv_SE": "Kontaktperson"
            },
            "role_signatory": {
                "en_EN": "Signatory",
                "nb_NO": "Signaturberettiget",
                "sv_SE": "Undertecknande",
                "de_DE": "Unterschriftsbevollmächtigter"
            },
            "role_procura": {
                "en_EN": "Procura",
                "nb_NO": "Prokurist",
                "sv_SE": "Procura",
                "de_DE": "Prokurist"
            },
            "role_deputy_chair": {
                "en_EN": "Deputy chairman",
                "nb_NO": "Nestleder",
                "sv_SE": "Suppleant ordförande",
                "de_DE": "stellv. Geschäftsführer"
            },
            "role_board_member": {
                "en_EN": "Board member",
                "nb_NO": "Styremedlem",
                "sv_SE": "Ledamot",
                "de_DE": "Vorstandsmitglied"
            },
            "role_deputy_bm": {
                "en_EN": "Deputy board member",
                "nb_NO": "Varamedlem",
                "sv_SE": "Suppleant",
                "de_DE": "Stellvertreter / stellvertretendes Mitglied"
            },
            "role_rrh": {
                "en_EN": "Beneficial owner",
                "nb_NO": "Reell rettighetshaver",
                "sv_SE": "Verklig huvudman",
                "de_DE": "persönlicher Gesellschafter"
            },
            "role_shareholder": {
                "en_EN": "Shareholder",
                "nb_NO": "Aksjonær",
                "sv_SE": "Aktieägare",
                "de_DE": "Aktionär"
            },
            "role_owner_10": {
                "en_EN": "Direct/indirect owner (more than 10%)",
                "nb_NO": "Direkte/indirekte eier (mer enn 10%)",
                "sv_SE": "Direct/indirect owner (more than 10%)",
            },
            "role_accountant": {
                "en_EN": "Accountant",
                "nb_NO": "Regnskapsfører",
                "sv_SE": "Revisor"
            },
            "role_accountant": {
                "en_EN": "Accountant",
                "nb_NO": "Regnskapsfører",
                "sv_SE": "Revisor"
            },
            "role_cfo": {
                "en_EN": "CFO",
                "nb_NO": "Økonomisjef",
                "sv_SE": "CFO"
            },
            "role_commercial": {
                "en_EN": "Commercial representative",
                "nb_NO": "Handelsfullmektig",
                "sv_SE": "Kommersiell representant"
            },
            "role_poa": {
                "en_EN": "Power of Attorney",
                "nb_NO": "Fullmakt",
                "sv_SE": "Fullmakt"
            },
            "role_other": {
                "en_EN": "Other",
                "nb_NO": "Annet",
                "de_DE": "Sonstiges",
                "sv_SE": "Annat"
            },
            "role_none": {
                "en_EN": "This person no longer have a role in the company",
                "nb_NO": "Denne personen har ikke lenger en rolle i foretaket",
                "sv_SE": "Denna person har inte längre någon roll i företaget"
            },
            "role_nones": {
                "en_EN": "Persons that no longer have a role in the company",
                "nb_NO": "Personer som ikke lengre har en rolle i foretaket",
                "sv_SE": "Personer som inte längre har en roll i företaget"
            },

            "pep_kyc_info_header": {
                "en_EN": "Declaration form not completed",
                "nb_NO": "Egenerklæringsskjema ikke fullført",
                "sv_SE": "Kundkännedom har inte fyllts i"
            },
            "pep_kyc_info_text": {
                "en_EN": "The information below comes from public registries and can be outdated. It is recomemnded that you wait with performing PEP/Sanction-searches on beneficial owners until the customer has filled out the declaration form.",
                "nb_NO": "Informasjonen under kommer fra offentlige registre og kan være utdatert. Det anbefales at du venter med å gjøre PEP/Sanksjonsøk på reelle rettighetshavere til kunden har svart på egenerklærings-skjemaet.",
                "sv_SE": "Informationen nedan kommer från offentliga register och kan vara inaktuell. Vi rekommenderar att du väntar på att göra PEP/Sanction-sökning på Verklig huvudman tills kunden har svarat på kundkännedomet."
            },
            "pep_aml_info_header": {
                "en_EN": "BankID AML-search not completed",
                "nb_NO": "BankID AML-søk ikke utført",
                "sv_SE": "BankID AML-sökning slutfördes inte"
            },
            "pep_aml_info_text": {
                "en_EN": "Perform a search with BankID AML to see key roles and beneficial owners.",
                "nb_NO": "Søk opp foretaket med BankID AML for å se nøkkelroller og reelle rettighetshavere.",
                "sv_SE": "Utför en sökning med BankID AML för att se nyckelroller och verkliga huvudmän."
            },
            "rep_created_info_header": {
                "en_EN": "Final report created",
                "nb_NO": "Sluttrapport laget",
                "sv_SE": "Slutrapport skapad"
            },
            "rep_created_info_text": {
                "en_EN": "The final report for this customer is created and editing is locked.",
                "nb_NO": "Det er laget sluttrapport for denne kunden og redigering er låst.",
                "sv_SE": "Slutrapporten för denna kund är skapad och redigering är låst."
            },
            "action_sign": {
                "en_EN": "signing",
                "nb_NO": "signering",
                "sv_SE": "signering"
            },
            "action_sign_verb": {
                "en_EN": "sign",
                "nb_NO": "signere",
                "sv_SE": "signera"
            },
            "action_approve": {
                "en_EN": "approval",
                "nb_NO": "godkjenning",
                "sv_SE": "godkännande"
            },
            "action_approve_verb": {
                "en_EN": "approve",
                "nb_NO": "godkjenne",
                "sv_SE": "godkänna"
            },
            "settings_for": {
                "en_EN": "Settings for",
                "nb_NO": "Innstillinger for",
                "sv_SE": "Inställningar för"
            },
            "settings_show_for": {
                "en_EN": "Show settings for:",
                "nb_NO": "Vis innstillinger for:",
                "sv_SE": "Visa inställningar för:"
            },
            "settings_show_portal_head": {
                "en_EN": "Portal",
                "nb_NO": "Portal",
                "sv_SE": "Portal"
            },
            "settings_show_portal_desc": {
                "en_EN": "Show settings for the portal",
                "nb_NO": "Vis innstillinger for portalen",
                "sv_SE": "Visa inställningar för portalen"
            },
            "settings_show_kyc_head": {
                "en_EN": "Self-declaration form",
                "nb_NO": "Egenerklæringsskjema",
                "sv_SE": "kundkännedom"
            },
            "settings_show_kyc_desc": {
                "en_EN": "Change questions, texts/translations, function etc.",
                "nb_NO": "Endre spørsmål, tekster/oversettelser, utseende osv.",
                "sv_SE": "Ändra frågor, texter / översättningar, funktion etc."
            },
            "settings_show_idc_head": {
                "en_EN": "ID-control",
                "nb_NO": "ID-kontroll",
                "sv_SE": "ID-kontroll"
            },
            "settings_show_idc_desc": {
                "en_EN": "Change questions, texts/translations, function etc.",
                "nb_NO": "Endre spørsmål, tekster/oversettelser, utseende osv.",
                "sv_SE": "Ändra frågor, texter / översättningar, funktion etc."
            },
            "settings_show_colors_head": {
                "en_EN": "Color theme",
                "nb_NO": "Fargetema",
                "sv_SE": "Färgtema"
            },
            "settings_show_colors_desc": {
                "en_EN": "Change the color theme for the portal, forms and ID-controls.",
                "nb_NO": "Endre fargetema for portalen, skjema og ID-kontroller.",
                "sv_SE": "Ändra färgtema för portalen, formulär och ID-kontroller."
            },
            "settings_preview": {
                "en_EN": "Preview",
                "nb_NO": "Forhåndsvisning",
                "sv_SE": "Förhandsgranskning"
            },
            "settings_hc_editor": {
                "en_EN": "Customer fills out",
                "nb_NO": "Kunden fyller ut",
                "sv_SE": "Kund fyller i "
            },
            "settings_hc_owner": {
                "en_EN": "Internal",
                "nb_NO": "Internt",
                "sv_SE": "Internt"
            },
            "settings_text_editor": {
                "en_EN": "Text editor",
                "nb_NO": "Tekstredigering",
                "sv_SE": "Textredigerare"
            },
            "settings_new_text": {
                "en_EN": "New text",
                "nb_NO": "Ny tekst",
                "sv_SE": "Ny text"
            },
            "settings_new_text_tt": {
                "en_EN": "<p>New <b>formatted</b> text</p>",
                "nb_NO": "<p>Ny <b>formattert</b> tekst</p>",
                "sv_SE": "<p> Ny <b> formaterad </b> text </p>"
            },
            "settings_lp_editor": {
                "en_EN": "Filled out form",
                "nb_NO": "Fylte i skjema",
                "sv_SE": "Utfyllt formulär"
            },
            "settings_lp_signed": {
                "en_EN": "Signing OK",
                "nb_NO": "Signering OK",
                "sv_SE": "Signering OK"
            },
            "settings_lp_aborted": {
                "en_EN": "Signing aborted",
                "nb_NO": "Signering avbrutt",
                "sv_SE": "Signering avbruten"
            },
            "settings_welcome": {
                "en_EN": "Welcome text",
                "nb_NO": "Velkomstmelding",
                "sv_SE": "Välkomnstmeddelande"
            },
            "settings_thank_you": {
                "en_EN": "Thank you message",
                "nb_NO": "Takkemelding",
                "sv_SE": "Tack meddelande"
            },
            "settings_email": {
                "en_EN": "Email",
                "nb_NO": "E-post",
                "sv_SE": "E-post"
            },
            "settings_email_editor": {
                "en_EN": "Email (fill out form)",
                "nb_NO": "E-post (fylle i skjema)",
                "sv_SE": "E-post (fyll i formuläret)"
            },
            "settings_email_sign": {
                "en_EN": "Email (sign)",
                "nb_NO": "E-post (signere)",
                "sv_SE": "E-post (signering)"
            },
            "settings_email_done": {
                "en_EN": "Email (Copy of signed document)",
                "nb_NO": "E-post (Kopi av signert dokument)"
            },
            "settings_general": {
                "en_EN": "General",
                "nb_NO": "Generelt",
                "sv_SE": "Generellt"
            },
            "settings_purpose": {
                "en_EN": "Purpose/Questions",
                "nb_NO": "Formål/Spørsmål",
                "sv_SE": "Syfte/frågor"
            },
            "settings_help_texts": {
                "en_EN": "Help texts",
                "nb_NO": "Hjelpetekster",
                "sv_SE": "Hjälptext"
            },
            "settings_landing_page": {
                "en_EN": "Landing page",
                "nb_NO": "Landingsside",
                "sv_SE": "Landningssida"
            },
            "settings_help_page": {
                "en_EN": "Help page",
                "nb_NO": "Hjelpeside",
                "sv_SE": "Hjälpsida"
            },
            "settings_copy_to": {
                "en_EN": "Send copy to",
                "nb_NO": "Send kopi til",
                "sv_SE": "Skicka kopia till"
            },
            "settings_sender": {
                "en_EN": "Sender",
                "nb_NO": "Avsender",
                "sv_SE": "Avsändare"
            },
            "settings_subject": {
                "en_EN": "Subject",
                "nb_NO": "Emne",
                "sv_SE": "Ämne"
            },
            "settings_greeting": {
                "en_EN": "Greeting",
                "nb_NO": "Hilsen",
                "sv_SE": "Hälsning"
            },
            "settings_message": {
                "en_EN": "Message",
                "nb_NO": "Melding",
                "sv_SE": "Meddelande"
            },
            "settings_button_text": {
                "en_EN": "Button text",
                "nb_NO": "Knappetekst"
            },
            "settings_help_text": {
                "en_EN": "Help text",
                "nb_NO": "Hjelpetekst",
                "sv_SE": "Hjälptext"
            },
            "settings_contact": {
                "en_EN": "Contact info",
                "nb_NO": "Kontaktinfo",
                "sv_SE": "Kontaktinformation"
            },
            "settings_help_link": {
                "en_EN": "Text for link to help page",
                "nb_NO": "Tekst for link til hjelpeside",
                "sv_SE": "Text för länk till hjälpsidan"
            },
            "settings_custom_sender": {
                "en_EN": "Custom sender",
                "nb_NO": "Fast avsender"
            },
            "settings_custom_sender_use": {
                "en_EN": "Use custom sender",
                "nb_NO": "Bruk fast avsender"
            },
            "settings_dynamic_info": {
                "en_EN": "<h2>Dynamic values</h2><p>By using the double opening and closing brackets '{{' and '}}', the system will replace these keywords with the appropriate value when an email/SMS is sent.</p><p>For example '{{firstName}}' will be replaced with the recipients actual first name in the email.</p><p></p><p><strong>List over available keywords:</strong></p><p></p><ul><li><p>{{firstName}} - Will be replaced with the recipients FIRST name</p></li><li><p>{{lastName}} - Will be replaced with the recipients LAST name</p></li><li><p>{{customerName}} - Will be replaced with the recipients company name (if available)</p></li><li><p>{{companyName}} - Will be replaced with your company name</p></li><li><p>{{senderName}} - Will be replaced with the name of the logged in users name (you)</p></li><li><p>{{senderEmail}} - Will be replaced with the name of the logged in users email (you)</p></li></ul><p></p><p></p>",
                "nb_NO": ""
            },
            "fr_delete_input": {
                "en_EN": "Delete input",
                "nb_NO": "Slett felt",
                "sv_SE": "Radera fält"
            },
            "fr_delete_input_prompt": {
                "en_EN": "Are you sure you want to delete this input?",
                "nb_NO": "Er du sikker på at du vil slette dette feltet?",
                "sv_SE": "Är du säker på att du vill radera detta fält?"
            },
            "fr_localized_text": {
                "en_EN": "Localized text",
                "nb_NO": "Lokalisert tekst",
                "sv_SE": "Lokaliserad text"
            },
            "company_aml_pending": {
                "en_EN": "Perform a search on the company with BankID AML",
                "nb_NO": "Gjør et søk på foretaket med BankID AML",
                "sv_SE": "Utför en sökning på företaget med BankID AML"
            },
            "company_aml_complete": {
                "en_EN": "BankID AML search on company completed",
                "nb_NO": "BankID AML søk på foretaket utført",
                "sv_SE": "BankID AML-sökning på företag slutförd"
            },
            "company_se_complete": {
                "en_EN": "Company search completed",
                "nb_NO": "Selskapssøk utført",
                "sv_SE": "Företagssökning utförd"
            },
            "company_se_complete_sub": {
                "en_EN": "Data fetched from Trapets/Bisnode",
                "nb_NO": "Data hentet fra Trapets/Bisnode",
                "sv_SE": "Data hämtad från Trapets/Bisnode"
            },
            "company_kyc_pending": {
                "en_EN": "Send out self-declaration form",
                "nb_NO": "Send ut egenerklæringsskjema",
                "sv_SE": "Skicka ut kundkännedomsformulär"
            },
            "company_kyc_progress": {
                "en_EN": "Waiting for self-declaration form to be complated",
                "nb_NO": "Venter på fullførelse av egenerklæringsskjema",
                "sv_SE": "Väntar på att kundkännedom ska kompletteras"
            },
            "company_kyc_complete": {
                "en_EN": "Self-declaration form completed",
                "nb_NO": "Egenerklæringsskjema fullført",
                "sv_SE": "Självdeklaration för slutförd"
            },
            "company_per_pending": {
                "en_EN": "Control and assess key roles in the company",
                "nb_NO": "Kontroller nøkkelroller i foretaket",
                "sv_SE": "Kontrollera och bedöm nyckelroller i företaget"
            },
            "company_per_complete": {
                "en_EN": "Control and assess key roles in the company",
                "nb_NO": "Kontroller nøkkelroller i foretaket",
                "sv_SE": "Kontrollera och bedöm nyckelroller i företaget"
            },
            "company_rep_pending": {
                "en_EN": "Create the final report",
                "nb_NO": "Lag en sluttrapport/risikovurdering",
                "sv_SE": "Skapa slutrapport/riskbedömning"
            },
            "company_rep_complete": {
                "en_EN": "Final report created",
                "nb_NO": "Sluttrapport laget",
                "sv_SE": "Slutrapport skapad"
            },
            "custom_approve_pending": {
                "en_EN": "Send for approval (optional)",
                "nb_NO": "Send til godkjenning (valgfritt)",
                "sv_SE": "Skicka för godkännande (valfritt)"
            },
            "custom_approve_hint": {
                "en_EN": "Send the collected information to LCSP for review/approval, if it is not certain that the information is correct.",
                "nb_NO": "Send den innsamlede informasjonen til LCSP for gjennomgang/godkjenning, hvis det er usikkerhet om informasjonen er riktig.",
                "sv_SE": "Skicka den insamlade informationen till LCSP för granskning/godkännande, om det inte är säkert att informationen är korrekt."
            },
            "custom_approve_help": {
                "en_EN": "<p>Send the collected information to LCSP for review/approval, if it is not certain that the information is correct.</p>",
                "nb_NO": "<p>Send den innsamlede informasjonen til LCSP for gjennomgang/godkjenning, hvis det er usikkerhet om informasjonen er riktig.</p>",
                "sv_SE": "<p>Skicka den insamlade informationen till LCSP för granskning/godkännande, om det inte är säkert att informationen är korrekt.</p>"
            },
            "custom_imanage_pending": {
                "en_EN": "Save the report to iManage",
                "nb_NO": "Lagre rapporten i iManage",
                "sv_SE": "Spara rapporten i iManage"
            },
            "custom_forward_pending": {
                "en_EN": "Send the report to the team (optional)",
                "nb_NO": "Send rapporten til teamet (valgfritt)",
                "sv_SE": "Skicka rapporten till teamet (valfritt)"
            },
            "o_person_idc_pending_head": {
                "en_EN": "Perform ID-control",
                "nb_NO": "Utfør ID-kontroll",
                "sv_SE": "Utför ID-kontroll"
            },
            "o_person_idc_pending_info": {
                "en_EN": "Send an email with an invitation to the ID-control. The recipient log in with BankID and is authenticated.",
                "nb_NO": "Send en epost med invitasjon til ID-kontroll. Mottaker følger linken i eposten og autentiserer seg med BankID.",
                "sv_SE": "Skicka ett mejl med en inbjudan till ID-kontrollen. Mottagaren loggar in med BankID och autentiseras."
            },
            "o_person_idc_pending_tt": {
                "en_EN": "<p>Send an email with an invitation to the ID-control. The recipient log in with BankID and is authenticated.</p>",
                "nb_NO": "<p>Send en epost med invitasjon til ID-kontroll. Mottaker følger linken i eposten og autentiserer seg med BankID.</p>",
                "sv_SE": "<p>Skicka ett mejl med en inbjudan till ID-kontrollen. Mottagaren loggar in med BankID och verifieras.</p>"
            },
            "o_person_pep_pending_head": {
                "en_EN": "Perform PEP/Sanction-search",
                "nb_NO": "Utfør PEP/Sanksjonssøk",
                "sv_SE": "Utför PEP/Sanctionsökning"
            },
            "o_person_pep_pending_info": {
                "en_EN": "Search with BankID AML against international sanction-lists and nordic PEP-lists.",
                "nb_NO": "Søker på personen med BankID AML mot internasjonale sankjsonslister og nordiske PEP-lister.",
                "sv_SE": "Sök med BankID AML mot internationella sanktionslistor och nordiska PEP-listor. "
            },
            "o_person_pep_pending_tt": {
                "en_EN": "<p>Perform PEP/Sanction-search.</p>",
                "nb_NO": "<p>Utfør PEP/Sanksjonssøk.</p>",
                "sv_SE": "Utför PEP/Sanctionsökning"
            },
            "o_person_rep_pending_head": {
                "en_EN": "Create a final report",
                "nb_NO": "Lag sluttrapport/risikovurdering",
                "sv_SE": "Skapa slutrapport/riskutvärdering"
            },
            "o_person_rep_pending_info": {
                "en_EN": "Look through the collected information and set a risk assessment, then generate a final report for this customer.",
                "nb_NO": "Gå gjennom innsamlet informasjon og sett en risikovurdering, så genereres det en sluttrapport for kunden.",
                "sv_SE": "Gå igenom den insamlade informationen och sätt en riskbedömning och skapa sedan en slutrapport för denna kund."
            },
            "o_person_rep_pending_tt": {
                "en_EN": "<p>Look through the collected information and set a risk assessment, then generate a final report for this customer.</p>",
                "nb_NO": "<p>Gå gjennom innsamlet informasjon og sett en risikovurdering, så genereres det en sluttrapport for kunden.</p>",
                "sv_SE": "<p>Gå igenom den insamlade informationen och sätt en riskbedömning och skapa sedan en slutrapport för denna kund.</p>"
            },
            "fileupload_contents": {
                "en_EN": "Describe this file?",
                "nb_NO": "Hva er denne filen?",
                "sv_SE": "Beskriv denna fil?"
            },
            "fileupload_contents_hint": {
                "en_EN": "*Please select the contents of this file",
                "nb_NO": "*Vennligst velg innhold i denne filen",
                "sv_SE": "*Välj innehållet i den här filen"
            },
            "method_help_title": {
                "en_EN": "Info about signing methods",
                "nb_NO": "Hjelp for signeringsmetoder",
                "sv_SE": "Information om signeringsmetoder"
            },
            "method_bankidno_head": {
                "en_EN": "BankID Norway",
                "nb_NO": "BankID Norge",
                "sv_SE": "BankID Norge"
            },
            "method_bankidno_help": {
                "en_EN": "Use your Norwegian BankID-chip or BankID on Mobile.",
                "nb_NO": "Bruk din norske brikke eller BankID på Mobil.",
                "sv_SE": "Använd ditt norska BankID-chip eller BankID på mobil."
            },
            "method_bankidse_head": {
                "en_EN": "BankID Sweden",
                "nb_NO": "BankID Sverige",
                "sv_SE": "BankID Sverige"
            },
            "method_bankidse_help": {
                "en_EN": "Use your Swedish BankID on mobile or file.",
                "nb_NO": "Bruk din svenske BankID på mobil eller fil.",
                "sv_SE": "Använd ditt svenska BankID på mobil eller fil"
            },
            "method_nemidnets_head": {
                "en_EN": "NemID Denmark",
                "nb_NO": "NemID Danmark",
                "sv_SE": "NemID Danmark"
            },
            "method_nemidnets_help": {
                "en_EN": "Use your Danish NemID.",
                "nb_NO": "Bruk din danske NemID.",
                "sv_SE": "Använd ditt danska NemID"
            },
            "method_touchsign_head": {
                "en_EN": "TouchSign",
                "nb_NO": "TouchSign",
                "sv_SE": "TouchSign"
            },
            "method_touchsign_help": {
                "en_EN": "If you do not have any of the above methods available, you can select Touchsign and use your finger on PC or pointer on mobile to draw your signature.",
                "nb_NO": "Hvis du ikke har noen av metodene over tilgjengelig, kan du velge TouchSign og bruke musepekeren på PC eller fingeren på mobil til å tegne din signatur.",
                "sv_SE": "Om du inte har någon av ovanstående metoder tillgängliga, kan du välja Touchsign och använda fingret på datorn eller pekaren på mobilen för att rita din signatur."
            },
            "method_passreader_head": {
                "en_EN": "Passport Reader",
                "nb_NO": "Passleser",
                "sv_SE": "Passport Reader"
            },
            "method_passreader_help": {
                "en_EN": "Use an app on your smartphone to read the digital chip on your passport.",
                "nb_NO": "Bruk en app på din smarttelefon for å lese den digitale chippen i passet ditt.",
                "sv_SE": "Använd en app på din smartphone för att läsa det digitala chippet på ditt pass."
            },
            "aml_pdf_title": {
                "en_EN": "Receipt for company search",
                "nb_NO": "Kvittering for foretakssøk",
                "sv_SE": "Kvitto för företagssökning"
            },
            "pep_pdf_title": {
                "en_EN": "Receipt for PEP/Sanction search",
                "nb_NO": "Kvittering for PEP/Sanksjonssøk",
                "sv_SE": "Kvitto för PEP/sanktionssökning"
            },
            "pep_pdf_search_params": {
                "en_EN": "Search parameters",
                "nb_NO": "Søkeparametere",
                "sv_SE": "Sökparametrar"
            },
            "pep_pdf_pep_header": {
                "en_EN": "Politically exposed person",
                "nb_NO": "Politisk eksponert person",
                "sv_SE": "Politiskt utsatt person"
            },
            "pep_pdf_pep_empty": {
                "en_EN": "No hits for politically exposed person",
                "nb_NO": "Ingen treff for politisk eksponert person",
                "sv_SE": "Inga träffar för politiskt utsatt person"
            },
            "pep_pdf_sanction_header": {
                "en_EN": "Sanction lists",
                "nb_NO": "Sanksjonslister",
                "sv_SE": "Sanktionslistor"
            },
            "pep_pdf_sanction_empty": {
                "en_EN": "No hits in sanction lists",
                "nb_NO": "Ingen treff i sanksjonslister",
                "sv_SE": "Inga träffar i sanktionslistorna"
            },
            "pep_pdf_lists": {
                "en_EN": "The following lists has been searched",
                "nb_NO": "Det er søkt mot følgende lister",
                "sv_SE": "Följande listor har sökts igenom"
            },
            "pep_pdf_company_roles": {
                "en_EN": "Company roles",
                "nb_NO": "Selskapsroller",
                "sv_SE": "Företagsroller"
            },
            "pep_pdf_provider": {
                "en_EN": "Search provider",
                "nb_NO": "Søketjeneste",
                "sv_SE": "Sök tjänst"
            },
            "pep_pdf_user": {
                "en_EN": "Search performed by",
                "nb_NO": "Søk utført av",
                "sv_SE": "Sökning utförd av"
            },
            "pep_pdf_firm": {
                "en_EN": "Search performed in relation to role in firm",
                "nb_NO": "Søk utført i forbindelse med rolle i foretak",
                "sv_SE": "Sökning utförd i förhållande till roll i företag"
            },
            "pep_risk_auto_high": {
                "en_EN": "Risk is automatically set to high because of a hit on PEP or sanction.",
                "nb_NO": "Risikovurdering er automatisk satt til høy fordi det er treff på PEP eller sanksjon.",
                "sv_SE": "Risken sätts automatiskt till hög på grund av en träff på PEP eller sanktion."
            },
            "datepicker_select_decade": {
                "en_EN": "Select decade",
                "nb_NO": "Velg tiår",
                "sv_SE": "Välj årtionde"
            },
            "datepicker_select_year": {
                "en_EN": "Select year",
                "nb_NO": "Velg år",
                "sv_SE": "Välj år"
            },
            "datepicker_select_month": {
                "en_EN": "Select month",
                "nb_NO": "Velg måned",
                "sv_SE": "Välj månad"
            },
            "datepicker_select_date": {
                "en_EN": "Select date",
                "nb_NO": "Velg dato",
                "sv_SE": "Välj datum"
            },
            "datepicker_from": {
                "en_EN": "From",
                "nb_NO": "Fra",
                "sv_SE": "Från"
            },
            "datepicker_to": {
                "en_EN": "To",
                "nb_NO": "Til",
                "sv_SE": "Till"
            },
            "sort": {
                "en_EN": "Sort:",
                "nb_NO": "Sortere:",
                "sv_SE": "Sortera"
            },
            "sort_last_updated": {
                "en_EN": "Last updated",
                "nb_NO": "Sist oppdatert",
                "sv_SE": "Sist uppdaterad"
            },
            "sort_last_created": {
                "en_EN": "Date created",
                "nb_NO": "Dato opprettet",
                "sv_SE": "Skapat datum"
            },
            "sort_name": {
                "en_EN": "Name",
                "nb_NO": "Navn",
                "sv_SE": "Namn"
            },
            "econ_key_info": {
                "en_EN": "Financial key information",
                "nb_NO": "Økonimisk nøkkelinformasjon",
                "sv_SE": "Finansiell nyckelinformation"
            },
            "econ_accountant": {
                "en_EN": "Accountant",
                "nb_NO": "Regnskapsfører",
                "sv_SE": "Revisor"
            },
            "econ_auditor": {
                "en_EN": "Auditor",
                "nb_NO": "Revisor",
                "sv_SE": "Revisor"
            },
            "econ_accounting_years": {
                "en_EN": "Accounting years",
                "nb_NO": "Regnskapsår",
                "sv_SE": "Redovisningsår"
            },
            "econ_income_statement": {
                "en_EN": "Income statement",
                "nb_NO": "Resultatregnskap",
                "sv_SE": "Resultaträkning"
            },
            "econ_balance_sheet": {
                "en_EN": "Balance sheet",
                "nb_NO": "Balanseregnskap",
                "sv_SE": "Balansräkning"
            },
            "econ_sales_revenues": {
                "en_EN": "Sales revenues",
                "nb_NO": "Salgsinntekter",
                "sv_SE": "Försäljningsintäkter"
            },
            "econ_other_revenues": {
                "en_EN": "Other revenues",
                "nb_NO": "Annen driftsinntekt",
                "sv_SE": "Övriga intäkter"
            },
            "econ_total_revenues": {
                "en_EN": "Total revenues",
                "nb_NO": "Total inntekt",
                "sv_SE": "Totala intäkter"
            },
            "econ_cost_of_goods_sold": {
                "en_EN": "Cost of goods sold",
                "nb_NO": "Varekostnad",
                "sv_SE": "Kostnad för sålda varor"
            },
            "econ_inventory_changes": {
                "en_EN": "Inventory changes",
                "nb_NO": "Beholdningsendringer",
                "sv_SE": "Lagerförändringar"
            },
            "econ_salary_costs": {
                "en_EN": "Salary costs",
                "nb_NO": "Lønnskostnader",
                "sv_SE": "Lönekostnader"
            },
            "econ_financial_costs": {
                "en_EN": "Financial costs",
                "nb_NO": "Andre finanskostnader",
                "sv_SE": "Finansiella kostnader"
            },
            "econ_depreciations": {
                "en_EN": "Depreciations",
                "nb_NO": "Nedskrivninger",
                "sv_SE": "Avskrivningar"
            },
            "econ_amortizations": {
                "en_EN": "Amortizations",
                "nb_NO": "Ordinære avskrivninger",
                "sv_SE": "Avskrivningar"
            },
            "econ_other_operating_costs": {
                "en_EN": "Other operating costs",
                "nb_NO": "Andre driftskostnader",
                "sv_SE": "Övriga driftskostnader"
            },
            "econ_operating_profits": {
                "en_EN": "Operating profits",
                "nb_NO": "Driftsresultat",
                "sv_SE": "Rörelseresultat"
            },
            "econ_ordinary_profits": {
                "en_EN": "Ordinary profits",
                "nb_NO": "Ordinært resultat",
                "sv_SE": "Vanliga vinster"
            },
            "econ_extraordinary_revenues": {
                "en_EN": "Extraordinary revenues",
                "nb_NO": "Ekstraordinære inntekter",
                "sv_SE": "Extraordinära intäkter"
            },
            "econ_extraordinary_costs": {
                "en_EN": "Extraordinary costs",
                "nb_NO": "Ekstraordinære kostnader",
                "sv_SE": "Extra kostnader"
            },

            "econ_sum_other_financial_income": {
                "en_EN": "Sum other financial income",
                "nb_NO": "Andre finansinntekter",
                "sv_SE": ""
            },
            "econ_sum_financial_income": {
                "en_EN": "Sum financial income",
                "nb_NO": "Sum finansinntekter",
                "sv_SE": ""
            },

            "econ_minority_interests": {
                "en_EN": "Minority interests",
                "nb_NO": "Minioritetens andel",
                "sv_SE": "Minoritets intressen"
            },
            "econ_taxes": {
                "en_EN": "Taxes",
                "nb_NO": "Skatt",
                "sv_SE": "Skatt"
            },
            "econ_result_before_tax": {
                "en_EN": "Result before tax",
                "nb_NO": "Resultat før skatt",
                "sv_SE": "Resultat före skatt"
            },
            "econ_net_profits": {
                "en_EN": "Net profits",
                "nb_NO": "Årsresultat",
                "sv_SE": "Nettointäkter"
            },
            "econ_current_assets": {
                "en_EN": "Current assets",
                "nb_NO": "Sum omløpsmidler",
                "sv_SE": "Nuvarande tillgångar"
            },
            "econ_fixed_assets": {
                "en_EN": "Fixed assets",
                "nb_NO": "Anleggsmidler",
                "sv_SE": "Anläggningstillgångar"
            },
            "econ_sum_assets": {
                "en_EN": "Sum assets",
                "nb_NO": "Sum eiendeler",
                "sv_SE": "Summa tillgångar"
            },
            "econ_equity": {
                "en_EN": "Equity",
                "nb_NO": "Egenkapital",
                "sv_SE": "Rättvisa"
            },
            "econ_debt": {
                "en_EN": "Debt",
                "nb_NO": "Sum gjeld",
                "sv_SE": "Skuld"
            },
            "econ_sum_equity_and_debt": {
                "en_EN": "Sum equity and debt",
                "nb_NO": "Sum egenkapital og lån",
                "sv_SE": "Summa eget kapital och skuld"
            },
            "shareapp": {
                "en_EN": "Share application form",
                "nb_NO": "Tegningsblankett"
            },
            "shareapp_tab_title": {
                "en_EN": "Share applications",
                "nb_NO": "Tegningsblanketter"
            },
            "shareapp_filter": {
                "en_EN": "Share application",
                "nb_NO": "Tegningsblankett"
            },
            "shareapp_none": {
                "en_EN": "Not sent",
                "nb_NO": "Ikke sendt"
            },
            "shareapp_tags": {
                "en_EN": "Project name",
                "nb_NO": "Prosjektnavn"
            },
            "shareapp_new": {
                "en_EN": "New share application",
                "nb_NO": "Ny tegningsblankett"
            },
            "shareapp_empty": {
                "en_EN": "No share applications",
                "nb_NO": "Ingen tegningsblanketter"
            },
            "shareapp_title": {
                "en_EN": "Share application form and power of attorney",
                "nb_NO": "Tegningsblankett og fullmakt"
            },
            "shareapp_step_upload": {
                "en_EN": "Upload share application form",
                "nb_NO": "Last opp tegningsblankett"
            },
            "shareapp_step_recipient": {
                "en_EN": "Select recipient",
                "nb_NO": "Velg mottaker"
            },
            "shareapp_step_preview": {
                "en_EN": "Share application",
                "nb_NO": "Tegningsblankett",
                "sv_SE": "Teckningsblankett"
            },
            "shareapp_step_form": {
                "en_EN": "Filled out by the drawer",
                "nb_NO": "Fylles ut av tegneren"
            },
            "shareapp_step_checkout": {
                "en_EN": "Signing",
                "nb_NO": "Signering"
            },
            "shareapp_send_out": {
                "en_EN": "Send",
                "nb_NO": "Send ut"
            },
            "shareapp_welcome": {
                "en_EN": "Welcome",
                "nb_NO": "Velkommen"
            },
            "shareapp_sign": {
                "en_EN": "Sign",
                "nb_NO": "Signering"
            },
            "shareapp_input_header": {
                "en_EN": "Filled out by the drawer",
                "nb_NO": "Fylles ut av tegneren"
            },
            "shareapp_input_project": {
                "en_EN": "Name of project company",
                "nb_NO": "Navn prosjektselskap"
            },
            "shareapp_input_price": {
                "en_EN": "Share price",
                "nb_NO": "Tegningskurs"
            },
            "shareapp_input_minimum": {
                "en_EN": "Minimum amount",
                "nb_NO": "Minimum beløp"
            },
            "shareapp_input_name": {
                "en_EN": "Drawers name",
                "nb_NO": "Tegnerens navn"
            },
            "shareapp_input_identity": {
                "en_EN": "SSN or organization number",
                "nb_NO": "Fnr eller org nr"
            },
            "shareapp_input_shares1": {
                "en_EN": "Drawing number of shares a NOK ",
                "nb_NO": "Tegner antall aksjer a kr. "
            },
            "shareapp_input_shares2": {
                "en_EN": ",- (minimum NOK ",
                "nb_NO": ",- (minimum kr "
            },
            "shareapp_input_shares3": {
                "en_EN": ")",
                "nb_NO": ")"
            },
            "shareapp_input_amount": {
                "en_EN": "Sum NOK",
                "nb_NO": "Beløp"
            },
            "shareapp_checkout_header": {
                "en_EN": "Signing",
                "nb_NO": "Signering"
            },
            "shareapp_checkout_understood": {
                "en_EN": "I have read and understood the contents of the share application in step 2",
                "nb_NO": "Jeg har lest og forstått innholdet i tegningsblanketten på steg 2"
            },
            "shareapp_checkout_method": {
                "en_EN": "Select signing method",
                "nb_NO": "Velg signeringsmetode"
            },
            "shareapp_checkout_start": {
                "en_EN": "Start signing process",
                "nb_NO": "Start signering"
            },
            "shareapp_help_o_upload_1_header": {
                "en_EN": "Upload share application form",
                "nb_NO": "Last opp tegningsblankett"
            },
            "shareapp_help_o_upload_1_text": {
                "en_EN": "Upload the completed share application form (first part) as a PDF.",
                "nb_NO": "Last opp den ferdige tegningsblanketten (første del) som en PDF."
            },
            "shareapp_help_o_recipient_1_header": {
                "en_EN": "Select recipient",
                "nb_NO": "Velg mottaker"
            },
            "shareapp_help_o_recipient_1_text": {
                "en_EN": "Select the recipient that will fill out the last part and sign the form.",
                "nb_NO": "Velg mottakeren (tegneren) som skal fylle ut siste del og signere tegningsblanketten."
            },
            "shareapp_help_e_preview_1_header": {
                "en_EN": "Share application",
                "nb_NO": "Tegningsblankett"
            },
            "shareapp_help_e_preview_1_text": {
                "en_EN": "Read through part 1 of the share application form (filled by Pangea).",
                "nb_NO": "Les gjennom del 1 av tegningsblanketten (fylt ut av Pangea)."
            },
            "shareapp_help_e_form_1_header": {
                "en_EN": "Filled out by the drawer",
                "nb_NO": "Fylles ut av tegneren"
            },
            "shareapp_help_e_form_1_text": {
                "en_EN": "Fill in the amount of shares.",
                "nb_NO": "Fyll inn ønsket antall aksjer."
            },
            "shareapp_help_e_form_2_header": {
                "en_EN": "Signing",
                "nb_NO": "Signering"
            },
            "shareapp_help_e_form_2_text": {
                "en_EN": "The share application form is signed digitally.",
                "nb_NO": "Tegningsblanketten signeres digitalt."
            },
            "shareapp_error_upload": {
                "en_EN": "You have to upload the document first",
                "nb_NO": "Du må laste opp tegningsblanketten først"
            },
            "shareapp_error_recipient": {
                "en_EN": "You have to select a recipient first",
                "nb_NO": "Du må velge mottaker først"
            },
            "shareapp_error_downloading": {
                "en_EN": "Waiting for download of share application",
                "nb_NO": "Venter på nedlasting av tegningsblankett"
            },
            "shareapp_error_fill_out": {
                "en_EN": "Please fill out all required fields first",
                "nb_NO": "Fyll i alle påkrevde felter først"
            },
            "shareapp_error_signer": {
                "en_EN": "Specify the person(s) that will sign the form",
                "nb_NO": "Velg hvem som skal signere skjemaet"
            },
            "shareapp_email_editor_subject": {
                "tt": false,
                "en_EN": "Share application {{projectName}}",
                "nb_NO": "Tegningsblankett {{projectName}}"
            },
            "shareapp_email_editor_header": {
                "tt": false,
                "en_EN": "Hi {{firstName}} {{lastName}}",
                "nb_NO": "Hei {{firstName}} {{lastName}}"
            },
            "shareapp_email_editor_message": {
                "tt": false,
                "en_EN": "You have been invited by {{companyName}} to fill out a share application form for ordering of shares in {{projectName}}.",
                "nb_NO": "Du er invitert av {{companyName}} til å fylle ut tegningsblankett og fullmakt for bestilling av aksjer i {{projectName}}."
            },
            "shareapp_email_editor_hint": {
                "tt": false,
                "en_EN": "Press the button to open the form and start filling it out",
                "nb_NO": "Trykk på knappen for å åpne skjemaet og starte utfyllingen"
            },
            "shareapp_email_editor_button": {
                "tt": false,
                "en_EN": "CONTINUE",
                "nb_NO": "GÅ VIDERE"
            },
            "shareapp_email_editor_footer": {
                "tt": false,
                "en_EN": "If you have any questions, please contact {{senderName}} on {{senderEmail}}",
                "nb_NO": "Ved spørsmål, kontakt {{senderName}} på {{senderEmail}}"
            },
            "shareapp_email_editor_link": {
                "tt": false,
                "en_EN": "here",
                "nb_NO": "her"
            },
            "shareapp_email_signer_subject": {
                "tt": false,
                "en_EN": "Share application {{projectName}} ready for {{action}}",
                "nb_NO": "Tegningsblankett {{projectName}} klar for {{action}}"
            },
            "shareapp_email_signer_header": {
                "tt": false,
                "en_EN": "Hi {{firstName}} {{lastName}}",
                "nb_NO": "Hei {{firstName}} {{lastName}}"
            },
            "shareapp_email_signer_message": {
                "tt": false,
                "en_EN": "You have been invited by {{companyName}} to {{actionVerb}} the following documents:",
                "nb_NO": "Du har blitt invitert av {{companyName}} til å {{actionVerb}} følgende dokumenter:"
            },
            "shareapp_email_signer_hint": {
                "tt": false,
                "en_EN": "Start the signing process by pressing the above button",
                "nb_NO": "Start signeringen ved å trykke på knappen over"
            },
            "shareapp_email_signer_button": {
                "tt": false,
                "en_EN": "CONTINUE",
                "nb_NO": "GÅ VIDERE"
            },
            "shareapp_email_signer_footer": {
                "tt": false,
                "en_EN": "If you have any questions, please contact {{senderName}} on {{senderEmail}}",
                "nb_NO": "Ved spørsmål, kontakt {{senderName}} på {{senderEmail}}"
            },
            "shareapp_email_signer_link": {
                "tt": false,
                "en_EN": "here",
                "nb_NO": "her"
            },
            "shareapp_email_done_subject": {
                "tt": false,
                "en_EN": "Signed share application {{projectName}}",
                "nb_NO": "Signert tegningsblankett {{projectName}}"
            },
            "shareapp_email_done_header": {
                "tt": false,
                "en_EN": "Hi {{firstName}} {{lastName}}",
                "nb_NO": "Hei {{firstName}} {{lastName}}"
            },
            "shareapp_email_done_message": {
                "tt": false,
                "en_EN": "Here is your copy of the signed document",
                "nb_NO": "Her er din kopi av det signerte dokumentet"
            },
            "shareapp_email_done_hint": {
                "tt": false,
                "en_EN": "Click on the document name to download it for archiving",
                "nb_NO": "Trykk på navnet for å laste det ned for arkivering"
            },
            "shareapp_email_done_footer": {
                "tt": false,
                "en_EN": "If you have any questions, please contact {{senderName}} on {{senderEmail}}",
                "nb_NO": "Ved spørsmål, kontakt {{senderName}} på {{senderEmail}}"
            },
            "shareapp_pdf_name": {
                "tt": false,
                "en_EN": "Share application",
                "nb_NO": "Tegningsblankett"
            },
            "shareapp_pdf_title": {
                "tt": false,
                "en_EN": "Share application form and power of attorney",
                "nb_NO": "Tegningsblankett og fullmakt"
            },
            "shareapp_pdf_sub": {
                "tt": false,
                "en_EN": "Ordering of shares in ",
                "nb_NO": "Bestilling av aksjer i "
            },
            "shareapp_pdf_sent": {
                "tt": true,
                "en_EN": "Form sent by",
                "nb_NO": "Skjema sendt av"
            },
            "shareapp_pdf_filled": {
                "tt": true,
                "en_EN": "Form received and filled out by",
                "nb_NO": "Skjema mottatt og fylt ut av"
            },
            "shareapp_pdf_understood": {
                "tt": false,
                "en_EN": "I have read and understood the contents of the share application attached to this document",
                "nb_NO": "Jeg har lest og forstått innholdet i tegningsblanketten vedlagt dette dokumentet"
            },
            "shareapp_pdf_attachment": {
                "tt": false,
                "en_EN": "Attachment 1: Share application form part 1 (filled by Pangea)",
                "nb_NO": "Vedlegg 1: Tegningsblankett del 1 (fylt ut av Pangea)"
            },
            "shareapp_pdf_signatories": {
                "tt": false,
                "en_EN": "The recipient has chosen the following persons to sign the share application",
                "nb_NO": "Mottaker har angitt følgende personer som må signere tegningsblanketten"
            },
            "nb_tags": {
                "tt": true,
                "en_EN": "Internal status",
                "nb_NO": "Intern status",
                "sv_SE": "Intern status"
            },
            "company_info_header": {
                "en_EN": "Company information",
                "nb_NO": "Foretaksinformasjon",
                "sv_SE": "Företagsinformation"
            },
            "company_info_text": {
                "en_EN": "Basic information on the company, and signature rights and economy if available.",
                "nb_NO": "Grunnleggende informasjon om foretaket, samt signaturrett og regnskap hvis tilgjengelig.",
                "sv_SE": "Grundläggande information om företaget, samt underskriftsrättigheter och ekonomi om tillgängligt."
            },
            "company_head_sign_rights": {
                "en_EN": "Signature rights",
                "nb_NO": "Signaturrett",
                "sv_SE": "Underskriftsrättigheter"
            },
            "company_head_economy": {
                "en_EN": "Economy",
                "nb_NO": "Økonomi",
                "sv_SE": "Ekonomi"
            },
            "sr_alternatives": {
                "en_EN": "Options",
                "nb_NO": "Alternativer",
                "sv_SE": "Alternativ"
            },
            "sr_alternative": {
                "en_EN": "Option",
                "nb_NO": "Alternativ",
                "sv_SE": "Alternativ"
            },
            "sr_conclusive": {
                "en_EN": "CONCLUSIVE",
                "nb_NO": "CONCLUSIVE",
                "sv_SE": "AVGÖRANDE"
            },
            "sr_not_conclusive": {
                "en_EN": "Signature rights are not conclusive and no options can be presented. Check the description.",
                "nb_NO": "Signaturrett er ikke conclusive og ingen signerings-alternativer kan presenteres. Sjekk beskrivelsen.",
                "sv_SE": "Signaturrättigheter är inte avgörande och inga signeringsalternativ kan presenteras. Kontrollera beskrivningen"
            },
            "sr_description": {
                "en_EN": "Description",
                "nb_NO": "Beskrivelse",
                "sv_SE": "Beskrivning"
            },
            "sr_remarks": {
                "en_EN": "Remarks",
                "nb_NO": "Bemerkninger",
                "sv_SE": "Anmärkningar"
            },
            "sr_remarks_none": {
                "en_EN": "No remarks",
                "nb_NO": "Ingen bemerkninger",
                "sv_SE": "Inga anmärkningar"
            },
            "ki_info_baml_header": {
                "en_EN": "Ownership indicators",
                "nb_NO": "Eierstruktur-indikatorer",
                "sv_SE": "Indikatorer för ägarstruktur"
            },
            "ki_info_baml_text": {
                "en_EN": "These indicators give a general overview of the company and can indicate if the ownership is complicated or connected to industries one should be aware of.",
                "nb_NO": "Disse indikatorene gir et generelt bilde av selskapet og kan indikere om det er komplisert eller knyttet til bransjer man bør vær oppmerksom på.",
                "sv_SE": "Dessa indikatorer ger en allmän bild av företaget och kan ange om det är komplicerat eller relaterat till branscher man bör vara medveten om."
            },
            "ki_info_trap_header": {
                "en_EN": "Company ownership",
                "nb_NO": "Eierstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "ki_info_trap_text": {
                "en_EN": "Information on shareholders and beneficial owners.",
                "nb_NO": "Informasjon om aksjonærer og reelle rettighetshavere.",
                "sv_SE": "Information om aktieägare och verkliga huvudmän"
            },
            "ki_val_numberOfShareholdersTotal": {
                "en_EN": "Total number of shareholders",
                "nb_NO": "Totalt antall aksjonærer",
                "sv_SE": "Totalt antal aktieägare "
            },
            "ki_desc_numberOfShareholdersTotal": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Det totale antallet aksjonærer i det omspurte selskapet sin eierskapsstruktur, summen av fysiske personer og bedrifter som er eiere direkte eller indirekte.</p><p></p><p><h6>Kommentar</h6></p><p><em>Allerede her kan man si noe om kompleksitet. Høyt antall tilsier høyere kompleksitet</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Det totala antalet aktieägare i det undersökta företagets ägarstruktur, summan av fysiska personer och företag som är direkt eller indirekt ägare.</p><p></p><p><strong>Kommentar</strong></p><p><em>Redan här kan man säga något om komplexitet. Höga siffror indikerar högre komplexitet</em></p>"
            },
            "ki_val_numberOfShareholdersDirect": {
                "en_EN": "Number of direct shareholders",
                "nb_NO": "Antall direkte eiere",
                "sv_SE": "Antal direkta ägare"
            },
            "ki_desc_numberOfShareholdersDirect": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Antall bedrifter eller fysiske person som har en direkte eierandel i det omspurte selskapet.</p><p></p><p><h6>Kommentar</h6></p><p><em>Ved å sammenligne antall aksjonærer med antall direkte eiere, kan man se om det er mange som har et indirekte eierskap. Indirekte eierskap tilsier høyere kompleksitet.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Antal företag eller fysisk person som har ett direkt ägande i företaget i fråga.</p><p></p><p><strong>Kommentar</strong></p><p><em>Genom att jämföra antalet aktieägare med antalet direktägare kan man se om det finns många som har ett indirekt ägande. Indirekt ägande innebär högre komplexitet.</em></p>"
            },
            "ki_val_numberOfShareholdersLegal": {
                "en_EN": "Number of legal shareholders",
                "nb_NO": "Antall bedrifter med eierskap",
                "sv_SE": "Antal företag med ägande"
            },
            "ki_desc_numberOfShareholdersLegal": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Antall juridiske personer (bedrifter) i eierstrukturen.</p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Antal juridiska personer (företag) i ägarstrukturen.</p>"
            },
            "ki_val_ownershipNace": {
                "en_EN": "NACE overview",
                "nb_NO": "NACE-oversikt",
                "sv_SE": "NACE-översikt"
            },
            "ki_desc_ownershipNace": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Liste av NACE-koder for bedrifter i eierstrukturen, samt andel av integrert eierskap for hver av disse.</p><p></p><p><h6>Kommentar</h6></p><p><em>Noen bransjer er knyttet til spesiell risiko og bør følges spesielt med på. Denne indikatoren kan vise at enkelte av disse bransjene er representert.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Lista över NACE-koder för företag i ägarstrukturen, samt andelen integrerat ägande för var och en av dessa.</p><p></p><p><strong>Kommentar</strong></p><p><em>Vissa branscher är förknippade med särskild risk och bör ägnas särskild uppmärksamhet åt. Denna indikator kan visa att vissa av dessa branscher är representerade.</em></p>"
            },
            "ki_val_maxShareHolderDistance": {
                "en_EN": "Maximum shareholder distance",
                "nb_NO": "Antall aksjonærledd",
                "sv_SE": "Maximalt aktieägaravstånd"
            },
            "ki_desc_maxShareHolderDistance": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Maksimal avstand, i antall hopp, fra selskapet til en aksjonær.&nbsp;</p><p></p><p><h6>Kommentar</h6></p><p><em>Noen ganger er det en lang kjede av bedrifter som eier hverandre, og det kan være komplisert og tidkrevende å få overblikk over hele strukturen. Høyt antall aksjonærledd tilsier høy kompleksitet.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Maximalt avstånd, i antal hopp, från företaget till en aktieägare.&nbsp;</p><p></p><p><strong>Kommentar</strong></p><p><em>Ibland finns det en lång kedja av företag som äger varandra, och det kan vara komplicerat och tidskrävande att få en överblick över hela strukturen. Högt antal aktieägarlänkar indikerar hög komplexitet.</em></p>"
            },
            "ki_val_sumIdentifiedShareholders": {
                "en_EN": "Identified shares",
                "nb_NO": "Identifiserte eierandeler",
                "sv_SE": "Identifierade aktier"
            },
            "ki_desc_sumIdentifiedShareholders": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Identifiserte eierandeler er summen av eierandelene til</p><ol><li><p>Fysiske personer</p></li><li><p>Offentlige instanser</p></li><li><p>Offentlig eide selskaper som vi ikke har eierinformasjon på</p></li><li><p>Stiftelser</p></li></ol><p></p><p><h6>Kommentar</h6></p><p><em>Denne indikatoren viser i&nbsp;hvor stor grad kildene har kunnskap om&nbsp;hvem som er eiere. 100% tilsier at man har full kunnskap, men et lavere tall sier at man ikke vet hvem som har enkelte eierandeler, eller at man har for lite kunnskap om eierne til at de er 'identifisert'.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Identifierade innehav är summan av innehaven</p><ol><li><p>Fysiska personer</p></li><li><p>Offentliga instanser</p></li><li><p>Offentligt ägda företag där vi inte har ägarinformation</p></li><li><p>Stiftelser</p></li></ol><p></p><p><strong>Kommentar</strong></p><p><em>Denna indikator visar i&nbsp;i vilken utsträckning källorna har kunskap om&nbsp;vem är ägarna. 100% anger att du har full kunskap, men ett lägre antal säger att du inte vet vem som har vissa ägarintressen, eller att du har för lite kunskap om ägarna för att de ska kunna 'identifieras'.</em></p>"
            },
            "ki_val_sumUnidentifiedShareholders": {
                "en_EN": "Unidentified shares",
                "nb_NO": "Uidentifiserte eierandeler",
                "sv_SE": "Identifierade aktier"
            },
            "ki_desc_sumUnidentifiedShareholders": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Uidentifiserte entiteter er entiteter der kun navn er kjent, og vi ikke vet om det dreier seg om en fysisk eller juridisk person. Uidentifiserte aksjonærer er ofte utenlandske aksjonærer.</p><p></p><p><h6>Kommentar</h6></p><p><em>Det er vanlig å ønske å undersøke nærmere dersom store&nbsp;eierandeler er uidentifiserte. Den vanligste grunnen er at eieren er ukjent, og man derfor ikke kan følge sporet videre automatisk.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Oidentifierade enheter är enheter där endast namn är kända och vi vet inte om det är en fysisk eller juridisk person. Oidentifierade aktieägare är ofta utländska aktieägare. </p> <p> </p> <p> <strong> Kommentar </strong> </p> <p> <em> Det är vanligt att vilja undersöka ytterligare om stora & nbsp; innehav är oidentifierade. Den vanligaste orsaken är att ägaren är okänd, och du kan därför inte följa spåret längre automatiskt.</em></p>"
            },
            "ki_val_sumUnknownShareholders": {
                "en_EN": "Unknown shares",
                "nb_NO": "Ukjente eierandeler",
                "sv_SE": "Oidentifierade aktier"
            },
            "ki_desc_sumUnknownShareholders": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Eierandeler vi har lite eller ingen informasjon om. Ukjente eierandeler betyr at aksjonærregisteret ikke har informasjon om enkelte eierandeler.&nbsp;</p><p></p><p><h6>Kommentar</h6></p><p><em>Ukjente eierandeler gir en usikkerhet og man kan derfor ønske å undersøke tilfellene nærmere, særlig dersom andelene er store</em></p><p><em>Summen av identifiserte + uidentifiserte + ukjente = 100%</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Ägarskap som vi har liten eller ingen information om. Okända innehav innebär att aktieägarregistret inte har information om vissa innehav. & Nbsp; </p> <p> </p> <p> <strong> Kommentar </strong> </p> <p> <em> Okända innehav ger en osäkerhet och man kan därför vilja undersöka fallen ytterligare, särskilt om proportionerna är stora </em> </p> <p> <em> Summan av identifierade + oidentifierade + okända = 100%</em></p>"
            },
            "ki_val_numberOfUnidentifiedShareholders": {
                "en_EN": "Number of unidentified shareholders",
                "nb_NO": "Antall uidentifiserte aksjonærer",
                "sv_SE": "Antal oidentifierade aktier"
            },
            "ki_desc_numberOfUnidentifiedShareholders": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Dette tallet angir antallet aksjeposter som er uidentifiserte.</p><p></p><p><h6>Kommentar</h6></p><p><em>Om store andeler er uidentifisert, kan det være nyttig å vite om det er fordelt over flere aksjeposter, eller dreier seg om en enkelt eier.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Detta nummer anger antalet aktieinnehav som är oidentifierade. </p> <p> </p> <p> <strong> Kommentar </strong> </p> <p> <em> Om stora aktier är oidentifierade kan det vara bra att veta om det är fördelat på flera aktieinnehav eller handlar om en enskild ägare.</em></p>"
            },
            "ki_val_companySelfOwnership": {
                "en_EN": "Company's self-ownership",
                "nb_NO": "Selskapets eierskap i seg selv",
                "sv_SE": "Företagets egenägande "
            },
            "ki_desc_companySelfOwnership": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Prosentandel selskapet eier i seg selv, direkte og/eller indirekte. Dette inkluderer sirkulært eierskap via andre bedrifter.</p><p></p><p><h6>Kommentar</h6></p><p><em>Det kan være gode grunner til selveierskap og sirkulært eierskap, men det kan også brukes bevisst for å kamuflere hvem som egentlig har kontrollen. Noen ganger blir grupper av bedrifter med eierskap i hverandre, men med en enkelt fysisk person som eneste fysisk eier. Selv om denne personen har lav eierandel, og ikke kommer inn under noen 25%-regel, vil de i realiteten kunne kontrollere det omspurte selskapet.<br><br>Om selskapet har en grad av selveierskap eller sirkulært eierskap kan det&nbsp;vær grunn til å stille kunden spørsmål om hvorfor det er organisert på den måten.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Procentandel som företaget äger i sig själv, direkt och / eller indirekt. Detta inkluderar cirkulärt ägande genom andra företag. </p> <p> </p> <p> <strong> Kommentar </strong> </p> <p> <em> Det kan finnas goda skäl för självägande och cirkulärt ägande, men det kan också användas medvetet för att kamouflera vem som kontrollerar. Ibland blir företagsgrupper ägare till varandra, men med en enda fysisk person som ensam fysisk ägare. Även om den här personen har ett lågt ägarintresse och inte faller under någon 25% -regel, kommer de i själva verket att kunna kontrollera företaget i fråga.<br><br>Om företaget haer en grad av cirkulärt ägande kan det finnas & nbsp; att ställa frågor till kunden om varför det är organiserat på det sättet.</em></p>"
            },
            "ki_val_numberOfSelfOwnedShareholders": {
                "en_EN": "Number of self-owned shareholders",
                "nb_NO": "Antall eiere med vesentlig selveierskap",
                "sv_SE": "Antal ägare med betydande egenägare"
            },
            "ki_desc_numberOfSelfOwnedShareholders": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Antall eiere med over 10% integrert eierskap som har integrert eierskap i seg selv over 10%.</p><p>Denne indikatoren viser om det er noen bedrifter i eierskapstrukturen som har selveierskap. Små eierandeler eller liten grad av selveierskap regnes ikke med.</p><p></p><p><h6>Kommentar</h6></p><p><em>Selv om en bedrift ikke har selveierskap eller sirkulært eierskap kan det hende at&nbsp;en av eierne deres har det. Det vil også&nbsp;kunne kamuflere hvem som egentlig&nbsp;kontrollerer selskapet, men blir eksponert av denne indikatoren.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Antal ägare med mer än 10% integrerat ägande som har integrerat ägande i sig själva över 10%.</p><p>Denna indikator visar om det finns några företag i ägarstrukturen som har eget ägande.Små ägarintressen eller en liten grad av egenägande ingår inte.</p><p></p><p><strong>Kommentar</strong></p><p><em>Även om ett företag inte har ensam eller cirkulärt ägarskap kan & nbsp; en av deras ägare ha ett. Det kommer det också&nbsp;kunde kamouflera vem som verkligen&nbsp;kontrollerar företaget, men exponeras av denna indikator.</em></p>"
            },
            "ki_val_numberOfShareClasses": {
                "en_EN": "Number of share classes",
                "nb_NO": "Antall aksjeklasser",
                "sv_SE": "Antal andelsklasser"
            },
            "ki_desc_numberOfShareClasses": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Hvor mange aksjeklasser selskapet har.</p><p></p><p><h6>Kommentar</h6></p><p><em>Om et&nbsp;selskap&nbsp;bare har en&nbsp;aksjeklasser er det enkelt å finne ut hvem som kontrollerer det. Men om det er flere, kan det være&nbsp;nødvendig å sette seg inn hvordan stemmeretten knyttet til de ulike aksjeklassene er fordelt.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Hur många andelsklasser företaget har.</p><p></p><p><strong>Kommentar</strong></p><p><em>Om ett&nbsp;företag&nbsp;bara har en&nbsp;andelklasser är det lätt att ta reda på vem som styr den. Men om det finns fler kan det vara&nbsp;nödvändigt för att förstå hur rösträtten relaterad till de olika andelsklasserna fördelas.</em></p>"
            },
            "ki_val_numberOfShareholdersManyShareClasses": {
                "en_EN": "Number of significant owners with at least two share classes",
                "nb_NO": "Antall signifikante eiere som har minst to aksjeklasser",
                "sv_SE": "Antal betydande ägare som har minst två andelsklasser"
            },
            "ki_desc_numberOfShareholdersManyShareClasses": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Antall eiere med over 10% integrert eierskap som har minst to aksjeklasser.</p><p>Denne indikatoren viser om en&nbsp;stor&nbsp;eier har flere aksjeklasser.</p><p></p><p><h6>Kommentar</h6></p><p><em>Om større eiere har flere aksjeklasser, kan det være spesiell grunn til å undersøke stemmeretten knyttet til aksjeklassene.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Antal ägare med mer än 10% integrerat ägande som har minst två andelsklasser.</p><p>Denna indikator visar om en&nbsp;stor&nbsp;ägare har flera andelsklasser.</p><p></p><p><strong>Kommentar</strong></p><p><em>Om större ägare har flera andelsklasser kan det finnas särskilda skäl att undersöka rösträtten för aktieklasserna.</em></p>"
            },
            "ki_val_numberOfHighVpLowIntegrated": {
                "en_EN": "Number of owners with low ownership and high voting power",
                "nb_NO": "Antall eiere med lavt eierskap og høy innflytelse",
                "sv_SE": "Antal ägare med lågt ägande och stort inflytande"
            },
            "ki_desc_numberOfHighVpLowIntegrated": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Antall eiere med integrert eierskap under 25% og som har mer enn 49.8% bestemmelsesrett i selskapet.</p><p>Denne indikatoren viser om det finnes eiere som eier lite, men i realiteten har større kontroll enn andelen skulle tilsi.</p><p></p><p><h6>Kommentar</h6></p><p><em>Hvis en mindre eier er i vippeposisjon i et selskap kan de ha vesentlig større kontroll over selskapet enn eierandelen skulle tilsi, og blir ikke fanget opp&nbsp;som reell&nbsp;rettighetshaver av automatiske søk. Denne indikatoren fanger opp slike tilfeller, slik at man kan ta en nærmere kikk.</em></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Antal ägare med integrerat ägande under 25% och som har mer än 49,8% kontroll i företaget.</p><p>Den här indikatorn visar om det finns ägare som äger lite men i verkligheten har större kontroll än andelen skulle indikera. </p> <p> </p> <p> <strong> Kommentar </strong> </p> < p> <em> Om en mindre ägare är i en tippposition i ett företag kan de ha betydligt mer kontroll över företaget än ägarandelen skulle föreslå, och fångas inte & nbsp; som verkliga & nbsp; rättighetsinnehavare av automatiska sökningar. Denna indikator fångar in sådana fall så att du kan titta närmare på dem. </em> </p> "
            },
            "ki_val_shareHoldersHaveMultipleShareClasses": {
                "en_EN": "Shareholders have multiple share classes",
                "nb_NO": "Det finnes eiere som har flere aksjeklasser",
                "sv_SE": "Det finns ägare som har flera andelsklasser"
            },
            "ki_desc_shareHoldersHaveMultipleShareClasses": {
                "nb_NO": "<p><h6>Forklaring</h6></p><p>Avkrysset hvis det finnes eiere (bedrifter) som har flere enn én aksjeklasse.</p><p></p>",
                "sv_SE": "<p><strong>Förklaring</strong></p><p>Kontrollera om det finns ägare (företag) som har mer än en andelsklass.</p><p></p>"
            },
            "ki_head_beneficial": {
                "en_EN": "Beneficial owners",
                "nb_NO": "Reelle rettighetshavere",
                "sv_SE": "Verkliga huvudmän"
            },
            "ki_no_beneficial": {
                "en_EN": "No beneficial owners identified",
                "nb_NO": "Ingen reelle rettighetshavere identifisert",
                "sv_SE": "Inga verkliga huvudmän har identifierats"
            },
            "ki_head_indicators": {
                "en_EN": "Indicators",
                "nb_NO": "Indikatorer",
                "sv_SE": "Indikatorer"
            },
            "ki_head_key_indicators": {
                "en_EN": "Key indicators",
                "nb_NO": "Nøkkelindikatorer",
                "sv_SE": "Nyckeltal"
            },
            "ki_head_identified_shares": {
                "en_EN": "Identified shares",
                "nb_NO": "Identifiserte eierandeler",
                "sv_SE": "Identifierade innehav"
            },
            "ki_head_shareholders": {
                "en_EN": "Shareholders",
                "nb_NO": "Aksjonærer",
                "sv_SE": "Aktieägare"
            },
            "ki_head_self_ownership": {
                "en_EN": "Self ownership",
                "nb_NO": "Selveierskap",
                "sv_SE": "Självägande"
            },
            "ki_head_voting_power": {
                "en_EN": "Voting power",
                "nb_NO": "Bestemmelsesrett",
                "sv_SE": "Bestämmanderätt"
            },
            "ki_identified": {
                "en_EN": "Identified",
                "nb_NO": "Identifisert",
                "sv_SE": "Identifierad"
            },
            "ki_unidentified": {
                "en_EN": "Unidentified",
                "nb_NO": "Uidentifisert",
                "sv_SE": "Oidentifierad"
            },
            "ki_unknown": {
                "en_EN": "Unknown",
                "nb_NO": "Ukjent",
                "sv_SE": "Okänt"
            },
            "ki_val_beneficials_available": {
                "en_EN": "Data available",
                "nb_NO": "Data tilgjengelig",
                "sv_SE": "Data tillgänglig"
            },
            "ki_desc_beneficials_available": {
                "en_EN": "Is information on beneficial owners available from Bolagsverket",
                "nb_NO": "Er informasjon om reelle rettighetshavere tilgjengelig fra Bolagsverket",
                "sv_SE": "Finns information om riktiga verkliga huvudmän från Bolagsverket"
            },
            "ki_val_beneficials_suspiciuos": {
                "en_EN": "Suspicious ownership",
                "nb_NO": "Mistenkelig eierskap",
                "sv_SE": "Misstänkt ägande"
            },
            "ki_desc_beneficials_suspiciuos": {
                "en_EN": "Is the ownership of this company marked as susicious by Bolagsverket",
                "nb_NO": "Er eierskapet markert som mistenkelig av Bolagsverket",
                "sv_SE": "Är ägarskapet markerat som misstänkt av Bolagsverket"
            },
            "ki_missing_shareholder_data": {
                "en_EN": "Data is missing on this shareholder",
                "nb_NO": "Mangler data på denne aksjonæren",
                "sv_SE": "Uppgifter saknas om denna aktieägare"
            },
            "sorry_api_head": {
                "en_EN": "Verified platform",
                "nb_NO": "Verified plattform",
                "sv_SE": "Verified plattform"
            },
            "sorry_api_text": {
                "en_EN": "There are some technical challenges at the moment. It is recommended not to perform any search/send out forms.",
                "nb_NO": "Det er for øyeblikket tekniske utfordringer. Det anbefales å vente med å gjøre søk/sende ut skjema.",
                "sv_SE": "Det finns för närvarande tekniska utmaningar. Det rekommenderas att vänta med att söka / skicka ut formuläret."
            },
            "sorry_baml_head": {
                "en_EN": "BankID AML",
                "nb_NO": "BankID AML",
                "sv_SE": "BankID AML"
            },
            "sorry_baml_text": {
                "en_EN": "BankID AML or a third-party service is having technical difficulties. Screening/company-info might be unavailable.",
                "nb_NO": "BankID AML eller en underleverandør har tekniske utfordringer. Screening/selskapsinfo kan være utilgjengelig.",
                "sv_SE": "BankID AML eller en underleverantör har tekniska utmaningar. Screening/företagsinformation kan vara otillgänglig."
            },
            "sorry_details": {
                "en_EN": "Details",
                "nb_NO": "Detaljer",
                "sv_SE": "Detaljer"
            },
            "idc_short_link_1": {
                "en_EN": "<h3>An error occurred</h3><p>The link you have followed is not complete. This can happen if you are using an outdated email-client or web-browser. You can try to copy the link from the email, and paste it in a modern web-browser, like Google Chrome, Mozilla Firefox or the newest version of Microsoft Edge. Alternatively you can open the link from your mobile phone.</p><p></p><p>We are sorry for the inconvenience, and if none of the methods above work for you, please contact us for other alternatives.</p>",
                "nb_NO": "<h3>Det skjedde en feil</h3><p>Linken du har fulgt er ikke komplett. Dette kan skje hvis du bruker en utdatert epost-klient eller nettleser. Du kan prøve å kopiere linken fra eposten og lime inn i en moderne nettleser, f.eks. Google Chrome, Mozilla Firefox eller nyeste versjon av Microsoft Edge. Alternativt kan du også prøve å åpne linken fra din mobiltelefon.</p><p></p><p>Vi beklager ulempen, og hvis ingen av metodene over fungerer for deg, vennligst kontakt oss for andre altarnativer.</p>",
                "sv_SE": "<h3>Ett fel uppstod</h3><p>Länken du följde är inte komplett. Detta kan hända om du använder en föråldrad e-postklient eller webbläsare. Du kan försöka kopiera länken från e-postmeddelandet och klistra in den i en modern webbläsare, t.ex. Google Chrome, Mozilla Firefox eller den senaste versionen av Microsoft Edge. Alternativt kan du också försöka öppna länken från din mobiltelefon. </p> <p> </p> <p> Vi ber om ursäkt för besväret, och om ingen av ovanstående metoder fungerar för dig, kontakta oss för andra alternativ.</p>"
            },
            "signrights_filler_header": {
                "en_EN": "The following groups of people have rights to sign on behalf of the company",
                "nb_NO": "Velg hvem som skal signere på vegne av selskapet",
                "sv_SE": "..."
            },
            "signrights_filler_subheader": {
                "en_EN": "We found the following groups with rights to sign on behalf of the company. If it's not correct or missing persons, please fill them in manually.",
                "nb_NO": "Vi har hentet ut opplysninger om hvem som kan signere på vegne av selskapet. Dersom det ikke stemmer kan du velge å legge til personer manuelt.",
                "sv_SE": "..."
            },
            "signrights_owner_header": {
                "en_EN": "Options for who can sign",
                "nb_NO": "Signeringsalternativer",
                "sv_SE": "..."
            },
            "signrights_owner_override_checkbox": {
                "en_EN": "Allow the filler choose anyone to sign",
                "nb_NO": "Overstyr (La mottaker selv velge hvem som skal signere)",
                "sv_SE": "..."
            },
            "signrights_owner_options_description": {
                "en_EN": "The filler will be presented with the following options for who can sign:",
                "nb_NO": "Mottaker vil få presentert disse signeringsalternativene:",
                "sv_SE": "..."
            },
            "signrights_owner_no_options": {
                "en_EN": "No available options for who can sign. Filler will be prompted to add someone manually.",
                "nb_NO": "Ingen signeringsalternativer tilgjengelig, mottaker vil bli bedt om å legge til de som skal signere.",
                "sv_SE": "..."
            },
            "signrights_owner_override_text": {
                "en_EN": "Filler will be prompted to add someone manually.",
                "nb_NO": "Mottaker vil bli bedt om å legge til personer som skal signere på vegne av foretaket.",
                "sv_SE": "..."
            },
            "signrights_owner_override_message": {
                "en_EN": "Message for filler (instructions for who should sign)",
                "nb_NO": "Melding til mottaker (instruksjon på hvem som må signere)",
                "sv_SE": "..."
            },
            "signrights_owner_override_message_placeholder": {
                "en_EN": "Message for filler",
                "nb_NO": "Melding til mottaker",
                "sv_SE": "..."
            },
            "signrights_owner_option": {
                "en_EN": "Option",
                "nb_NO": "Alternativ",
                "sv_SE": "..."
            },
            "signrights_filler_signmethod": {
                "en_EN": "Sign using",
                "nb_NO": "Signeringsmetode",
                "sv_SE": "..."
            },
            "signrights_filler_no_options_header": {
                "en_EN": "Who has rights to sign on behalf of the company",
                "nb_NO": "Signaturrett kunne ikke bestemmes maskinelt",
                "sv_SE": "..."
            },
            "signrights_description_info_text": {
                "en_EN": "The following parties have rights to sign on behalf of the company:",
                "nb_NO": "Det kunne ikke bli bestemt noen signaturrett maskinelt, og det kunne heller ikke hentes en beskrivelse fra Brønnøysundregisteret. Venligst undersøk hvem som har signaturrett slik at dokumentet kan signeres på rett måte.",
                "sv_SE": "..."
            },
            "signrights_description_info_text_no_brreg": {
                "en_EN": "We couldn't find any information on who has rights to sign on behalf of the company. Please add the correct signing parties manually.",
                "nb_NO": "Det kunne ikke bli bestemt noen signaturrett maskinelt, og det kunne heller ikke hentes en beskrivelse fra Brønnøysundregisteret. Venligst undersøk hvem som har signaturrett slik at dokumentet kan signeres på rett måte.",
                "sv_SE": "..."
            },
            "signrights_according_to_description": {
                "en_EN": "The document has to be signed according to the description. Choose an alternative below:",
                "nb_NO": "Skjema må signeres i henhold til beskrivelsen. Velg ett alternativ under:",
                "sv_SE": "..."
            },
            "signrights_according_to_sender": {
                "en_EN": "The document has to be signed according to the instructions from the sender",
                "nb_NO": "Skjema må signeres i henhold til beskrivelse fra utsender.",
                "sv_SE": "..."
            },
            "signrights_option_below": {
                "en_EN": "Choose an option below:",
                "nb_NO": "Velg ett alternativ under:",
                "sv_SE": "..."
            },
            "signrights_message_from_sender": {
                "en_EN": "Message from sender:",
                "nb_NO": "Melding fra utsender:",
                "sv_SE": "..."
            },
            "signrights_direct_sign": {
                "en_EN": "I have power of procuration and want to go straight to signing the document",
                "nb_NO": "Jeg har fullmakt til å signere alene og ønsker å gjøre det nå",
                "sv_SE": "..."
            },
            "signrights_nondirect_sign": {
                "en_EN": "I want to add one or more persons that will receive an invitation to sign by email",
                "nb_NO": "Jeg vil legge til en eller flere personer som vil motta invitasjon til å signere på epost",
                "sv_SE": "..."
            },
            "signrights_other_option": {
                "en_EN": "Go back to my options",
                "nb_NO": "Velg et annet alternativ",
                "sv_SE": "..."
            },
            "signrights_signatories_text": {
                "en_EN": "Signatories",
                "nb_NO": "Signatarer",
                "sv_SE": "..."
            },
            "signrights_add_self_notification": {
                "en_EN": "Remember to add yourself if you are to sign the document",
                "nb_NO": "Husk å legge til deg selv dersom du også skal signere dokumentet",
                "sv_SE": "Remember to add yourself if you are to sign the document"
            },
            "signrights_direct_option": {
                "en_EN": "I want to sign the document now instead of receiving an email with link to sign.",
                "nb_NO": "Jeg vil gå direkte til signering istedenfor å motta en link på e-post",
                "sv_SE": "I want to sign the document now instead of receiving an email with link to sign."
            },
            "signrights_signrights_text": {
                "en_EN": "Signrights",
                "nb_NO": "Signaturrett",
                "sv_SE": "..."
            },
            "signrights_add_signatories": {
                "en_EN": "Add all persons that have to sign below",
                "nb_NO": "Legg til alle personer som må signere under",
                "sv_SE": "..."
            },
            "signrights_poa": {
                "en_EN": "Power of procuration",
                "nb_NO": "Fullmakt",
                "sv_SE": "..."
            },
            "signrights_poa_header": {
                "en_EN": "Please upload a legal document that shows that the persons you added have the right to sign on behalf of the company",
                "nb_NO": "Vennligst last opp fullmakt som viser at personene du la til har rettigheter til å signere på vegne på selskapet",
                "sv_SE": "Please upload a legal document that shows that the persons you added have the right to sign on behalf of the company"
            },
            "signrights_upload_poa": {
                "en_EN": "Upload power of procuration if applicable",
                "nb_NO": "Last opp fullmakt for de som skal signere dersom relevant",
                "sv_SE": "..."
            },
            "signrights_upload_poa_here": {
                "en_EN": "Drag and drop a file here or",
                "nb_NO": "Dra og slipp fullmakt her eller",
                "sv_SE": "..."
            },
            "signrights_upload_poa_select_file": {
                "en_EN": "browse filesystem",
                "nb_NO": "velg fil",
                "sv_SE": "..."
            },
            "signrights_checkout_method": {
                "en_EN": "Sign using:",
                "nb_NO": "Velg signeringsmetode",
                "sv_SE": "..."
            },
            "signrights_add_signatory": {
                "en_EN": "Add signatory",
                "nb_NO": "Legg til signatar",
                "sv_SE": "..."
            },
            "signrights_add_signatory_header": {
                "en_EN": "Add signatories",
                "nb_NO": "Legg til personer som skal signere",
                "sv_SE": "Add signatories"
            },
            "signrights_add_self": {
                "en_EN": "Add yourself",
                "nb_NO": "Legg til deg selv",
                "sv_SE": "Add yourself"
            },
            "signrights_min_1": {
                "en_EN": "You have to add at least 1 person",
                "nb_NO": "Du må legge til minst 1 person",
                "sv_SE": "You have to add at least 1 person"
            },
            "signrights_signatory_popup_text": {
                "en_EN": "Fill in details",
                "nb_NO": "Fyll inn detaljer",
                "sv_SE": "..."
            },
            "signrights_required": {
                "en_EN": "Required",
                "nb_NO": "Påkrevd",
                "sv_SE": "..."
            },
            "signrights_result_pending": {
                "en_EN": "Pending signature",
                "nb_NO": "Avventer signering",
                "sv_SE": "Pending signature"
            },
            "signrights_result_match": {
                "en_EN": "Match on all signatures",
                "nb_NO": "Alle signaturer matcher",
                "sv_SE": "Match on all signatures"
            },
            "signrights_result_manual": {
                "en_EN": "Requires manual control",
                "nb_NO": "Krever manuell sjekk",
                "sv_SE": "Requires manual control"
            },
            "signrights_result_manual_confirm": {
                "en_EN": "Confirm signature",
                "nb_NO": "Bekreft signatur",
                "sv_SE": "Bekräfta signaturen"
            },
            "signrights_result_manual_confirm_check": {
                "en_EN": "I confirm that the correct person(s) have signed",
                "nb_NO": "Jeg bekrefter at rett person(er) har signert",
                "sv_SE": "Jag bekräftar att rätt person(er) har skrivit på"
            },
            "signrights_result_manual_confirmed": {
                "en_EN": "Signature confirmed by",
                "nb_NO": "Signatur bekreftet av",
                "sv_SE": "Signatur bekräftad av"
            },
            "signrights_result_mismatch": {
                "en_EN": "One or more signatures did not match",
                "nb_NO": "Minst en signatur matcher ikke signeringsalternativet",
                "sv_SE": "One or more signatures did not match"
            },
            "signrights_result_popup_header": {
                "en_EN": "Signature information",
                "nb_NO": "Informasjon om signatur",
                "sv_SE": "Signature information"
            },
            "signrights_result_popup_has_signed": {
                "en_EN": "Who signed the form:",
                "nb_NO": "Følgende personer signerte skjemaet",
                "sv_SE": "Who signed the form:"
            },
            "signrights_result_popup_procura": {
                "en_EN": "Attached procura:",
                "nb_NO": "Vedlagt fullmakt",
                "sv_SE": "Attached procura:"
            },
            "signrights_result_popup_signoptions": {
                "en_EN": "Who were supposed to sign",
                "nb_NO": "Hvem som skulle signere",
                "sv_SE": "Who were supposed to sign"
            },
            "signrights_result_popup_signers": {
                "en_EN": "Who actually signed",
                "nb_NO": "Hvem som faktisk signerte",
                "sv_SE": "Who actually signed"
            },
            "signrights_result_popup_unknown_dob": {
                "en_EN": "Unknown birthdate",
                "nb_NO": "Ukjent fødselsdato",
                "sv_SE": "Unknown birthdate"
            },
            "signrights_result_popup_manualoption": {
                "en_EN": "The recipient added signatories manually. Make sure the correct people have signed.",
                "nb_NO": "Mottakeren la til signatarer manuelt. Etterse at de rette partene har signert.",
                "sv_SE": "The recipient added signatories manually. Make sure the correct people have signed."
            },
            "signrights_result_popup_notfilled": {
                "en_EN": "The recipient has not yet filled out the form.",
                "nb_NO": "Mottakeren har ikke fylt ut skjemaet enda.",
                "sv_SE": "The recipient has not yet filled out the form."
            },
            "signrights_result_popup_no_signers": {
                "en_EN": "Nobody has signed yet.",
                "nb_NO": "Ingen har signert enda.",
                "sv_SE": "Nobody has signed yet."
            },
        };
        return translations;
    },

    getDefaultKycTranslations() {
        const translations = {
            "kyc_submitting_form": {
                "show": true,
                "tt": true,
                "en_EN": "Submitting form",
                "nb_NO": "Sender inn skjema",
                "sv_SE": "Skickar formulär"
            },
            "kyc_welcome": {
                "show": true,
                "tt": true,
                "en_EN": "<h2>Welcome to our KYC-form</h2><p>This form is already partially filled with data from public registries. What you need to do is:</p><ul><li><p>Go over the informastion and make sure everything is correct and up to date.</p></li><li><p>If some of the information is wrong/outdated use the edit tools to correct it.</p></li><li><p>Enter necessary contact information for key roles in the company.</p></li></ul><p>Finally you choose who will sign the form on behalf of the company, yourself or you can forward it to someone else.</p><h3>Good luck!</h3>",
                "nb_NO": "<h2>Velkommen til vårt Egenerklæringsskjema</h2><p>Skjemaet er delvis utfylt med informasjon hentet fra offentlige registre. Det du nå skal gjøre er:</p><ul><li><p>Gå over informasjonen og sjekk at alt stemmer med dagens virkelighet.</p></li><li><p>Hvis noe ikke stemmer endrer du informasjonen med redigeringsverktøyene.</p></li><li><p>Fyll inn nødvendig kontaktinformasjon til relevante nøkkelpersoner.</p></li></ul><p>Til slutt velger du hvem som skal signere skjemaet, enten du selv, eller noen andre i foretaket.</p><h3>Lykke til!</h3>",
                "sv_SE": "<h2>Välkommen till vår kundkännedom</h2><p>Blanketten fylls delvis i med information från offentliga register. Vad du ska göra nu är:</p><ul><li><p>Gå igenom informationen och kontrollera att allt överensstämmer med dagens verklighet.</p></li><li><p>Om något är fel redigerar du informationen med redigeringsverktygen. </p> </li> <li> <p> Fyll i önskad kontaktinformation för relevanta nyckelpersoner. </p> </li> </ul> <p> Välj slutligen den som ska skriva under formuläret, antingen dig själv eller någon annan i företaget. </p> <h3> Lycka till! </h3>"
            },
            "kyc_title": {
                "tt": false,
                "en_EN": "Declaration form Judicial Person",
                "nb_NO": "Egenerklæringsskjema Juridisk Person",
                "de_DE": "Selbstauskunft (juristische Person)",
                "sv_SE": "Kundkännedom Juridisk person "
            },
            "kyc_step_welcome": {
                "tt": false,
                "en_EN": "Welcome",
                "nb_NO": "Velkommen",
                "de_DE": "Willkommen",
                "sv_SE": "Välkommen"
            },
            "kyc_step_company": {
                "tt": false,
                "en_EN": "Company",
                "nb_NO": "Foretaket",
                "de_DE": "die Gesellschaft",
                "sv_SE": "Företaget"
            },
            "kyc_step_aagree": {
                "tt": false,
                "en_EN": "Assignment agreement",
                "nb_NO": "Oppdragsavtale",
                "sv_SE": "Uppdragsavtal"
            },
            "kyc_step_roles": {
                "tt": false,
                "en_EN": "Key roles",
                "nb_NO": "Nøkkelroller",
                "de_DE": "Schlüsselrollen",
                "sv_SE": "Nyckelroller"
            },
            "kyc_step_rrh": {
                "tt": false,
                "en_EN": "Beneficial owners",
                "nb_NO": "Reelle rettighetshavere",
                "de_DE": "persönliche(r) Gesellschafter",
                "sv_SE": "Verkliga huvudmän"
            },
            "kyc_step_entity": {
                "tt": false,
                "en_EN": "Owner structure",
                "nb_NO": "Eierstruktur",
                "de_DE": "Gesellschafterstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "kyc_step_book": {
                "tt": false,
                "en_EN": "Shareholder book",
                "nb_NO": "Aksjeeierbok",
                "de_DE": "Aktionärsregister",
                "sv_SE": "Aktieägarbok"
            },
            "kyc_step_pep": {
                "tt": false,
                "en_EN": "Politically exposed persons",
                "nb_NO": "Politisk eksponerte personer",
                "de_DE": "politisch tätige Personen",
                "sv_SE": "Politiskt utsatta personer"
            },
            "kyc_step_purpose": {
                "tt": false,
                "en_EN": "Purpose",
                "nb_NO": "Formål",
                "de_DE": "Ziel",
                "sv_SE": "Syfte"
            },
            "kyc_step_recipient": {
                "tt": false,
                "en_EN": "Recipient",
                "nb_NO": "Mottaker",
                "de_DE": "Empfänger",
                "sv_SE": "Mottagare"
            },
            "kyc_step_signers": {
                "tt": false,
                "en_EN": "Signatories",
                "nb_NO": "Signering",
                "de_DE": "Unterschrift",
                "sv_SE": "Signering"
            },
            "kyc_aml_info": {
                "tt": false,
                "en_EN": "There has been performed a search with BankID AML on ",
                "nb_NO": "Det er gjennomført et BankID AML søk på ",
                "sv_SE": "En BankID AML-sökning har genomförts på "
            },
            "kyc_aml_on": {
                "tt": false,
                "en_EN": "  on  ",
                "nb_NO": "  den  ",
                "sv_SE": "  den  "
            },
            "kyc_aml_result": {
                "tt": false,
                "en_EN": "Result: ",
                "nb_NO": "Resultat: ",
                "sv_SE": "Resultat: "
            },
            "kyc_aa_include": {
                "tt": false,
                "en_EN": "Include assignment agreement",
                "nb_NO": "Inkluder oppdragsavtale",
                "sv_SE": "Inkludera uppdragsavtal"
            },
            "kyc_aa_drop": {
                "tt": false,
                "en_EN": "Drag & drop the assignment agreement here or",
                "nb_NO": "Dra og slipp oppdragsavtale her eller",
                "sv_SE": "Dra och släpp uppdragsavtal här eller"
            },
            "kyc_aa_upload": {
                "tt": false,
                "en_EN": "Upload assignment agreement",
                "nb_NO": "Last opp oppdragsavtale",
                "sv_SE": "Ladda upp uppdragsavtal"
            },
            "kyc_aa_browse": {
                "tt": false,
                "en_EN": "select file",
                "nb_NO": "velg fil",
                "sv_SE": "välj fil"
            },
            "kyc_rrh_yes": {
                "tt": false,
                "en_EN": "The company has one or more beneficial owner(s)",
                "nb_NO": "Foretaket har én eller flere rettighetshaver(e)",
                "de_DE": "Die Gesellschaft hat einen oder mehrere Inhaber",
                "sv_SE": "Företaget har en eller flera verkliga huvudmän"
            },
            "kyc_rrh_no": {
                "tt": false,
                "en_EN": "The company has no beneficial owners",
                "nb_NO": "Foretaket har ingen reelle rettighetshavere",
                "de_DE": "Die Gesellschaft hat keinen persönlichen Gesellschafter, der mehr als 25 % Anteile an der Gesellschaft hat.",
                "sv_SE": "Företaget har inga verkliga huvudmän"
            },
            "kyc_rrh_public": {
                "tt": false,
                "en_EN": "The company, or it's parent company is listed, and therefore do not need to report beneficial owners",
                "nb_NO": "Foretaket er et børsnotert foretak eller et datterforetak av et børsnotert foretak, og trenger derfor ikke å rapportere reell rettighetshaver",
                "de_DE": "Die Gesellschaft ist an der Börse notiert oder eine an der Börse notierte Tochtergesellschaft und braucht aus diesem Grund nicht über persönliche Gesellschafter Auskunft zu erteilen.",
                "sv_SE": "Företaget är ett börsnoterat företag eller ett dotterbolag till ett börsnoterat företag och behöver därför inte rapportera en riktig licensinnehavare"
            },
            "kyc_rrh_popup_header": {
                "tt": false,
                "en_EN": "Are you sure?",
                "nb_NO": "Er du sikker?",
                "de_DE": "Bist du sicher?",
                "sv_SE": "Är du säker?"
            },
            "kyc_rrh_popup_message": {
                "tt": false,
                "en_EN": "Are you sure the company does not have any beneficial owners?",
                "nb_NO": "Er du sikker på at foretaket ikke har noen reelle rettighetshavere?",
                "de_DE": "Bist du sicher, dass die Gesellschaft keine(n) persönlichen Gesellschafter hat, der mehr als 25 % Anteile an der Gesellschaft hat?",
                "sv_SE": "Är du säker på att företaget inte har några verkliga huvudmän?"
            },
            "kyc_rrh_popup_hint": {
                "tt": false,
                "en_EN": "(A beneficial owner is a person that owns or controls more than 25 percent of the shares in the company)",
                "nb_NO": "(En reell rettighetshaver eier eller kontrollerer mer enn 25 prosent av eierandelene i foretaket)",
                "de_DE": "(Ein persönlicher Gesellschafter ist eine Person, die mehr als 25 % der Anteile der Gesellschaft.)",
                "sv_SE": "(En verklig huvudman äger eller kontrollerar mer än 25 procent av aktierna i företaget)"
            },
            "kyc_rrh_popup_yes": {
                "tt": false,
                "en_EN": "Yes, I am sure",
                "nb_NO": "Ja, jeg er sikker",
                "de_DE": "Ja, ich bin sicher.",
                "sv_SE": "Ja, jag är säker"
            },
            "kyc_entity_manual": {
                "tt": false,
                "en_EN": "I confirm that the information from public registries show below is correct (You can edit names/owner share, and add/remove owners if the information is outdated).",
                "nb_NO": "Jeg bekrefter at informasjonen fra offentlige registre vist under er korrekt (Du kan endre navn/eierandel, og legge til/ta bort eiere hvis informasjonen er utdatert).",
                "de_DE": "Ich bestätige, dass die unten genannten Auskünfte aus den öffentlichen Registern richtig sind. (Du kannst Name oder Geschäftsanteil ändern oder Gesellschafter hinzufügen oder entfernen, falls die Registerangaben nicht richtig sind.)",
                "sv_SE": "Jag bekräftar att informationen från offentliga register som visas nedan är korrekt (Du kan ändra namn/ägande och lägga till/ta bort ägare om informationen är föråldrad)."
            },
            "kyc_entity_manual_no_lookup": {
                "tt": false,
                "en_EN": "I want to fill in information about the owner structure",
                "nb_NO": "Jeg vil sette opp eierstruktur manuelt",
                "de_DE": "Ich möchte die Struktur der Gesellschaft manuell erklären.",
                "sv_SE": "Jag vill ställa in ägarstruktur manuellt"
            },
            "kyc_entity_file": {
                "tt": false,
                "en_EN": "I want to upload a file that describes the owner structure",
                "nb_NO": "Jeg vil laste opp en fil som beskriver eierstruktur",
                "de_DE": "Ich möchte eine Datei zur Beschreibung der Struktur der Gesellschaft hochladen.",
                "sv_SE": "Jag vill ladda upp en fil som beskriver ägarstrukturen"
            },
            "kyc_entity_drop": {
                "tt": false,
                "en_EN": "Drag & drop files here or",
                "nb_NO": "Dra og slipp filer her eller",
                "de_DE": "Die Datei kann mit der Mouse in dieses Felt hinein gezogen werden oder",
                "sv_SE": "Dra och släpp filer här eller"
            },
            "kyc_entity_upload": {
                "tt": false,
                "en_EN": "Upload files",
                "nb_NO": "Last opp filer",
                "de_DE": "Datei hochladen",
                "sv_SE": "Ladda upp filer"
            },
            "kyc_entity_browse": {
                "tt": false,
                "en_EN": "select file",
                "nb_NO": "velg fil",
                "de_DE": "wähle eine Datei",
                "sv_SE": "välj fil"
            },
            "kyc_entity_empty": {
                "tt": false,
                "en_EN": "No owners added / found in public registries",
                "nb_NO": "Ingen eiere lagt til / funnet i offentlige registre",
                "de_DE": "Es wurden kein(e) Gesellschafter hinzugefügt oder im öffentlichen Register gefunden.",
                "sv_SE": "Inga ägare har lagts till / hittats i offentliga register"
            },
            "kyc_send_out": {
                "tt": false,
                "en_EN": "Send out",
                "nb_NO": "Send ut",
                "de_DE": "versenden",
                "sv_SE": "Skicka ut"
            },
            "kyc_send_in": {
                "tt": false,
                "en_EN": "Send in",
                "nb_NO": "Send inn",
                "de_DE": "einsenden",
                "sv_SE": "Skicka in"
            },
            "kyc_book_option_upload": {
                "en_EN": "I want to upload the shareholder book now",
                "nb_NO": "Jeg vil laste opp aksjeeierbok nå",
                "de_DE": "Ich möchte jetzt das Aktionärsregister hochladen.",
                "sv_SE": "Jag vill ladda upp aktieägarboken nu"
            },
            "kyc_book_option_later": {
                "en_EN": "The shareholder book is unavailable at this time and I want to submit it at a later stage",
                "nb_NO": "Aksjeeierbok er utilgjengelig nå og jeg vil ettersende den",
                "de_DE": "Das Aktionärrsegister ist zur Zeit nicht zugänglich und wird später nachgereicht.",
                "sv_SE": "Aktieägarboken är inte tillgänglig nu, jag skickar in den vid ett senare tillfälle"
            },
            "kyc_book_option_exists_o": {
                "en_EN": "Attach shareholder book",
                "nb_NO": "Legg ved aksjeeierbok",
                "de_DE": "Aktionärsregister beifügen",
                "sv_SE": "Bifoga aktieägarregister "
            },
            "kyc_book_option_exists_e": {
                "en_EN": "The shareholder book is already attached",
                "nb_NO": "Aksjeeierbok er allerede vedlagt",
                "de_DE": "Das Aktionärsregister ist bereits beigefügt.",
                "sv_SE": "Aktieägarregisteret är redan bifogat"
            },
            "help_company_aml_head": {
                "tt": false,
                "en_EN": "Company details",
                "nb_NO": "Foretaksinformasjon",
                "de_DE": "Informationen zur Gesellschaft",
                "sv_SE": "Företagsinformation"
            },
            "help_company_aml_desc": {
                "tt": false,
                "en_EN": "Information from BankID AML/Brønnøysundregistrene (Shown only for Norwegian companies).",
                "nb_NO": "Informasjon fra BankID AML/Brønnøysundregistrene (Vises kun på norske foretak).",
                "sv_SE": "Information från BankID AML / Brønnøysundregistrene (visas endast på norska företag)."
            },
            "help_o_company_aml_1_header": {
                "tt": false,
                "en_EN": "Company information",
                "nb_NO": "Foretaksinformasjon",
                "sv_SE": "Företagsinformation"
            },
            "help_o_company_aml_1_text": {
                "tt": true,
                "en_EN": "There has been performed a lookup in public registries wich returned the information below. The customer will be asked to check if the information is correct.",
                "nb_NO": "Det er gjennomført et søk i offentlige registre på foretaket som returnerte informasjonen under. Kunden får beskjed om å sjekke at informasjonen stemmer.",
                "sv_SE": "En sökning har genomförts i offentliga register över företaget som returnerade informationen nedan. Kunden uppmanas att kontrollera att informationen är korrekt."
            },
            "help_e_company_aml_1_header": {
                "tt": false,
                "en_EN": "Company information",
                "nb_NO": "Foretaksinformasjon",
                "sv_SE": "Företagsinformation"
            },
            "help_e_company_aml_1_text": {
                "tt": true,
                "en_EN": "We have performed a lookup in public registries wich returned the information below. Please look over the results and correct any missing/outdated information.",
                "nb_NO": "Det er gjennomført et søk i offentlige registre på foretaket som returnerte informasjonen under. Gå gjennom og sjekk at denne informasjonen stemmer overens med dagens virkelighet, og rett opp hvis noe er feil.",
                "sv_SE": "En sökning har genomförts i offentliga register över företaget som returnerade informationen nedan. Gå igenom och kontrollera att denna information är i linje med dagens verklighet och korrigera om något är fel."
            },
            "help_company_man_head": {
                "tt": false,
                "en_EN": "Company details",
                "nb_NO": "Foretaksinformasjon",
                "sv_SE": "Företagsinformation"
            },
            "help_company_man_desc": {
                "tt": false,
                "en_EN": "Information about the company (Show for non-Norwegian companies and companies under creation). The information must be entered manually.",
                "nb_NO": "Informasjon om foretaket (Vises for utenlandske foretak og foretak under stiftelse). Informasjonen må tastet inn manuelt.",
                "sv_SE": "Information om företaget (visas för utländska företag och företag som grundas). Informationen måste anges manuellt."
            },
            "help_o_company_man_1_header": {
                "tt": false,
                "en_EN": "Company information",
                "nb_NO": "Foretaksinformasjon",
                "sv_SE": "Företagsinformation"
            },
            "help_o_company_man_1_text": {
                "tt": true,
                "en_EN": "The customer will be asked to fill in the following details about the company. You can also fill in information at this stage if it is known.",
                "nb_NO": "Kunden vil bli bedt om å fylle inn følgende informasjon om foretaket. Du kan også fylle inn på dette steget hvis du har denne informasjonen.",
                "sv_SE": "Kunden kommer att bli ombedd att fylla i följande information om företaget. Du kan också fylla i detta steg om du har denna information."
            },
            "help_e_company_man_1_header": {
                "tt": false,
                "en_EN": "Company information",
                "nb_NO": "Foretaksinformasjon",
                "sv_SE": "Företagsinformation"
            },
            "help_e_company_man_1_text": {
                "tt": true,
                "en_EN": "Please fill in the following details about the company.",
                "nb_NO": "Vennligst fyll inn følgende informasjon om foretaket.",
                "sv_SE": "Vänligen fyll i följande information om företaget."
            },
            "help_aagree_head": {
                "tt": false,
                "en_EN": "Assignment agreement",
                "nb_NO": "Oppdragsavtale",
                "sv_SE": "Uppdragsavtal"
            },
            "help_aagree_desc": {
                "tt": false,
                "en_EN": "On this page you can upload an assignment agreement, the customer will see it in the form.",
                "nb_NO": "På denne siden kan man laste opp en oppdragsavtale, kunden vil få se denne avtalen i skjemaet.",
                "sv_SE": "På denna sida kan du ladda upp ett uppdragsavtal, kunden ser detta avtal i formuläret."
            },
            "help_o_aagree_1_header": {
                "tt": false,
                "en_EN": "Assignment agreement",
                "nb_NO": "Oppdragsavtale",
                "sv_SE": "Uppdragsavtal"
            },
            "help_o_aagree_1_text": {
                "tt": true,
                "en_EN": "Optional. Upload an assignment agreement that will be included as an attachment to the declaration",
                "nb_NO": "Valgfritt. Last opp en oppdragsavtale som vil bli lagt som vedlegg til egenerklæringen.",
                "sv_SE": "Valfritt. Ladda upp ett uppdragsavtal som bilaga till självdeklarationen."
            },
            "help_e_aagree_1_header": {
                "tt": false,
                "en_EN": "Assignment agreement",
                "nb_NO": "Oppdragsavtale",
                "sv_SE": "Uppdragsavtal"
            },
            "help_e_aagree_1_text": {
                "tt": true,
                "en_EN": "Assignment agreement for this assignment.",
                "nb_NO": "Oppdragsavtalen i forbindelse med oppdraget.",
                "sv_SE": "Uppdragsavtalet i samband med uppdraget."
            },
            "help_roles_aml_head": {
                "tt": false,
                "en_EN": "Key roles",
                "nb_NO": "Nøkkelroller",
                "sv_SE": "Nyckelroller"
            },
            "help_roles_aml_desc": {
                "tt": false,
                "en_EN": "Key company roles from public registries (nordic companies).",
                "nb_NO": "Nøkkelroller i foretaket hentet fra offentlige registre (nordiske foretak).",
                "sv_SE": "Nyckelroller i företaget hämtade från offentliga register (nordiska företag)."
            },
            "help_o_roles_aml_1_header": {
                "tt": false,
                "en_EN": "Key roles",
                "nb_NO": "Nøkkelroller",
                "sv_SE": "Nyckelroller"
            },
            "help_o_roles_aml_1_text": {
                "tt": true,
                "en_EN": "There has been performed a lookup in public registries on key roles in the company. The customer will be asked to check if the information is correct.",
                "nb_NO": "Det er gjennomført et søk i offentlige registre på nøkkelroller i foretaket. Kunden vil få beskjed om å sjekke at informasjonen er korrekt.",
                "sv_SE": "En sökning har gjorts i offentliga register efter nyckelroller i företaget. Kunden kommer att meddelas för att kontrollera att informationen är korrekt."
            },
            "help_e_roles_aml_1_header": {
                "tt": false,
                "en_EN": "Key roles",
                "nb_NO": "Nøkkelroller",
                "sv_SE": "Nyckelroller"
            },
            "help_e_roles_aml_1_text": {
                "tt": true,
                "en_EN": "We have performed a lookup in public registries on key roles in the company. Please look over the results and correct any missing/outdated information.",
                "nb_NO": "Det er gjennomført et søk i offentlige registre på nøkkelroller i foretaket. Gå gjennom og sjekk at denne informasjonen stemmer overens med dagens virkelighet, og rett opp hvis noe er feil.",
                "sv_SE": "En sökning har gjorts i offentliga register efter nyckelroller i företaget. Gå igenom och kontrollera att denna information är i linje med dagens verklighet och korrigera om något är fel."
            },
            "help_roles_man_head": {
                "tt": false,
                "en_EN": "Key roles",
                "nb_NO": "Nøkkelroller",
                "sv_SE": "Nyckelroller"
            },
            "help_roles_man_desc": {
                "tt": false,
                "en_EN": "Key company roles from public registries (nordic companies).",
                "nb_NO": "Nøkkelroller i foretaket hentet fra offentlige registre (nordiske foretak).",
                "sv_SE": "Nyckelroller i företaget hämtade från offentliga register (nordiska företag)."
            },
            "help_o_roles_man_1_header": {
                "tt": false,
                "en_EN": "Key roles",
                "nb_NO": "Nøkkelroller",
                "sv_SE": "Nyckelroller"
            },
            "help_o_roles_man_1_text": {
                "tt": true,
                "en_EN": "The customer will be asked add and fill in information about relevant key roles in the company. You can also add key roles at this stage if you have that information.",
                "nb_NO": "Kunden vil få beskjed om å legge til og fylle inn informasjon om relevante nøkkelroller i foretaket. Du kan også legge til nøkkelroller på dette steget hvis du har denne informasjonen.",
                "sv_SE": "Kunden uppmanas att lägga till och fylla i information om relevanta nyckelroller i företaget. Du kan också lägga till nyckelroller i det här steget om du har den här informationen."
            },
            "help_e_roles_man_1_header": {
                "tt": false,
                "en_EN": "Key roles",
                "nb_NO": "Nøkkelroller",
                "sv_SE": "Nyckelroller"
            },
            "help_e_roles_man_1_text": {
                "tt": true,
                "en_EN": "Please add and fill in information about key roles in the company. Add all relevant roles for the company i.e. CEO, chairman etc.",
                "nb_NO": "Vennligst legg til og fyll ut informasjon om nøkkelroller i foretaket. Legg til alle relevante roller i foretaket f.eks. Daglig leder, styreleder osv.",
                "sv_SE": "Lägg till och fyll i information om nyckelroller i företaget. Lägg till alla relevanta roller i företaget, t.ex. VD, styrelseordförande etc."
            },
            "help_rrh_aml_head": {
                "tt": false,
                "en_EN": "Beneficial owners",
                "nb_NO": "Reelle rettighetshavere",
                "sv_SE": "Verklig huvudman"
            },
            "help_rrh_aml_desc": {
                "tt": false,
                "en_EN": "Beneficial owners from public registries (nordic companies).",
                "nb_NO": "Reelle rettighetshavere hentet fra offentlige registre (nordiske foretak).",
                "sv_SE": "Verklig huvudman erhållna från offentliga register (nordiska företag)."
            },
            "help_o_rrh_aml_1_header": {
                "tt": false,
                "en_EN": "Information from public registries",
                "nb_NO": "Informasjon fra offentlige registre",
                "sv_SE": "Information från offentliga register"
            },
            "help_o_rrh_aml_1_text": {
                "tt": true,
                "en_EN": "There has been performed a lookup in public registries and hits on beneficial owners is shown below. The customer will be asked to look over the information and confirm it is correct.",
                "nb_NO": "Det er gjennomført et søk i offentlige registre og treff på reelle rettighetshavere vises under. Kunden vil bli bedt om å sjekke at informasjonen er korrekt.",
                "sv_SE": "En sökning har genomförts i offentliga register och träffar på verklig huvudman visas nedan. Kunden kommer att uppmanas att kontrollera att informationen är korrekt."
            },
            "help_e_rrh_aml_1_header": {
                "tt": false,
                "en_EN": "Information from public registries",
                "nb_NO": "Informasjon fra offentlige registre",
                "sv_SE": "Information från offentliga register"
            },
            "help_e_rrh_aml_1_text": {
                "tt": true,
                "en_EN": "We have performed a lookup in public registries and hits on beneficial owners is shown below. Please look over the results and correct any missing/outdated information.",
                "nb_NO": "Det er gjennomført et søk i offentlige registre og treff på reelle rettighetshavere vises under. Gå gjennom og sjekk at denne informasjonen stemmer overens med dagens virkelighet, og rett opp hvis noe er feil.",
                "sv_SE": "En sökning har genomförts i offentliga register och träffar på verklig huvudman visas nedan. Gå igenom och kontrollera att denna information är i linje med dagens verklighet och korrigera om något är fel."
            },
            "help_o_rrh_aml_2_header": {
                "tt": false,
                "en_EN": "What is a beneficial owner?",
                "nb_NO": "Hva er en reell rettighetshaver?",
                "sv_SE": "Vad är en verklig huvudman?"
            },
            "help_o_rrh_aml_2_text": {
                "tt": true,
                "en_EN": "A beneficial owner is a person that in the end controls more than 25 % of a company, either directly or indirectly through a parent company.",
                "nb_NO": "En reell rettighetshaver er en person som i praksis kontrollerer mer enn 25 % av foretaket, enten direkte eller inderekte gjennom et morselskap.",
                "sv_SE": "En verklig huvudman är en person som i praktiken kontrollerar mer än 25% av företaget, antingen direkt eller indirekt genom ett moderbolag."
            },
            "help_rrh_man_head": {
                "tt": false,
                "en_EN": "Beneficial owners",
                "nb_NO": "Reelle rettighetshavere",
                "sv_SE": "Verklig huvudman"
            },
            "help_rrh_man_desc": {
                "tt": false,
                "en_EN": "Beneficial owners (Show for non-nordic companies and companies under creation). Will have to be entered manually.",
                "nb_NO": "Reelle rettighetshavere (Vises for utenlandske foretak og foretak under stiftelse). Informasjonen må tastes inn manuelt.",
                "sv_SE": "Verklig huvudman (Visas för utländska företag och företag som grundas). Informationen måste anges manuellt."
            },
            "help_o_rrh_man_1_header": {
                "tt": false,
                "en_EN": "Beneficial owners",
                "nb_NO": "Reelle rettighetshavere",
                "sv_SE": "Verklig huvudman"
            },
            "help_o_rrh_man_1_text": {
                "tt": true,
                "en_EN": "The customer will be asked to add and fill in information about any beneficial owners.",
                "nb_NO": "Kunden vil bli bedt om å legge til og fylle inn informasjon om eventuelle reelle rettighetshavere.",
                "sv_SE": "Kunden kommer att bli ombedd att lägga till och fylla i information om alla verkliga huvudman."
            },
            "help_e_rrh_man_1_header": {
                "tt": false,
                "en_EN": "Beneficial owners",
                "nb_NO": "Reelle rettighetshavere",
                "sv_SE": "Verklig huvudman"
            },
            "help_e_rrh_man_1_text": {
                "tt": true,
                "en_EN": "Please add and fill in information about any beneficial owners.",
                "nb_NO": "Vennligst legg til og fyll inn informasjon om eventuelle reelle rettighetshavere.",
                "sv_SE": "Vänligen lägg till och fyll i information om eventuella verkliga verkliga huvudman."
            },
            "help_entity_aml_head": {
                "tt": false,
                "en_EN": "Owner structure",
                "nb_NO": "Eierstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "help_entity_aml_desc": {
                "tt": false,
                "en_EN": "Owner structure from BankID AML (Show only for Norwegian companies).",
                "nb_NO": "Eierstruktur hentet fra BankID AML (Vises kun for norske foretak).",
                "sv_SE": "Ägarstruktur hämtad från BankID AML (visas endast för norska företag)."
            },
            "help_o_entity_aml_1_header": {
                "tt": false,
                "en_EN": "Owner structure",
                "nb_NO": "Eierstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "help_o_entity_aml_1_text": {
                "tt": true,
                "en_EN": "There has been performed a lookup in public registries on the company owner structure. The customer will be asked to go over the information and confirm that it is correct.",
                "nb_NO": "Det er gjennomført et søk i offentlige registre på foretakets eierstruktur. Kunden vil bli bedt om å gå over informasjonen og bekrefte at den er korrekt.",
                "sv_SE": "En sökning har genomförts i offentliga register över företagets ägarstruktur. Kunden kommer att bli ombedd att granska informationen och bekräfta att den är korrekt."
            },
            "help_e_entity_aml_1_header": {
                "tt": false,
                "en_EN": "Owner structure",
                "nb_NO": "Eierstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "help_e_entity_aml_1_text": {
                "tt": true,
                "en_EN": "We have performed a lookup in public registries on the company owner structure. Please look over the results and correct any missing/outdated information.",
                "nb_NO": "Det er gjennomført et søk i offentlige registre på foretakets eierstruktur. Gå gjennom og sjekk at denne informasjonen stemmer overens med dagens virkelighet, og rett opp hvis noe er feil.",
                "sv_SE": "En sökning har genomförts i offentliga register över företagets ägarstruktur. Kunden kommer att bli ombedd att granska informationen och bekräfta att den är korrekt."
            },
            "help_entity_man_head": {
                "tt": false,
                "en_EN": "Owner structure",
                "nb_NO": "Eierstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "help_entity_man_desc": {
                "tt": false,
                "en_EN": "Owner structure (Show for non-Norwegian companies and companies under creation). Will have to be entered manually.",
                "nb_NO": "Eierstruktur (Vises for utenlandske foretak og foretak under stiftelse). Informasjonen må tastes inn manuelt.",
                "sv_SE": "Ägarstruktur (visas för utländska företag och företag som grundas). Informationen måste anges manuellt."
            },
            "help_o_entity_man_1_header": {
                "tt": false,
                "en_EN": "Owner structure",
                "nb_NO": "Eierstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "help_o_entity_man_1_text": {
                "tt": true,
                "en_EN": "The customer will be asked to set up the owner structure in the form or upload a file that describes the owner structure.",
                "nb_NO": "Kunden vil bli bedt om å sette opp eierstrukturen i skjemaet eller laste opp en fil som beskriver eierstrukturen.",
                "sv_SE": "Kunden uppmanas att ange ägarstrukturen i formuläret eller ladda upp en fil som beskriver ägarstrukturen."
            },
            "help_e_entity_man_1_header": {
                "tt": false,
                "en_EN": "Owner structure",
                "nb_NO": "Eierstruktur",
                "sv_SE": "Ägarstruktur"
            },
            "help_e_entity_man_1_text": {
                "tt": true,
                "en_EN": "Please set up the owner structure of the company by adding any parent companies (juducial persons) and shareholders (physical persons).",
                "nb_NO": "Vennligst sett opp eierstrukturen til foretaket ved å legge til eventuelle moderselskaper (juridiske personer) og aksjonærer (fysiske personer).",
                "sv_SE": "Vänligen ange ägarstrukturen för företaget genom att lägga till moderbolag (juridiska personer) och aktieägare (fysiska personer)."
            },
            "help_e_entity_man_2_header": {
                "tt": false,
                "en_EN": "Complex structure",
                "nb_NO": "Kompleks struktur",
                "sv_SE": "Komplex struktur"
            },
            "help_e_entity_man_2_text": {
                "tt": true,
                "en_EN": "If the company has a complex owner structure, you can choose to upload a file that describes it.",
                "nb_NO": "Hvis foretaket har en kompleks eierstruktur, kan du velge laste opp en fil som beskriver den.",
                "sv_SE": "Om företaget har en komplex ägarstruktur kan du välja att ladda upp en fil som beskriver den."
            },
            "help_pep_head": {
                "tt": false,
                "en_EN": "Politically Exposed Persons",
                "nb_NO": "Politisk Eksponerte Personer",
                "sv_SE": "Politiskt utsatta personer"
            },
            "help_pep_desc": {
                "tt": false,
                "en_EN": "Here the customer will have to fill in information about persons that was checked as PEP in the form.",
                "nb_NO": "Her må kunden fylle inn informasjon om personer som er huket av som PEP i skjemaet.",
                "sv_SE": "Här måste kunden fylla i information om personer som har markerats som PEP i formuläret."
            },
            "help_o_pep_1_header": {
                "tt": false,
                "en_EN": "Politically Exposed Persons",
                "nb_NO": "Politisk Eksponerte Personer",
                "sv_SE": "Politiskt utsatta personer"
            },
            "help_o_pep_1_text": {
                "tt": true,
                "en_EN": "The customer will be asked to fill in required information abou any person that has been checked as a PEP. This step is only shown if a key role has been checked as a PEP.",
                "nb_NO": "Kunden vil bli bedt om å fylle inn påkrevd informasjon om personer som er huket av for PEP. Dette steget vises kun hvis nøkkelroller har blitt huket av som PEP.",
                "sv_SE": "Kunden kommer att bli ombedd att fylla i nödvändig information om personer som har kryssats för PEP. Detta steg visas bara om nyckelroller har avmarkerats som PEP."
            },
            "help_e_pep_1_header": {
                "tt": false,
                "en_EN": "Politically Exposed Persons",
                "nb_NO": "Politisk Eksponerte Personer",
                "sv_SE": "Politiskt utsatta personer"
            },
            "help_e_pep_1_text": {
                "tt": true,
                "en_EN": "Fill in required information about politically exposed persons.",
                "nb_NO": "Fyll inn nødvendig informasjon om politisk eksponerte personer.",
                "sv_SE": "Fyll i nödvändig information om politiskt utsatta personer."
            },
            "help_e_pep_2_header": {
                "tt": false,
                "en_EN": "Title/Function",
                "nb_NO": "Tittel/Funksjon",
                "sv_SE": "Titel/funktion"
            },
            "help_e_pep_2_text": {
                "tt": true,
                "en_EN": "In this field you describe why this person is classified as a politically exposed person, i.e. 'Married to the prime minister of Norway'.",
                "nb_NO": "I dette feltet beskriver du hvorfor denne personen er klassifisert som en politisk eksponert person, f.eks. 'Gift med statsministeren i Norge'.",
                "sv_SE": "I det här fältet beskriver du varför denna person klassificeras som en politiskt utsatt person, t.ex. 'Gift med Norges premiärminister'."
            },
            "help_purpose_head": {
                "tt": false,
                "en_EN": "Purpose",
                "nb_NO": "Formål",
                "sv_SE": "Syfte"
            },
            "help_purpose_desc": {
                "tt": false,
                "en_EN": "Here the customer will answer questions about the purpose of the assignment if any questions were added.",
                "nb_NO": "Her svarer kunden på eventuelle spørsmål om kundeforholdets formål og tilsiktede art.",
                "sv_SE": "Här svarar kunden på eventuella frågor om kundrelationens syfte och avsikt."
            },
            "help_o_purpose_1_header": {
                "tt": false,
                "en_EN": "Purpose",
                "nb_NO": "Kundeforholdets formål og tilsiktede art",
                "sv_SE": "Kundrelationens syfte och avsedda karaktär "
            },
            "help_o_purpose_1_text": {
                "tt": true,
                "en_EN": "The customer will be asked to answer these questions.",
                "nb_NO": "Kunden vil bli bedt om å svare på disse spørsmålene.",
                "sv_SE": "Kunden kommer att uppmanas att svara på dessa frågor."
            },
            "help_e_purpose_1_header": {
                "tt": false,
                "en_EN": "Purpose",
                "nb_NO": "Kundeforholdets formål og tilsiktede art",
                "sv_SE": "Syftet med kundrelationen och avsedd art"
            },
            "help_e_purpose_1_text": {
                "tt": true,
                "en_EN": "Please answer the following questions.",
                "nb_NO": "Vennligst svar på spørsmålene.",
                "sv_SE": "Vänligen svara på frågorna."
            },
            "help_book_head": {
                "tt": false,
                "en_EN": "Shareholder book",
                "nb_NO": "Aksjeeierbok",
                "sv_SE": "Aktieägarbok"
            },
            "help_book_desc": {
                "tt": false,
                "en_EN": "Here the recipient will be able to upload the shareholder book if there are any changes from the original data.",
                "nb_NO": "Her vil mottaker kunne laste opp aksjeeierbok hvis det er gjort endringer fra oppslagsdata.",
                "sv_SE": "Här kommer mottagaren att kunna ladda upp aktieägarregistret om ändringar har gjorts från referensdata."
            },
            "help_o_book_1_header": {
                "tt": false,
                "en_EN": "Shareholder book",
                "nb_NO": "Aksjeeierbok",
                "sv_SE": "Aktieägarbok"
            },
            "help_o_book_1_text": {
                "tt": true,
                "en_EN": "Here the recipient will be able to upload the shareholder book if there are any changes from the original data. You can also attach the shareholder book if you already have it.",
                "nb_NO": "Her vil mottaker kunne laste opp aksjeeierbok hvis det er gjort endringer fra oppslagsdata. Du kan også legge ved aksjeeierbok hvis du har den allerede.",
                "sv_SE": "Här kommer mottagaren att kunna ladda upp aktieägarregistret om ändringar har gjorts från referensdata. Du kan också bifoga ett aktieägarregister om du redan har det."
            },
            "help_e_book_1_header": {
                "tt": false,
                "en_EN": "Shareholder book",
                "nb_NO": "Aksjeeierbok",
                "sv_SE": "Aktieägarbok"
            },
            "help_e_book_1_text": {
                "tt": true,
                "en_EN": "You have made changes to the company structure and you will have to upload the shareholder book to confirm the changes. If you do not have it available right now, you can send it to us when you have it.",
                "nb_NO": "Det er gjort endringer i selskapsstrukturen og du må laste opp aksjeeierbok for å bekrefte endringene. Hvis du ikke har den tilgjengelig nå kan den ettersendes.",
                "sv_SE": "Ändringar har gjorts i företagsstrukturen och du måste ladda upp ett aktieägarregister för att bekräfta ändringarna. Om du inte har det tillgängligt nu kan det vidarebefordras."
            },
            "help_o_checkout_head": {
                "tt": false,
                "en_EN": "Recipient",
                "nb_NO": "Mottaker",
                "sv_SE": "Mottagre"
            },
            "help_o_checkout_desc": {
                "tt": false,
                "en_EN": "Here the recipient of the form (customers representive) is selected. They will fill out the form and select the signatories for the company.",
                "nb_NO": "Her velges mottakeren av skjemaet (kundens kontaktperson), som skal fylle inn informasjon og velge hvem som skal signere.",
                "sv_SE": "Här väljs mottagaren av formuläret (kundens kontaktperson) som måste fylla i information och välja vem som ska skriva under."
            },
            "help_o_checkout_1_header": {
                "tt": false,
                "en_EN": "Recipient",
                "nb_NO": "Mottaker",
                "sv_SE": "Mottagare"
            },
            "help_o_checkout_1_text": {
                "tt": true,
                "en_EN": "Select the customer contact person that will fill out the form.",
                "nb_NO": "Velg kontaktpersonen for oppdraget som skal fylle ut skjemaet.",
                "sv_SE": "Välj kontaktperson för den som ska fylla i formuläret."
            },
            "help_e_checkout_head": {
                "tt": false,
                "en_EN": "Signatories",
                "nb_NO": "Signering",
                "sv_SE": "Undertecknare"
            },
            "help_e_checkout_desc": {
                "tt": false,
                "en_EN": "Here the recipient of the form (customers representive) selects the person or persons that will sign the form on behalf of the company.",
                "nb_NO": "Her velger mottakeren av skjemaet (kundens kontaktperson), hvem som skal signere på vegne av foretaket.",
                "sv_SE": "Här väljer mottagaren av formuläret (kundens kontaktperson) vem som ska skriva under på företagets vägnar."
            },
            "help_e_checkout_1_header": {
                "tt": false,
                "en_EN": "Signatories",
                "nb_NO": "Signering",
                "sv_SE": "Undertecknare"
            },
            "help_e_checkout_1_text": {
                "tt": true,
                "en_EN": "Select the person or persons that will sign the declaration on behalf of the company.",
                "nb_NO": "Velg hvem som skal signere egenerklæringen på vegne av foretaket.",
                "sv_SE": "Välj vem som ska underteckna självdeklarationen på företagets vägnar."
            },
            "help_e_checkout_2_header": {
                "tt": false,
                "en_EN": "Who can sign?",
                "nb_NO": "Hvem kan signere?",
                "sv_SE": "Vem kan signera?"
            },
            "help_e_checkout_2_text": {
                "tt": true,
                "en_EN": "There are no special requirements as to who can sign, as long as the person has a power of attorney from the company for this.",
                "nb_NO": "Det er ingen spesielle krav til hvem som kan signere, så lenge personen har fullmakt fra foretaket til dette.",
                "sv_SE": "Det finns inga speciella krav på vem som kan skriva under, så länge personen har en fullmakt från företaget för detta."
            },
            "help_recipient_1_header": {
                "tt": false,
                "en_EN": "Recipient",
                "nb_NO": "Mottaker",
                "sv_SE": "Mottagare"
            },
            "help_recipient_1_text": {
                "tt": true,
                "en_EN": "Select the customer contact person that will fill out the form.",
                "nb_NO": "Velg kontaktpersonen for oppdraget som skal fylle ut skjemaet.",
                "sv_SE": "Välj kontaktperson för den som ska fylla i formuläret"
            },
            "help_tasks_1_header": {
                "tt": false,
                "en_EN": "Assignment agreement",
                "nb_NO": "Oppdragsavtale",
                "sv_SE": "Uppdragsavtal"
            },
            "help_tasks_1_text": {
                "tt": true,
                "en_EN": "Optional. Upload an assignment agreement that will be included as an attachment to the declaration",
                "nb_NO": "Valgfritt. Last opp en oppdragsavtale som vil bli lagt som vedlegg til egenerklæringen.",
                "sv_SE": "Valfritt. Ladda upp ett uppdragsavtal som bifogas självdeklarationen."
            },
            "help_vtasks_1_header": {
                "tt": false,
                "en_EN": "Assignment agreement",
                "nb_NO": "Oppdragsavtale",
                "sv_SE": "Uppdragsavtal"
            },
            "help_vtasks_1_text": {
                "tt": true,
                "en_EN": "Assignment agreement for this assignment.",
                "nb_NO": "Oppdragsavtalen i forbindelse med oppdraget.",
                "sv_SE": "Uppdragsavtalet i samband med uppdraget."
            },
            "helpicon_pep_html": {
                "tt": true,
                "en_EN": "<h3>Politically exposed person</h3><p>A «politically exposed person» is defined as a person who:</p><p></p><ul><li><p>(a) holds or has held a «<strong>senior public position or office</strong>» as mentioned below;</p></li><li><p>(b) is a «<strong>close relative</strong>» of a politically exposed person; or</p></li><li><p>(c) is a «<strong>known employee/business partner</strong>» of a political person.</p></li></ul><p>«<strong>Senior public office or office</strong>» is defined as:</p><p></p><ul><li><p>(a) head of state, head of government, minister or deputy minister</p></li><li><p>(b) member of the National Assembly</p></li><li><p>(c) member of governing body of political party</p></li><li><p>(d) a member of a higher court who makes a decision which cannot or only exceptionally be appealed</p></li><li><p>(e) member of the board of the National Audit Office, the Court of Auditors or the Central Bank</p></li><li><p>(f) ambassador, chargé d'affaires or military officer of higher rank</p></li><li><p>(g) medlem av administrativt, ledende eller kontrollerende organ i statlig foretak</p></li><li><p>(h) member of administrative, governing or controlling body of a state-owned enterprise</p></li></ul><p>«<strong>close relative</strong>» is defined as parents, spouse, registered partner, cohabitant and children, as well as the child's spouse, registered partner or cohabitant.</p><p></p><p>A «<strong>known employee/business partner</strong>» is defined as:</p><p></p><ul><li><p>(a) a beneficial owner of a judicial person, association or foreign legal arrangement in association with a politically exposed person;</p></li><li><p>(b) have a close business relationship with a politically exposed person; or</p></li><li><p>(c) be the sole real right holder in a judicial person, association or foreign legal arrangement that is in fact established to favor a politically exposed person.</p></li></ul>",
                "nb_NO": "<h3>Politisk eksponert person</h3><p>Med «politisk eksponert person» menes person som:</p><p></p><ul><li><p>(a) innehar eller har innehatt «<strong>høytstående offentlig stilling eller verv</strong>» som&nbsp; nevnt nedenfor;</p></li><li><p>(b) er «<strong>nært familiemedlem</strong>» av en politisk eksponert person; eller</p></li><li><p>(c) er «<strong>kjent medarbeider</strong>» av en politisk person.</p></li></ul><p>Med «<strong>høytstående offentlig stilling eller verv</strong>» menes:</p><p></p><ul><li><p>(a) statsoverhode, regjeringssjef, minister eller assisterende minister</p></li><li><p>(b) medlem av nasjonalforsamling</p></li><li><p>(c) medlem av styrende organ i politisk parti</p></li><li><p>(d) medlem av høyere rettsinstans som treffer beslutning som ikke eller bare&nbsp; unntaksvis kan ankes</p></li><li><p>(e) medlem av styre i riksrevisjon, revisjonsdomstol eller sentralbank</p></li><li><p>(f) ambassadør, chargé d'affaires eller militær offiser av høyere rang</p></li><li><p>(g) medlem av administrativt, ledende eller kontrollerende organ i statlig foretak</p></li><li><p>(h) direktør, styremedlem eller annen person i øverste ledelse i internasjonal&nbsp; organisasjon</p></li></ul><p>Med «<strong>nært familiemedlem</strong>» menes foreldre, ektefelle, registrert partner, samboer og&nbsp; barn, samt barns ektefelle, registrert partner eller samboer.</p><p></p><p>Med «<strong>kjent medarbeider</strong>» menes fysisk person som er kjent for å:</p><p></p><ul><li><p>(a) være reell rettighetshaver i juridisk person, sammenslutning eller utenlandsk&nbsp; juridisk arrangement i felleskap med politisk eksponert person;</p></li><li><p>(b) ha nær forretningsforbindelse til politisk eksponert person; eller</p></li><li><p>(c) være eneste reelle rettighetshaver i juridisk person, sammenslutning eller&nbsp; utenlandsk juridisk arrangement som i realiteten er etablert for å begunstige&nbsp; politisk eksponert person.</p></li></ul><p></p>",
                "sv_SE": "<h3> Politiskt utsatt person </h3> <p> Med «politiskt utsatt person» avses en person som:</p><p></p><ul><li><p>(a) innehar eller har hållit «<strong>ledande offentliga befattning eller kontor</strong>» som&nbsp;nämnt nedan;</p></li><li><p>(b) er «<strong>nära familjemedlem</strong>»av en politiskt utsatt person; eller</p></li><li><p>(c) er «<strong>känd medarbetare</strong>» av en politisk person.</p></li></ul><p>Med «<strong>högre offentliga befattningar eller befattningar</strong>» menar:</p><p></p><ul><li><p>(a) statschef, regeringschef, minister eller biträdande minister</p></li><li><p>(b) medlem av nationalförsamlingen</p></li><li><p>(c) ledamot av styrande organ i politiskt parti</p></li><li><p>(d) medlem av en högre domstol som fattar ett beslut som inte eller bara&nbsp; kan i undantagsfall överklagas</p></li><li><p>(e) styrelseledamot i revisionsverket, revisionsrätten eller centralbanken </p></li><li><p>(f) Ambassadör, Chargé d 'affaires eller militär officer med högre rang</p></li><li><p>(g) medlem av ett statligt företags administrativa, styrande eller kontrollerande organ</p></li><li><p>(h) en styrelseledamot, styrelseledamot eller annan person i ledningen för en internationell&nbsp; organisation</p></li></ul><p>Med «<strong>Närstående familjemedlem </strong>» betyder föräldrar, make, registrerad partner, samboare och &nbsp; barn, liksom barnets make, registrerade partner eller samboare.</p><p></p><p>Med «<strong>känd medarbeare</strong>» avses en fysisk person som är känd för att</p><p></p><ul><li><p>(a) vara en verklig ägare till en juridisk enhet, förening eller utländsk &nbsp; lagligt arrangemang gemensamt med en politiskt utsatt person;</p></li><li><p>(b) har en nära affärsrelation med en politiskt utsatt person; eller</p></li><li><p>(c) vara den enda verkliga ägaren till en juridisk enhet, förening eller&nbsp; utländskt lagligt arrangemang som faktiskt är etablerat för att gynna&nbsp; politiskt utsatt person.</p></li></ul><p></p>"
            },
            "kyc_email_editor_subject": {
                "tt": false,
                "en_EN": "Declaration form {{customerName}}",
                "nb_NO": "Egenerklæringsskjema {{customerName}}",
                "sv_SE": "Kundkännedom {{customerName}}"
            },
            "kyc_email_editor_header": {
                "tt": false,
                "en_EN": "Hi {{firstName}} {{lastName}}",
                "nb_NO": "Hei {{firstName}} {{lastName}}",
                "sv_SE": "Hej {{firstName}} {{lastName}}"
            },
            "kyc_email_editor_message": {
                "tt": false,
                "en_EN": "As part of your cooporation with {{companyName}}, we ask that you fill out a declaration form.",
                "nb_NO": "I forbindelse med deres samarbeid med {{companyName}} ber vi deg om å svare på et egenerklæringsskjema.",
                "sv_SE": "I samband med ditt samarbete med {{companyName}} ber vi dig svara på ett kundkännedomsformulär."
            },
            "kyc_email_editor_hint": {
                "tt": false,
                "en_EN": "Press the button to open the form and start filling it out",
                "nb_NO": "Trykk på knappen for å åpne skjemaet og starte utfyllingen",
                "sv_SE": "Tryck på knappen för att öppna formuläret och börja fylla i det"
            },
            "kyc_email_editor_button": {
                "tt": false,
                "en_EN": "CONTINUE",
                "nb_NO": "GÅ VIDERE",
                "sv_SE": "GÅ VIDARE"
            },
            "kyc_email_editor_footer": {
                "tt": false,
                "en_EN": "If you have any questions, please contact {{senderName}} on {{senderEmail}}",
                "nb_NO": "Ved spørsmål, kontakt {{senderName}} på {{senderEmail}}",
                "sv_SE": "Om du har några frågor, vänligen kontakta {{senderName}} på {{senderEmail}}"
            },
            "kyc_email_editor_link": {
                "tt": false,
                "en_EN": "here",
                "nb_NO": "her",
                "sv_SE": "här"
            },
            "kyc_email_signer_subject": {
                "tt": false,
                "en_EN": "Declaration form {{customerName}} ready for {{action}}",
                "nb_NO": "Egenerklæringsskjema {{customerName}} klar for {{action}}",
                "sv_SE": "Kundkännedom {{customerName}} klar för {{action}}"
            },
            "kyc_email_signer_header": {
                "tt": false,
                "en_EN": "Hi {{firstName}} {{lastName}}",
                "nb_NO": "Hei {{firstName}} {{lastName}}",
                "sv_SE": "Hej {{firstName}} {{lastName}}"
            },
            "kyc_email_signer_message": {
                "tt": false,
                "en_EN": "You have been invited by {{companyName}} to {{actionVerb}} the following documents:",
                "nb_NO": "Du har blitt invitert av {{companyName}} til å {{actionVerb}} følgende dokumenter:",
                "sv_SE": "Du har blivit ibjuden av {{companyName}} till att {{actionVerb}} följande dokument:"
            },
            "kyc_email_signer_hint": {
                "tt": false,
                "en_EN": "Start the signing process by pressing the above button",
                "nb_NO": "Start signeringen ved å trykke på knappen over",
                "sv_SE": "Starta signeringsprocessen genom att trycka på knappen ovan"
            },
            "kyc_email_signer_button": {
                "tt": false,
                "en_EN": "CONTINUE",
                "nb_NO": "GÅ VIDERE",
                "sv_SE": "GÅ VIDARE"
            },
            "kyc_email_signer_footer": {
                "tt": false,
                "en_EN": "If you have any questions, please contact {{senderName}} on {{senderEmail}}",
                "nb_NO": "Ved spørsmål, kontakt {{senderName}} på {{senderEmail}}",
                "sv_SE": "Om du har några frågor, vänligen kontakta {{senderName}} på {{senderEmail}}"
            },
            "kyc_email_signer_link": {
                "tt": false,
                "en_EN": "here",
                "nb_NO": "her",
                "sv_SE": "här"
            },
            "kyc_email_done_subject": {
                "tt": false,
                "en_EN": "Signed declaration form {{customerName}}",
                "nb_NO": "Signert egenerklæringsskjema {{customerName}}",
                "sv_SE": "Signerat kundkännedom {{customerName}}"
            },
            "kyc_email_done_header": {
                "tt": false,
                "en_EN": "Hi {{firstName}} {{lastName}}",
                "nb_NO": "Hei {{firstName}} {{lastName}}",
                "sv_SE": "Hej {{firstName}} {{lastName}}"
            },
            "kyc_email_done_message": {
                "tt": false,
                "en_EN": "Here is your copy of the signed document",
                "nb_NO": "Her er din kopi av det signerte dokumentet",
                "sv_SE": "Här är din kopia av det signerade dokumentet"
            },
            "kyc_email_done_hint": {
                "tt": false,
                "en_EN": "Click on the document name to download it for archiving",
                "nb_NO": "Trykk på navnet for å laste det ned for arkivering",
                "sv_SE": "Klicka på dokumentets namn för att ladda ner det för arkivering"
            },
            "kyc_email_done_footer": {
                "tt": false,
                "en_EN": "If you have any questions, please contact {{senderName}} on {{senderEmail}}",
                "nb_NO": "Ved spørsmål, kontakt {{senderName}} på {{senderEmail}}",
                "sv_SE": "Om du har några frågor, vänligen kontakta {{senderName}} på {{senderEmail}}"
            },
            "kyc_landing_editor_head": {
                "tt": true,
                "en_EN": "Declaration form filled",
                "nb_NO": "Egenerklæringsskjema fylt ut",
                "sv_SE": "Kundkännedom är ifylld"
            },
            "kyc_landing_editor": {
                "tt": true,
                "en_EN": "<p></p><p>Thank you for filling out the declaration form.</p><p></p><p>The persons you selected will now receive an e-mail invitation to sign the decleration.</p><p></p><p></p>",
                "nb_NO": "<p></p><p>Takk for at du fylte ut egenerklæringsskjemaet. </p><p></p><p>De valgte personene vil nå få en e-post med invitasjon til å signere.</p><p></p><p></p>",
                "sv_SE": "<p></p><p>Tack för att du fyllt i formuläret för kundkännedom.</p><p></p><p>De valda personerna får nu ett e-postmeddelande med en inbjudan att underteckna.</p><p></p><p></p>"
            },
            "kyc_landing_signed_head": {
                "tt": true,
                "en_EN": "Declaration form signed",
                "nb_NO": "Egenerklæringsskjema signert",
                "sv_SE": "Kundkännedom signerad"
            },
            "kyc_landing_signed": {
                "tt": true,
                "en_EN": "<p></p><p>You have now signed the declaration form regarding your cooperation with us.</p><p></p><p>You will now receive an e-mail with a copy of the signed document.</p><p></p><p>Thank you for your cooperation.</p><p></p>",
                "nb_NO": "<p></p><p>Du har nå signert egenerklæringen i forbindelse med deres samarbeid med oss.</p><p></p><p>Du vil nå motta en e-post med en kopi av det signerte dokumentet.</p><p></p><p>Takk for ditt samarbeid.</p><p></p>",
                "sv_SE": "<p></p><p>Du har nu undertecknat kundkännedom angående ditt samarbete med oss.</p><p></p><p>Du kommer nu få ett e-postmeddelande med en kopia av det signerade dokumentet.</p><p></p><p>Tack för ditt samarbete.</p><p></p>"
            },
            "kyc_landing_aborted_head": {
                "tt": true,
                "en_EN": "Signing aborted",
                "nb_NO": "Signering avbrutt",
                "sv_SE": "Signering avbröts"
            },
            "kyc_landing_aborted": {
                "tt": true,
                "en_EN": "<p></p><p>You have aborted the signing process, please contact your contact person with us to discuss further option.</p><p></p><p></p>",
                "nb_NO": "<p></p><p>Du har avbrutt signeringsprosessen, ta gjerne kontakt med din kontaktperson for oppdraget slik at vi kan bli enige om veien videre.</p><p></p><p></p>",
                "sv_SE": "<p></p><p>Du har avbrutit signeringsprocessen, kontakta gärna din kontaktperson för uppdraget så att vi kan komma överens om vägen framåt.</p><p></p><p></p>"
            },
            "kyc_landing_footer": {
                "tt": true,
                "en_EN": "You can now close this tab or visit our ",
                "nb_NO": "Du kan nå lukke denne fanen eller gå til vår ",
                "sv_SE": "Du kan nu stänga den här fliken eller besöka vår "
            },
            "kyc_landing_link": {
                "tt": true,
                "en_EN": "home page",
                "nb_NO": "hjemmeside",
                "sv_SE": "hemsida"
            },
            "kyc_checkout_select": {
                "tt": true,
                "en_EN": "Select an option",
                "nb_NO": "Velg et alternativ",
                "sv_SE": "Välj ett alternativ"
            },
            "kyc_checkout_back": {
                "tt": true,
                "en_EN": "Select a different option",
                "nb_NO": "Velg et annet alternativ",
                "sv_SE": "Välj ett annat alternativ"
            },
            "kyc_checkout_direct": {
                "tt": true,
                "en_EN": "I have authorization to sign the self-declaration and want to do it now",
                "nb_NO": "Jeg har fullmakt til å signere alene og ønsker å gjøre det nå",
                "sv_SE": "Jag har befogenhet att underteckna ensam och vill göra det nu"
            },
            "kyc_checkout_recipients": {
                "tt": true,
                "en_EN": "I want to select one or more persons that will receive an invitation to sign by email",
                "nb_NO": "Jeg vil legge til en eller flere personer som vil motta invitasjon til å signere på epost",
                "sv_SE": "Jag vill välja en eller flera personer som får en inbjudan att skriva under via e-post"
            },
            "kyc_checkout_method": {
                "tt": true,
                "en_EN": "Select signing method",
                "nb_NO": "Velg signeringsmetode",
                "sv_SE": "Välj signeringsmetod"
            },
            "kyc_checkout_start": {
                "tt": true,
                "en_EN": "Start signing process",
                "nb_NO": "Start signering",
                "sv_SE": "Starta signering"
            },
            "kyc_checkout_order": {
                "tt": true,
                "en_EN": "Signing order",
                "nb_NO": "Signeringsrekkefølge",
                "sv_SE": "Signeringsordning"
            },
            "kyc_checkout_add": {
                "tt": true,
                "en_EN": "Add recipient",
                "nb_NO": "Legg til mottaker",
                "sv_SE": "Lägg till mottagare"
            },
            "kyc_checkout_first": {
                "tt": true,
                "en_EN": "Enter details for the first signatory",
                "nb_NO": "Fyll inn detaljer for den første personen",
                "sv_SE": "Ange information för den första undertecknaren"
            },
            "kyc_checkout_list": {
                "tt": true,
                "en_EN": "Select from list",
                "nb_NO": "Velg fra listen",
                "sv_SE": "Välj från listan"
            },
            "kyc_checkout_send": {
                "tt": true,
                "en_EN": "Send to recipients",
                "nb_NO": "Send til signering",
                "sv_SE": "Skicka till mottagare"
            },
            "kyc_checkout_with": {
                "tt": true,
                "en_EN": "Sign with",
                "nb_NO": "Signere med",
                "sv_SE": "Signera med"
            },
            "kyc_pdf_sent": {
                "tt": true,
                "en_EN": "Form sent by",
                "nb_NO": "Skjema sendt av",
                "sv_SE": "Formulär skickat av"
            },
            "kyc_pdf_filled": {
                "tt": true,
                "en_EN": "Form received and filled out by",
                "nb_NO": "Skjema mottatt og fylt ut av",
                "sv_SE": "Formulär mottagen och fyllt i av"
            },
            "kyc_pdf_signatories": {
                "tt": true,
                "en_EN": "The recipient has chosen the following persons to sign the self-declaration on behalf of the firm",
                "nb_NO": "Mottaker har angitt følgende personer som må signere egenerklæringen på vegne av foretaket",
                "sv_SE": "Mottagaren har valt följande personer för att underteckna kundkännedomen åt företagets vägnar"
            },
            "kyc_pdf_empty_roles": {
                "tt": true,
                "en_EN": "No key roles declared in the self-declaration form",
                "nb_NO": "Ingen nøkkelpersoner rapportert i egenerklæringsskjema",
                "sv_SE": "Inga nyckelroller rapporterade i kundkännedomsformuläret"
            },
            "kyc_pdf_empty_rrh": {
                "tt": true,
                "en_EN": "No beneficial owners declared in the self-declaration form",
                "nb_NO": "Ingen reelle rettighetshavere rapportert i egenerklæringsskjema",
                "sv_SE": "Inga verkliga huvudmän rapporterade i kundkännedomsformuläret"
            },
            "kyc_pdf_empty_enitity": {
                "tt": true,
                "en_EN": "No owner structure declared in the self-declaration form",
                "nb_NO": "Ingen eierstruktur rapportert i egenerklæringsskjema",
                "sv_SE": "Ingen ägarstruktur rapporteras i kundkännedomsformuläret"
            },
            "kyc_pdf_empty_pep": {
                "tt": true,
                "en_EN": "No politically exposed persons declared in the self-declaration form",
                "nb_NO": "Ingen politisk eksponerte personer rapportert i egenerklæringsskjema",
                "sv_SE": "Inga politiskt utsatta personer rapporterades i kundkännedomsformuläret"
            },
            "kyc_signer_message": {
                "tt": true,
                "en_EN": "<h2>Self-declaration ready for signing</h2><p>Hi <strong>{{recipientName}}</strong>,</p><p></p><p><strong>{{editorName}}</strong> has filled out the self-declaration form for <strong>{{customerName}}</strong> and selected you as a signatory.</p><p></p><p>Select the signing method you would like to use:</p><p></p><p>(<em>You will be able to see the self-declaration before you decide to sign</em>)</p>",
                "nb_NO": "<h2>Egenerklæring klar for signering</h2><p>Hei <strong>{{recipientName}}</strong>,</p><p></p><p><strong>{{editorName}}</strong> har fylt ut egenerklæringsskjemaet for <strong>{{customerName}}</strong> og angitt deg som signatar.</p><p></p><p>Velg hvilken signeringsmetode du ønsker å bruke:</p><p></p><p>(<em>Du vil få se egenerklæringen før du velger om du vil signere</em>)</p>",
                "sv_SE": "<h2>Kundkännedom redo för signering</h2><p>Hej <strong>{{recipientName}}</strong>,</p><p></p><p><strong>{{editorName}}</strong> har fyllt i kundkännedom för <strong>{{customerName}}</strong> och angav dig som en signerande part</p><p></p><p>Välj vilken signeringsmetod du vill använda:</p><p></p><p>(<em>Du kommer kunna se kundkännedomen innan du väljer om du vill signera den</em>)</p>"
            },
            "kyc_signer_go": {
                "tt": true,
                "en_EN": "Show self-declaration",
                "nb_NO": "Vis egenerklæringen",
                "sv_SE": "Visa kundkännedom"
            }
        };
        return translations;
    },

    getDefaultIdcTranslations() {
        const translations = {
            "idc_welcome": {
                show: true,
                tt: true,
                en_EN: "<h2>Welcome to our ID-control</h2><p>You have been asked to perform an ID-control as part of your customer relations with us. This should take less than a minute, all you need to do is:</p><p></p><ul><li><p><strong>Click on 'START BANKID'</strong></p></li><li><p><strong>Log in with your personal BankID</strong></p></li><li><p><strong>Done! We thank you for your cooperation</strong></p></li></ul>",
                nb_NO: "<h2>Velkommen til vår ID-kontroll</h2><p>Du er blitt bedt om å gjennomføre en ID-kontroll i forbindelse med ditt samarbeid med oss. Dette tar under ett minutt, alt du trenger å gjøre er:</p><p></p><ul><li><p><strong>Trykk på 'START BANKID'</strong></p></li><li><p><strong>Logg inn med din personlige BankID</strong></p></li><li><p><strong>Ferdig! Vi takker for ditt samarbeid</strong></p></li></ul>"
            },
            "idc_welcome_select": {
                show: true,
                tt: true,
                en_EN: "<h2>Welcome to our ID-control</h2><p>You have been asked to confirm your identity as part of your cooperation with us.</p><p></p><p>Please select wich method you would like to use to confirm your identity:</p><p></p><p></p>",
                nb_NO: "<h2>Velkommen til vår ID-kontroll</h2><p>Du er blitt bedt om å gjennomføre en ID-kontroll i forbindelse med ditt samarbeid med oss.</p><p></p><p>Vennligst velg hvordan du vil bekrefte din ID:</p><p></p>"
            },
            "idc_thank_you": {
                show: true,
                tt: true,
                en_EN: "<h2>Thank you for your cooperation</h2><p>You do not have to perform any further actions at this time.</p><p></p><p></p>",
                nb_NO: "<h2>Takk for ditt samarbeid</h2><p>Du trenger ikke gjøre noe mer.</p><p></p><p></p>"
            },
            "idc_email_subject": {
                tt: false,
                en_EN: "ID-control",
                nb_NO: "ID-kontroll"
            },
            "idc_email_header": {
                tt: false,
                en_EN: "Hi {{firstName}} {{lastName}}",
                nb_NO: "Hei {{firstName}} {{lastName}}"
            },
            "idc_email_message": {
                tt: false,
                en_EN: "As part of your cooperation with {{companyName}}, we ask that you complete an ID-control. You will use personal BankID and it takes less than a minute.",
                nb_NO: "I forbindelse med deres samarbeid med {{companyName}} ber vi deg om utføre en ID-kontroll. Du bruker din personlige BankID og det tar bare ett minutt."
            },
            "idc_email_hint": {
                tt: false,
                en_EN: "Press the button to start the ID-control",
                nb_NO: "Trykk på knappen for å starte ID-kontrollen"
            },
            "idc_email_button": {
                tt: false,
                en_EN: "CONTINUE",
                nb_NO: "GÅ VIDERE"
            },
            "idc_email_footer": {
                tt: false,
                en_EN: "If you have any questions, please contact {{senderName}} on {{senderEmail}}",
                nb_NO: "Ved spørsmål, kontakt {{senderName}} på {{senderEmail}}"
            },
            "idc_email_link": {
                tt: false,
                en_EN: "here",
                nb_NO: "her"
            },
            "idc_landing_footer": {
                tt: true,
                en_EN: "You can now close this tab or visit our ",
                nb_NO: "Du kan nå lukke denne fanen eller gå til vår "
            },
            "idc_landing_link": {
                tt: true,
                en_EN: "home page",
                nb_NO: "hjemmeside"
            },
            "idc_met_select": {
                tt: true,
                en_EN: "Select authentication method",
                nb_NO: "Velg identifiserings-metode"
            },
            "idc_met_back": {
                tt: true,
                en_EN: "Select a different method",
                nb_NO: "Velg en annen metode"
            },
            "idc_met_bankidno_header": {
                tt: true,
                en_EN: "BankID Norway",
                nb_NO: "BankID Norge"
            },
            "idc_met_bankidno_hint": {
                tt: true,
                en_EN: "Authentication with BankID-chip or BankID on Mobile.",
                nb_NO: "Identifisering med brikke eller BankID på Mobil."
            },
            "idc_met_fileupload_header": {
                tt: true,
                en_EN: "Upload copy of passport",
                nb_NO: "Last opp kopi av pass"
            },
            "idc_met_fileupload_hint": {
                tt: true,
                en_EN: "Upload a copy of your passport together with a recent utility bill.",
                nb_NO: "Last opp en kopi av passet ditt sammen med en kopi av en nylig regning fra strømselskap/kommunale avgifter."
            },
            "idc_met_fileupload_hint_po": {
                tt: true,
                en_EN: "Upload a copy of your passport.",
                nb_NO: "Last opp en kopi av passet ditt."
            },
            "idc_fileupload_header": {
                tt: true,
                en_EN: "Please upload the following files:",
                nb_NO: "Last opp følgende filer:"
            },
            "idc_fileupload_header_po": {
                tt: true,
                en_EN: "Please upload your passport",
                nb_NO: "Last opp pass"
            },
            "idc_fileupload_passport": {
                tt: true,
                en_EN: "Passport",
                nb_NO: "Kopi av pass"
            },
            "idc_fileupload_utility_bill": {
                tt: true,
                en_EN: "Utility bill",
                nb_NO: "Strømregning/kommunale avgifter"
            },
            "idc_fileupload_send": {
                tt: true,
                en_EN: "Send in",
                nb_NO: "Send inn"
            },
            "idc_continue": {
                tt: true,
                en_EN: "Continue",
                nb_NO: "Fortsett"
            },
            "idc_questions": {
                tt: false,
                en_EN: "Purpose/Questions",
                nb_NO: "Formål/Spørsmål"
            },
            "idc_sms_invite": {
                tt: false,
                en_EN: "In complience with AML laws we need to confirm your identity. Click the link to open the ID-control. Kind regards {{companyName}}",
                nb_NO: "I henhold til lov om hvitvasking trenger vi å bekrefte din ID i forbindelse med vårt samarbeid. Trykk på linken for å åpne ID-kontrollen. Mvh {{companyName}}"
            },
            "idc_already_completed": {
                "en_EN": "<h3>The ID-control is already completed</h3><p>Thank you for your cooperation</p>",
                "nb_NO": "<h3>ID-kontrollen er allerede fullført</h3><p>Takk for ditt samarbeid</p>"
            }
        }
        return translations;
    },

    mergeTranslations(root, defaults, custom) {
        for (const key in custom) {
            if (defaults[key]) {
                for (const sub in custom[key]) {
                    defaults[key][sub] = custom[key][sub];
                }
            }else {
                defaults[key] = custom[key];
            }
        }
    }

};
export default locale;